// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.2 | MIT License | https://tailwindcss.com */
@layer properties;
:root, [data-theme='light'] {
  --gaxl-blue-50: #eef4ff;
  --gaxl-blue-100: #d9e5ff;
  --gaxl-blue-200: #bcd1ff;
  --gaxl-blue-300: #8eb3fd;
  --gaxl-blue-400: #5c8cf9;
  --gaxl-blue-450: #3b82f6;
  --gaxl-blue-500: #3b6bf0;
  --gaxl-blue-600: #2563eb;
  --gaxl-blue-700: #1d4fcb;
  --gaxl-blue-800: #1e42a3;
  --gaxl-blue-900: #1c3a80;
  --gaxl-blue-950: #132652;
  --gaxl-violet-25: #fafaff;
  --gaxl-violet-50: #f5f3ff;
  --gaxl-violet-100: #ebe6fe;
  --gaxl-violet-150: #e0dcea;
  --gaxl-violet-200: #dacffe;
  --gaxl-violet-300: #c0abfc;
  --gaxl-violet-400: #a37cf8;
  --gaxl-violet-500: #8b54f2;
  --gaxl-violet-550: #6d4ad9;
  --gaxl-violet-600: #7c3aed;
  --gaxl-violet-700: #6a28d4;
  --gaxl-violet-800: #5821ac;
  --gaxl-violet-900: #491d8a;
  --gaxl-neutral-0: #ffffff;
  --gaxl-neutral-50: #f8fafc;
  --gaxl-neutral-100: #f1f5f9;
  --gaxl-neutral-200: #e5eaf1;
  --gaxl-neutral-300: #cfd8e3;
  --gaxl-neutral-400: #98a4b6;
  --gaxl-neutral-500: #6a7689;
  --gaxl-neutral-600: #4b576b;
  --gaxl-neutral-700: #354056;
  --gaxl-neutral-800: #1f2940;
  --gaxl-neutral-900: #131a2b;
  --gaxl-neutral-925: #0e1626;
  --gaxl-neutral-950: #0a0f1c;
  --gaxl-success-50: #ecfdf3;
  --gaxl-success-100: #d1fadf;
  --gaxl-success-200: #a7f3cb;
  --gaxl-success-500: #16b364;
  --gaxl-success-600: #099250;
  --gaxl-success-700: #087443;
  --gaxl-warning-50: #fffaeb;
  --gaxl-warning-100: #fef0c7;
  --gaxl-warning-200: #fedf89;
  --gaxl-warning-500: #f59e0b;
  --gaxl-warning-600: #dc8211;
  --gaxl-warning-700: #b45309;
  --gaxl-error-50: #fef3f2;
  --gaxl-error-100: #fee4e2;
  --gaxl-error-200: #fecdca;
  --gaxl-error-500: #f04438;
  --gaxl-error-600: #d92d20;
  --gaxl-error-700: #b42318;
  --gaxl-info-50: #eff8ff;
  --gaxl-info-100: #d7edff;
  --gaxl-info-200: #b2ddff;
  --gaxl-info-500: #2e90fa;
  --gaxl-info-600: #1570ef;
  --gaxl-info-700: #175cd3;
  --gaxl-indigo-500: #6366f1;
  --gaxl-indigo-600: #4f46e5;
  --gaxl-sky-50: #f0f9ff;
  --gaxl-sky-200: #bae6fd;
  --gaxl-sky-600: #0284c7;
  --gaxl-sky-700: #0369a1;
  --gaxl-teal-500: #0e9bbb;
  --gaxl-teal-700: #0e7490;
  --gaxl-zinc-300: #d4d4d8;
  --gaxl-zinc-600: #52525b;
  --gaxl-slate-150: #e6e6ee;
  --gaxl-slate-400: #94a3b8;
  --gaxl-slate-925: #1e1e2e;
  --gaxl-amber-600: #d97706;
  --gaxl-green-100: #dcfce7;
  --gaxl-green-650: #1f8a5b;
  --gaxl-red-650: #c0392b;
  --gaxl-gray-150: #eeeeee;
  --gaxl-cyan-600: #0891b2;
  --gaxl-teal-mid: #0e9488;
  --gaxl-slate-ink: #0f172a;
  --gaxl-gray-near-black: #111111;
  --gaxl-blue-alt: #2a6fdb;
  --gaxl-apple-green: #34c759;
  --gaxl-sky-bright: #38bdf8;
  --gaxl-slate-deep: #475569;
  --gaxl-slate-mid: #64748b;
  --gaxl-gray-mid: #666666;
  --gaxl-violet-mid: #7a5ae0;
  --gaxl-indigo-light: #818cf8;
  --gaxl-purple-deep: #9333ea;
  --gaxl-gray-hex-muted: #999999;
  --gaxl-violet-light: #a78bfa;
  --gaxl-mint-light: #a7f3d0;
  --gaxl-chrome-muted: #b8b8c8;
  --gaxl-red-deep: #b91c1c;
  --gaxl-violet-pale: #c4b5fd;
  --gaxl-border-muted: #c4c4cc;
  --gaxl-indigo-pale: #c7d2fe;
  --gaxl-amber-dark: #ca8a04;
  --gaxl-coral: #d97757;
  --gaxl-pink-deep: #db2777;
  --gaxl-sky-pale: #e0f2fe;
  --gaxl-orange-deep: #ea580c;
  --gaxl-orange-accent: #ea7317;
  --gaxl-surface-subtle: #ececf2;
  --gaxl-green-pale: #ecfdf5;
  --gaxl-blue-pale: #eef4ff;
  --gaxl-slate-pale: #f1f5f9;
  --gaxl-violet-pale-bg: #f3f0ff;
  --gaxl-surface-alt: #f4f4f8;
  --gaxl-warm-surface: #f6f4ef;
  --gaxl-surface-neutral: #f6f6f7;
  --gaxl-blue-tint: #f6f9ff;
  --gaxl-edb-accent: #497bf7;
  --gaxl-edb-accent-muted: #edf2ff;
  --gaxl-surface-lifted: #f8f8fa;
  --gaxl-violet-tint: #faf7ff;
  --gaxl-blue-tint-light: #faf9ff;
  --gaxl-surface-faint: #fafafb;
  --gaxl-surface-muted: #fafafa;
  --gaxl-surface-cool: #fbfbfe;
  --gaxl-surface-cooler: #fcfcfe;
  --gaxl-amber-pale: #fef3c7;
  --gaxl-splitter-idle: #f0f0f0;
  --gaxl-splitter-grip: #cccccc;
  --gaxl-disabled-surface: #f4f4f5;
  --gaxl-danger-border-hover: #fca5a5;
  --gaxl-placeholder-stripe-a: #f7f7f8;
  --gaxl-placeholder-stripe-b: #f0f0f2;
  --gaxl-result-teal: #0d9488;
  --gaxl-result-teal-light: #0e9bbb;
  --gaxl-tweaks-text: #29261b;
  --gaxl-brand-primary: var(--gaxl-blue-600);
  --gaxl-brand-primary-hover: var(--gaxl-blue-700);
  --gaxl-brand-primary-active: var(--gaxl-blue-800);
  --gaxl-brand-primary-soft: var(--gaxl-blue-50);
  --gaxl-brand-primary-subtle: var(--gaxl-blue-100);
  --gaxl-brand-on-primary: var(--gaxl-neutral-0);
  --gaxl-brand-secondary: var(--gaxl-violet-600);
  --gaxl-brand-accent: var(--gaxl-violet-600);
  --gaxl-canvas: var(--gaxl-neutral-50);
  --gaxl-surface: var(--gaxl-neutral-0);
  --gaxl-surface-secondary: var(--gaxl-neutral-100);
  --gaxl-surface-card: var(--gaxl-neutral-0);
  --gaxl-surface-elevated: var(--gaxl-neutral-0);
  --gaxl-surface-header: var(--gaxl-neutral-0);
  --gaxl-surface-modal: var(--gaxl-neutral-0);
  --gaxl-surface-sidebar: var(--gaxl-neutral-900);
  --gaxl-surface-hover: var(--gaxl-neutral-100);
  --gaxl-surface-selected: var(--gaxl-blue-50);
  --gaxl-scrim: rgba(10, 15, 28, 0.48);
  --gaxl-text-primary: var(--gaxl-neutral-900);
  --gaxl-text-secondary: var(--gaxl-neutral-600);
  --gaxl-text-tertiary: var(--gaxl-neutral-500);
  --gaxl-text-disabled: var(--gaxl-neutral-400);
  --gaxl-text-muted: #a1a1aa;
  --gaxl-text-inverse: var(--gaxl-neutral-0);
  --gaxl-text-link: var(--gaxl-blue-600);
  --gaxl-border-default: var(--gaxl-neutral-200);
  --gaxl-border-strong: var(--gaxl-neutral-300);
  --gaxl-border-focus: var(--gaxl-blue-600);
  --gaxl-border-hover: var(--gaxl-neutral-300);
  --gaxl-focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.32);
  --gaxl-success: var(--gaxl-success-600);
  --gaxl-warning: var(--gaxl-warning-600);
  --gaxl-error: var(--gaxl-error-600);
  --gaxl-info: var(--gaxl-info-600);
  --gaxl-confidence-high: var(--gaxl-success-600);
  --gaxl-confidence-med: var(--gaxl-warning-600);
  --gaxl-confidence-low: var(--gaxl-error-600);
  --gaxl-viz-1: var(--gaxl-blue-600);
  --gaxl-viz-2: var(--gaxl-violet-600);
  --gaxl-viz-3: var(--gaxl-info-500);
  --gaxl-viz-4: var(--gaxl-warning-500);
  --gaxl-viz-5: var(--gaxl-success-500);
  --gaxl-viz-6: var(--gaxl-neutral-500);
  --gaxl-success-soft: var(--gaxl-success-50);
  --gaxl-success-border: var(--gaxl-success-200);
  --gaxl-success-text: var(--gaxl-success-700);
  --gaxl-warning-soft: var(--gaxl-warning-50);
  --gaxl-warning-border: var(--gaxl-warning-200);
  --gaxl-warning-text: var(--gaxl-warning-700);
  --gaxl-error-soft: var(--gaxl-error-50);
  --gaxl-error-border: var(--gaxl-error-200);
  --gaxl-error-text: var(--gaxl-error-700);
  --gaxl-info-soft: var(--gaxl-info-50);
  --gaxl-info-border: var(--gaxl-info-200);
  --gaxl-info-text: var(--gaxl-info-700);
  --gaxl-visit-supervisory: var(--gaxl-indigo-500);
  --gaxl-visit-start-of-care: var(--gaxl-success-500);
  --gaxl-visit-routine: var(--gaxl-blue-450);
  --gaxl-visit-pt-ot: var(--gaxl-warning-500);
  --gaxl-esa-panel: var(--gaxl-violet-25);
  --gaxl-esa-accent: var(--gaxl-indigo-500);
  --gaxl-esa-accent-muted: var(--gaxl-violet-100);
  --gaxl-esa-hover: var(--gaxl-indigo-600);
  --gaxl-esa-gradient-from: var(--gaxl-blue-600);
  --gaxl-esa-gradient-to: var(--gaxl-violet-600);
  --gaxl-esa-suggestion-gradient: linear-gradient(
    to right,
    var(--gaxl-esa-gradient-from),
    var(--gaxl-esa-gradient-to)
  );
  --gaxl-catalog-master: var(--gaxl-violet-550);
  --gaxl-catalog-channel: var(--gaxl-teal-700);
  --gaxl-catalog-channel-dot: var(--gaxl-teal-500);
  --gaxl-catalog-supplier: var(--gaxl-warning-700);
  --gaxl-catalog-supplier-dot: var(--gaxl-amber-600);
  --gaxl-chip-scope-fg: var(--gaxl-sky-700);
  --gaxl-chip-scope-bg: var(--gaxl-sky-50);
  --gaxl-chip-scope-border: var(--gaxl-sky-200);
  --gaxl-chip-objective-fg: var(--gaxl-violet-600);
  --gaxl-chip-objective-bg: var(--gaxl-violet-50);
  --gaxl-chip-objective-border: var(--gaxl-violet-200);
  --gaxl-dq-high: var(--gaxl-green-650);
  --gaxl-dq-mid: var(--gaxl-warning-700);
  --gaxl-dq-low: var(--gaxl-red-650);
  --gaxl-run-running: var(--gaxl-blue-600);
  --gaxl-run-queued: var(--gaxl-slate-400);
  --gaxl-explorer-new: var(--gaxl-sky-600);
  --gaxl-shell-bar: var(--gaxl-slate-925);
  --gaxl-shell-bar-top: var(--gaxl-slate-150);
  --gaxl-shell-bar-avatar: var(--gaxl-zinc-600);
  --gaxl-shell-bar-avatar-text: var(--gaxl-zinc-300);
  --gaxl-overlay: rgba(0, 0, 0, 0.4);
  --gaxl-overlay-strong: rgba(0, 0, 0, 0.18);
  --gaxl-glass-background: rgba(250, 249, 247, 0.82);
  --gaxl-glass-border: rgba(255, 255, 255, 0.6);
  --gaxl-progress-track-legacy: var(--gaxl-gray-150);
  --gaxl-progress-before: var(--gaxl-violet-150);
  --gaxl-success-strong: var(--gaxl-success-500);
  --gaxl-success-strong-hover: var(--gaxl-success-700);
  --gaxl-success-tint: var(--gaxl-green-100);
  --gaxl-font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, system-ui, sans-serif;
  --gaxl-font-mono: 'JetBrains Mono', 'SFMono-Regular', ui-monospace, 'Cascadia Code', Menlo, monospace;
  --gaxl-weight-regular: 400;
  --gaxl-weight-medium: 500;
  --gaxl-weight-semibold: 600;
  --gaxl-weight-bold: 700;
  --gaxl-size-display-xl: 3.5rem;
  --gaxl-size-display-l: 2.75rem;
  --gaxl-size-heading-xl: 2rem;
  --gaxl-size-heading-l: 1.625rem;
  --gaxl-size-heading-m: 1.375rem;
  --gaxl-size-heading-s: 1.125rem;
  --gaxl-size-title: 1rem;
  --gaxl-size-subtitle: 0.9375rem;
  --gaxl-size-body-lg: 1rem;
  --gaxl-size-body-md: 0.875rem;
  --gaxl-size-body-sm: 0.8125rem;
  --gaxl-size-label: 0.8125rem;
  --gaxl-size-caption: 0.75rem;
  --gaxl-size-compact: 0.71875rem;
  --gaxl-size-overline: 0.6875rem;
  --gaxl-size-code: 0.8125rem;
  --gaxl-leading-tight: 1.15;
  --gaxl-leading-snug: 1.3;
  --gaxl-leading-normal: 1.45;
  --gaxl-leading-relaxed: 1.6;
  --gaxl-tracking-tighter: -0.02em;
  --gaxl-tracking-tight: -0.011em;
  --gaxl-tracking-normal: 0;
  --gaxl-tracking-wide: 0.04em;
  --gaxl-tracking-overline: 0.08em;
  --gaxl-text-display-xl: 700 3.5rem/1.15 var(--gaxl-font-sans);
  --gaxl-text-display-l: 700 2.75rem/1.15 var(--gaxl-font-sans);
  --gaxl-text-heading-xl: 600 2rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-heading-l: 600 1.625rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-heading-m: 600 1.375rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-heading-s: 600 1.125rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-title: 600 1rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-body: 400 0.875rem/1.45 var(--gaxl-font-sans);
  --gaxl-text-label: 500 0.8125rem/1.3 var(--gaxl-font-sans);
  --gaxl-text-caption: 400 0.75rem/1.3 var(--gaxl-font-sans);
  --gaxl-space-1: 2px;
  --gaxl-space-2: 4px;
  --gaxl-space-3: 8px;
  --gaxl-space-4: 12px;
  --gaxl-space-5: 16px;
  --gaxl-space-6: 20px;
  --gaxl-space-7: 24px;
  --gaxl-space-8: 32px;
  --gaxl-space-9: 40px;
  --gaxl-space-10: 48px;
  --gaxl-space-11: 64px;
  --gaxl-space-12: 80px;
  --gaxl-space-13: 96px;
  --gaxl-radius-2: 2px;
  --gaxl-radius-4: 4px;
  --gaxl-radius-6: 6px;
  --gaxl-radius-8: 8px;
  --gaxl-radius-12: 12px;
  --gaxl-radius-16: 16px;
  --gaxl-radius-20: 20px;
  --gaxl-radius-full: 9999px;
  --gaxl-shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.05);
  --gaxl-shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  --gaxl-shadow-md: 0 4px 8px -2px rgba(15, 23, 42, 0.1), 0 2px 4px -2px rgba(15, 23, 42, 0.06);
  --gaxl-shadow-lg: 0 12px 20px -4px rgba(15, 23, 42, 0.12), 0 4px 8px -4px rgba(15, 23, 42, 0.06);
  --gaxl-shadow-xl: 0 24px 40px -8px rgba(15, 23, 42, 0.18), 0 8px 16px -8px rgba(15, 23, 42, 0.08);
  --gaxl-shadow-overlay: 0 32px 64px -12px rgba(10, 15, 28, 0.28);
  --gaxl-elevation-0: none;
  --gaxl-elevation-1: var(--gaxl-shadow-xs);
  --gaxl-elevation-2: var(--gaxl-shadow-sm);
  --gaxl-elevation-3: var(--gaxl-shadow-md);
  --gaxl-elevation-4: var(--gaxl-shadow-lg);
  --gaxl-duration-instant: 80ms;
  --gaxl-duration-fast: 120ms;
  --gaxl-duration-base: 180ms;
  --gaxl-duration-slow: 240ms;
  --gaxl-duration-slower: 360ms;
  --gaxl-ease-standard: cubic-bezier(0.2, 0, 0, 1);
  --gaxl-ease-emphasized: cubic-bezier(0.2, 0, 0, 1.05);
  --gaxl-ease-accelerate: cubic-bezier(0.3, 0, 1, 1);
  --gaxl-ease-decelerate: cubic-bezier(0, 0, 0, 1);
  --gaxl-transition-colors: color var(--gaxl-duration-fast) var(--gaxl-ease-standard),
    background-color var(--gaxl-duration-fast) var(--gaxl-ease-standard),
    border-color var(--gaxl-duration-fast) var(--gaxl-ease-standard);
  --gaxl-transition-transform: transform var(--gaxl-duration-fast) var(--gaxl-ease-standard);
  --gaxl-opacity-0: 0;
  --gaxl-opacity-10: 0.1;
  --gaxl-opacity-20: 0.2;
  --gaxl-opacity-40: 0.4;
  --gaxl-opacity-60: 0.6;
  --gaxl-opacity-80: 0.8;
  --gaxl-opacity-100: 1;
  --gaxl-opacity-disabled: 0.4;
  --gaxl-container-max: 1440px;
  --gaxl-sidebar-width: 248px;
  --gaxl-sidebar-collapsed: 64px;
  --gaxl-header-height: 56px;
  --gaxl-page-margin: 1.5rem;
  --gaxl-gutter: 1rem;
  --gaxl-row-height-compact: 36px;
  --gaxl-row-height-medium: 44px;
  --gaxl-row-height-large: 56px;
  --gaxl-btn-radius: var(--gaxl-radius-6);
  --gaxl-btn-font-weight: var(--gaxl-weight-semibold);
  --gaxl-btn-gap: var(--gaxl-space-3);
  --gaxl-btn-height-xs: 26px;
  --gaxl-btn-height-sm: 30px;
  --gaxl-btn-height-md: 36px;
  --gaxl-btn-height-lg: 42px;
  --gaxl-btn-height-xl: 48px;
  --gaxl-btn-padding-xs: var(--gaxl-space-3);
  --gaxl-btn-padding-sm: 11px;
  --gaxl-btn-padding-md: var(--gaxl-space-4);
  --gaxl-btn-padding-lg: 18px;
  --gaxl-btn-padding-xl: 22px;
  --gaxl-btn-font-size-sm: var(--gaxl-size-body-sm);
  --gaxl-btn-font-size-md: var(--gaxl-size-body-md);
  --gaxl-btn-font-size-lg: var(--gaxl-size-body-lg);
  --gaxl-btn-primary-bg: var(--gaxl-brand-primary);
  --gaxl-btn-primary-bg-hover: var(--gaxl-brand-primary-hover);
  --gaxl-btn-primary-bg-active: var(--gaxl-brand-primary-active);
  --gaxl-btn-primary-fg: var(--gaxl-brand-on-primary);
  --gaxl-btn-secondary-bg: var(--gaxl-surface);
  --gaxl-btn-secondary-bg-hover: var(--gaxl-surface-hover);
  --gaxl-btn-secondary-bg-active: var(--gaxl-surface-secondary);
  --gaxl-btn-secondary-fg: var(--gaxl-text-primary);
  --gaxl-btn-secondary-border: var(--gaxl-border-strong);
  --gaxl-btn-ghost-fg: var(--gaxl-text-secondary);
  --gaxl-btn-ghost-bg-hover: var(--gaxl-surface-hover);
  --gaxl-btn-danger-bg: var(--gaxl-error);
  --gaxl-btn-danger-bg-hover: var(--gaxl-error-700);
  --gaxl-btn-focus-ring: var(--gaxl-focus-ring);
  --gaxl-icon-btn-size-sm: 30px;
  --gaxl-icon-btn-size-md: 36px;
  --gaxl-icon-btn-size-lg: 42px;
  --gaxl-icon-btn-radius: var(--gaxl-radius-6);
  --gaxl-field-height-sm: 30px;
  --gaxl-field-height-md: 36px;
  --gaxl-field-height-lg: 42px;
  --gaxl-field-padding-x: var(--gaxl-space-4);
  --gaxl-field-radius: var(--gaxl-radius-6);
  --gaxl-field-bg: var(--gaxl-surface);
  --gaxl-field-border: var(--gaxl-border-default);
  --gaxl-field-border-hover: var(--gaxl-border-hover);
  --gaxl-field-border-focus: var(--gaxl-border-focus);
  --gaxl-field-fg: var(--gaxl-text-primary);
  --gaxl-field-placeholder: var(--gaxl-text-tertiary);
  --gaxl-field-disabled-bg: var(--gaxl-surface-secondary);
  --gaxl-field-error-border: var(--gaxl-error);
  --gaxl-field-success-border: var(--gaxl-success);
  --gaxl-field-label-color: var(--gaxl-text-primary);
  --gaxl-field-hint-color: var(--gaxl-text-tertiary);
  --gaxl-field-focus-ring: var(--gaxl-focus-ring);
  --gaxl-control-size: 18px;
  --gaxl-control-radius: var(--gaxl-radius-4);
  --gaxl-control-border: var(--gaxl-border-strong);
  --gaxl-control-checked-bg: var(--gaxl-brand-primary);
  --gaxl-control-checked-fg: var(--gaxl-neutral-0);
  --gaxl-switch-width: 36px;
  --gaxl-switch-height: 20px;
  --gaxl-switch-track-off: var(--gaxl-neutral-300);
  --gaxl-switch-track-on: var(--gaxl-brand-primary);
  --gaxl-card-bg: var(--gaxl-surface-card);
  --gaxl-card-border: var(--gaxl-border-default);
  --gaxl-card-radius: var(--gaxl-radius-8);
  --gaxl-card-padding: 18px;
  --gaxl-card-padding-compact: var(--gaxl-space-4);
  --gaxl-card-padding-dense: 10px;
  --gaxl-card-shadow: var(--gaxl-shadow-xs);
  --gaxl-card-shadow-hover: var(--gaxl-shadow-md);
  --gaxl-card-selected-ring: var(--gaxl-brand-primary);
  --gaxl-kpi-bg: var(--gaxl-surface-card);
  --gaxl-kpi-radius: var(--gaxl-radius-8);
  --gaxl-kpi-padding: 16px 18px;
  --gaxl-kpi-value-size: var(--gaxl-size-heading-xl);
  --gaxl-badge-radius: var(--gaxl-radius-full);
  --gaxl-badge-radius-square: var(--gaxl-radius-4);
  --gaxl-badge-font-weight: var(--gaxl-weight-medium);
  --gaxl-badge-padding-y: 3px;
  --gaxl-badge-padding-x: var(--gaxl-space-3);
  --gaxl-badge-font-size: var(--gaxl-size-caption);
  --gaxl-badge-dot-size: 6px;
  --gaxl-btn-font-size-xs: var(--gaxl-size-caption);
  --gaxl-secondary-soft: rgba(124, 58, 237, 0.08);
  --gaxl-secondary-text: var(--gaxl-violet-700);
  --gaxl-badge-height-sm: 20px;
  --gaxl-badge-height-md: 24px;
  --gaxl-badge-height-lg: 28px;
  --gaxl-badge-font-size-sm: var(--gaxl-size-overline);
  --gaxl-badge-font-size-lg: var(--gaxl-size-body-sm);
  --gaxl-badge-neutral-soft-bg: var(--gaxl-surface-secondary);
  --gaxl-badge-neutral-soft-fg: var(--gaxl-text-secondary);
  --gaxl-badge-neutral-filled-bg: var(--gaxl-neutral-600);
  --gaxl-badge-primary-soft-bg: var(--gaxl-brand-primary-soft);
  --gaxl-badge-primary-soft-fg: var(--gaxl-brand-primary);
  --gaxl-badge-secondary-soft-bg: var(--gaxl-secondary-soft);
  --gaxl-badge-secondary-soft-fg: var(--gaxl-secondary-text);
  --gaxl-badge-success-soft-bg: var(--gaxl-success-soft);
  --gaxl-badge-success-soft-fg: var(--gaxl-success-text);
  --gaxl-badge-warning-soft-bg: var(--gaxl-warning-soft);
  --gaxl-badge-warning-soft-fg: var(--gaxl-warning-text);
  --gaxl-badge-error-soft-bg: var(--gaxl-error-soft);
  --gaxl-badge-error-soft-fg: var(--gaxl-error-text);
  --gaxl-badge-info-soft-bg: var(--gaxl-info-soft);
  --gaxl-badge-info-soft-fg: var(--gaxl-info-text);
  --gaxl-tag-bg: var(--gaxl-surface-secondary);
  --gaxl-tag-border: var(--gaxl-border-default);
  --gaxl-tag-fg: var(--gaxl-text-secondary);
  --gaxl-tag-radius: var(--gaxl-radius-4);
  --gaxl-table-radius: var(--gaxl-radius-8);
  --gaxl-table-border: var(--gaxl-border-default);
  --gaxl-table-header-bg: var(--gaxl-surface-secondary);
  --gaxl-table-header-fg: var(--gaxl-text-secondary);
  --gaxl-table-row-height-compact: var(--gaxl-row-height-compact);
  --gaxl-table-row-height-medium: var(--gaxl-row-height-medium);
  --gaxl-table-row-height-large: var(--gaxl-row-height-large);
  --gaxl-table-cell-padding-x: var(--gaxl-space-5);
  --gaxl-table-row-hover: var(--gaxl-surface-hover);
  --gaxl-table-row-selected: var(--gaxl-surface-selected);
  --gaxl-tab-fg: var(--gaxl-text-secondary);
  --gaxl-tab-fg-active: var(--gaxl-brand-primary);
  --gaxl-tab-indicator: var(--gaxl-brand-primary);
  --gaxl-tab-font-weight: var(--gaxl-weight-semibold);
  --gaxl-tooltip-bg: var(--gaxl-neutral-900);
  --gaxl-tooltip-fg: var(--gaxl-neutral-0);
  --gaxl-tooltip-radius: var(--gaxl-radius-6);
  --gaxl-tooltip-font-size: var(--gaxl-size-caption);
  --gaxl-alert-radius: var(--gaxl-radius-8);
  --gaxl-alert-padding: var(--gaxl-space-4) 14px;
  --gaxl-avatar-size-xs: 22px;
  --gaxl-avatar-size-sm: 28px;
  --gaxl-avatar-size-md: 36px;
  --gaxl-avatar-size-lg: 44px;
  --gaxl-avatar-size-xl: 56px;
  --gaxl-avatar-bg: var(--gaxl-brand-primary-soft);
  --gaxl-avatar-fg: var(--gaxl-brand-primary);
  --gaxl-avatar-radius-square: var(--gaxl-radius-8);
  --gaxl-progress-track: var(--gaxl-surface-secondary);
  --gaxl-progress-bar: var(--gaxl-brand-primary);
  --gaxl-progress-height: 8px;
  --gaxl-confidence-track: var(--gaxl-surface-secondary);
  --gaxl-confidence-seg-high: var(--gaxl-confidence-high);
  --gaxl-confidence-seg-med: var(--gaxl-confidence-med);
  --gaxl-confidence-seg-low: var(--gaxl-confidence-low);
  --gaxl-pg-btn-size: 32px;
  --gaxl-pg-btn-gap: var(--gaxl-space-2);
  --gaxl-pg-btn-radius: var(--gaxl-radius-6);
  --gaxl-pg-btn-active-bg: var(--gaxl-brand-primary);
  --gaxl-pg-btn-active-fg: var(--gaxl-brand-on-primary);
  --gaxl-pg-btn-default-bg: var(--gaxl-surface);
  --gaxl-pg-btn-default-fg: var(--gaxl-text-primary);
  --gaxl-pg-btn-hover-bg: var(--gaxl-surface-hover);
  --gaxl-pg-btn-border: var(--gaxl-border-default);
  --gaxl-pg-btn-disabled-fg: var(--gaxl-text-disabled);
  --gaxl-pg-label-fg: var(--gaxl-text-secondary);
}
[data-theme='dark'] {
  --gaxl-brand-primary: var(--gaxl-blue-500);
  --gaxl-brand-primary-hover: var(--gaxl-blue-400);
  --gaxl-brand-primary-active: var(--gaxl-blue-300);
  --gaxl-brand-primary-soft: rgba(59, 107, 240, 0.14);
  --gaxl-brand-primary-subtle: rgba(59, 107, 240, 0.22);
  --gaxl-brand-on-primary: var(--gaxl-neutral-950);
  --gaxl-brand-accent: var(--gaxl-violet-400);
  --gaxl-canvas: var(--gaxl-neutral-950);
  --gaxl-surface: var(--gaxl-neutral-900);
  --gaxl-surface-secondary: var(--gaxl-neutral-925);
  --gaxl-surface-card: var(--gaxl-neutral-900);
  --gaxl-surface-elevated: var(--gaxl-neutral-800);
  --gaxl-surface-header: var(--gaxl-neutral-900);
  --gaxl-surface-modal: var(--gaxl-neutral-800);
  --gaxl-surface-hover: rgba(255, 255, 255, 0.04);
  --gaxl-surface-selected: rgba(59, 107, 240, 0.16);
  --gaxl-text-primary: var(--gaxl-neutral-50);
  --gaxl-text-secondary: var(--gaxl-neutral-300);
  --gaxl-text-tertiary: var(--gaxl-neutral-400);
  --gaxl-text-link: var(--gaxl-blue-300);
  --gaxl-border-default: rgba(255, 255, 255, 0.1);
  --gaxl-border-strong: rgba(255, 255, 255, 0.18);
  --gaxl-focus-ring: 0 0 0 3px rgba(92, 140, 249, 0.4);
  --gaxl-success: var(--gaxl-success-500);
  --gaxl-warning: var(--gaxl-warning-500);
  --gaxl-error: var(--gaxl-error-500);
  --gaxl-info: var(--gaxl-info-500);
  --gaxl-success-soft: rgba(22, 179, 100, 0.14);
  --gaxl-success-border: rgba(22, 179, 100, 0.32);
  --gaxl-success-text: var(--gaxl-success-200);
  --gaxl-warning-soft: rgba(245, 158, 11, 0.14);
  --gaxl-warning-border: rgba(245, 158, 11, 0.32);
  --gaxl-warning-text: var(--gaxl-warning-200);
  --gaxl-error-soft: rgba(240, 68, 56, 0.14);
  --gaxl-error-border: rgba(240, 68, 56, 0.32);
  --gaxl-error-text: var(--gaxl-error-200);
  --gaxl-info-soft: rgba(46, 144, 250, 0.14);
  --gaxl-info-border: rgba(46, 144, 250, 0.32);
  --gaxl-info-text: var(--gaxl-info-200);
  --gaxl-secondary-soft: rgba(124, 58, 237, 0.14);
  --gaxl-secondary-text: var(--gaxl-violet-200);
  --gaxl-badge-neutral-filled-bg: var(--gaxl-neutral-500);
  --gaxl-viz-1: var(--gaxl-blue-400);
  --gaxl-viz-2: var(--gaxl-violet-400);
  --gaxl-viz-6: var(--gaxl-neutral-400);
  --gaxl-esa-panel: rgba(99, 102, 241, 0.08);
  --gaxl-esa-accent: var(--gaxl-violet-400);
  --gaxl-esa-accent-muted: rgba(99, 102, 241, 0.14);
  --gaxl-esa-hover: var(--gaxl-indigo-500);
  --gaxl-esa-gradient-from: var(--gaxl-blue-600);
  --gaxl-esa-gradient-to: var(--gaxl-violet-600);
  --gaxl-esa-suggestion-gradient: linear-gradient(
    to right,
    var(--gaxl-esa-gradient-from),
    var(--gaxl-esa-gradient-to)
  );
  --gaxl-edb-accent: var(--gaxl-blue-400);
  --gaxl-edb-accent-muted: rgba(73, 123, 247, 0.14);
  --gaxl-shell-bar-top: var(--gaxl-surface-header);
  --gaxl-pg-btn-default-bg: var(--gaxl-surface);
  --gaxl-pg-btn-default-fg: var(--gaxl-text-primary);
  --gaxl-pg-btn-hover-bg: var(--gaxl-surface-hover);
  --gaxl-pg-btn-border: var(--gaxl-border-default);
  --gaxl-pg-btn-disabled-fg: var(--gaxl-text-disabled);
  --gaxl-pg-label-fg: var(--gaxl-text-secondary);
}
@media (prefers-reduced-motion: reduce) {
  :root {
    --gaxl-duration-instant: 0ms;
    --gaxl-duration-fast: 0ms;
    --gaxl-duration-base: 0ms;
    --gaxl-duration-slow: 0ms;
    --gaxl-duration-slower: 0ms;
  }
}
:root, [data-theme='light'] {
  --gaxl-brand-primary: #196EE0;
  --gaxl-brand-primary-hover: #1558B0;
  --gaxl-brand-primary-active: #1044A0;
  --gaxl-brand-primary-soft: rgba(25, 110, 224, 0.1);
  --gaxl-brand-primary-subtle: rgba(25, 110, 224, 0.18);
  --gaxl-text-link: #1558B0;
  --gaxl-canvas: #ffffff;
  --gaxl-surface: #ffffff;
  --gaxl-surface-card: #F8FAFC;
  --gaxl-surface-muted: #F1F5F9;
  --gaxl-surface-hover: #F1F5F9;
  --gaxl-surface-selected: rgba(25, 110, 224, 0.1);
  --gaxl-text-primary: #0F172A;
  --gaxl-text-secondary: #334155;
  --gaxl-text-muted: #64748B;
  --gaxl-text-disabled: #94A3B8;
  --gaxl-text-inverse: #ffffff;
  --gaxl-border-default: #E2E8F0;
  --gaxl-border-strong: #CBD5E1;
  --gaxl-border-focus: #196EE0;
  --gaxl-success: #16B364;
  --gaxl-success-soft: rgba(22, 179, 100, 0.1);
  --gaxl-success-text: #15803D;
  --gaxl-success-border: rgba(22, 179, 100, 0.3);
  --gaxl-error: #F04438;
  --gaxl-error-soft: rgba(240, 68, 56, 0.1);
  --gaxl-error-text: #B91C1C;
  --gaxl-error-border: rgba(240, 68, 56, 0.3);
  --gaxl-warning: #F59E0B;
  --gaxl-warning-soft: rgba(245, 158, 11, 0.1);
  --gaxl-warning-text: #B45309;
  --gaxl-warning-border: rgba(245, 158, 11, 0.3);
  --gaxl-font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --gaxl-font-mono: 'JetBrains Mono', 'Fira Code', 'Cascadia Code', ui-monospace, monospace;
  --gaxl-size-overline: 0.6875rem;
  --gaxl-size-compact: 0.6875rem;
  --gaxl-size-caption: 0.75rem;
  --gaxl-size-body-sm: 0.75rem;
  --gaxl-size-label: 0.75rem;
  --gaxl-size-code: 0.75rem;
  --gaxl-size-body-md: 0.875rem;
  --gaxl-size-subtitle: 0.9375rem;
  --gaxl-size-body-lg: 1rem;
  --gaxl-size-title: 1rem;
  --gaxl-size-heading-s: 1.125rem;
  --gaxl-size-heading-m: 1.25rem;
  --gaxl-size-heading-l: 1.5rem;
  --gaxl-size-heading-xl: 1.875rem;
  --gaxl-size-display-l: 2.25rem;
  --gaxl-size-display-xl: 2.25rem;
  --gaxl-text-body: 400 var(--gaxl-size-body-md) / var(--gaxl-leading-normal) var(--gaxl-font-sans);
  --gaxl-text-label: 500 var(--gaxl-size-label) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-caption: 400 var(--gaxl-size-caption) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-title: 600 var(--gaxl-size-title) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-heading-s: 600 var(--gaxl-size-heading-s) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-heading-m: 600 var(--gaxl-size-heading-m) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-heading-l: 600 var(--gaxl-size-heading-l) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-heading-xl: 600 var(--gaxl-size-heading-xl) / var(--gaxl-leading-snug) var(--gaxl-font-sans);
  --gaxl-text-display-l: 700 var(--gaxl-size-display-l) / var(--gaxl-leading-tight) var(--gaxl-font-sans);
  --gaxl-text-display-xl: 700 var(--gaxl-size-display-xl) / var(--gaxl-leading-tight) var(--gaxl-font-sans);
  --gaxl-space-1: 2px;
  --gaxl-space-2: 4px;
  --gaxl-space-3: 8px;
  --gaxl-space-4: 12px;
  --gaxl-space-5: 16px;
  --gaxl-space-6: 20px;
  --gaxl-space-7: 24px;
  --gaxl-space-8: 32px;
  --gaxl-space-9: 40px;
  --gaxl-space-10: 48px;
  --gaxl-space-11: 64px;
  --gaxl-space-12: 80px;
  --gaxl-space-13: 96px;
  --gaxl-radius-2: 2px;
  --gaxl-radius-4: 4px;
  --gaxl-radius-6: 6px;
  --gaxl-radius-8: 8px;
  --gaxl-radius-12: 12px;
  --gaxl-radius-16: 16px;
  --gaxl-radius-full: 9999px;
  --gaxl-shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06);
  --gaxl-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06);
  --gaxl-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.06);
  --gaxl-focus-ring: 0 0 0 3px rgba(25, 110, 224, 0.35);
  --color-blue-primary: #196EE0;
  --color-bg-page: #ffffff;
  --space-4: 8px;
  --space-8: 16px;
}
[data-theme='dark'] {
  --gaxl-canvas: #09090B;
  --gaxl-surface: #09090B;
  --gaxl-surface-card: #18181B;
  --gaxl-surface-muted: #1F2937;
  --gaxl-surface-hover: #27272A;
  --gaxl-surface-selected: rgba(59, 107, 240, 0.16);
  --gaxl-border-default: #3F3F46;
  --gaxl-border-strong: #3F3F46;
  --gaxl-border-focus: #2563EB;
  --gaxl-text-primary: #F8FAFC;
  --gaxl-text-secondary: #CFD8E3;
  --gaxl-text-muted: #98A4B6;
  --gaxl-text-disabled: #6B7280;
  --gaxl-text-inverse: #09090B;
  --gaxl-text-link: #8EB3FD;
  --gaxl-brand-primary: #2563EB;
  --gaxl-brand-primary-hover: #3B76F5;
  --gaxl-brand-primary-active: #4F88FF;
  --gaxl-brand-primary-soft: rgba(59, 107, 240, 0.16);
  --gaxl-brand-primary-subtle: rgba(59, 107, 240, 0.28);
  --gaxl-success: #16B364;
  --gaxl-success-soft: rgba(22, 179, 100, 0.12);
  --gaxl-success-text: #4ADE80;
  --gaxl-success-border: rgba(22, 179, 100, 0.25);
  --gaxl-error: #F04438;
  --gaxl-error-soft: rgba(240, 68, 56, 0.12);
  --gaxl-error-text: #FCA5A5;
  --gaxl-error-border: rgba(240, 68, 56, 0.25);
  --gaxl-warning: #F59E0B;
  --gaxl-warning-soft: rgba(245, 158, 11, 0.12);
  --gaxl-warning-text: #FCD34D;
  --gaxl-warning-border: rgba(245, 158, 11, 0.25);
  --color-blue-primary: #2563EB;
  --color-bg-page: #09090B;
}
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: var(--gaxl-font-sans);
    --font-mono: var(--gaxl-font-mono);
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-violet-200: var(--gaxl-violet-200);
    --color-violet-600: var(--gaxl-violet-600);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --font-weight-normal: 400;
    --font-weight-medium: var(--gaxl-weight-medium);
    --font-weight-semibold: var(--gaxl-weight-semibold);
    --font-weight-bold: var(--gaxl-weight-bold);
    --font-weight-extrabold: 800;
    --tracking-tighter: -0.05em;
    --tracking-tight: -0.025em;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --animate-bounce: bounce 1s infinite;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-brand-primary: var(--gaxl-brand-primary);
    --color-brand-primary-hover: var(--gaxl-brand-primary-hover);
    --color-brand-primary-active: var(--gaxl-brand-primary-active);
    --color-brand-primary-soft: var(--gaxl-brand-primary-soft);
    --color-brand-primary-subtle: var(--gaxl-brand-primary-subtle);
    --color-brand-on-primary: var(--gaxl-brand-on-primary);
    --color-brand-secondary: var(--gaxl-brand-secondary);
    --color-edb-accent: var(--gaxl-edb-accent);
    --color-canvas: var(--gaxl-canvas);
    --color-surface: var(--gaxl-surface);
    --color-surface-secondary: var(--gaxl-surface-secondary);
    --color-surface-card: var(--gaxl-surface-card);
    --color-surface-elevated: var(--gaxl-surface-elevated);
    --color-surface-hover: var(--gaxl-surface-hover);
    --color-surface-selected: var(--gaxl-surface-selected);
    --color-surface-muted: var(--gaxl-surface-muted);
    --color-text-primary: var(--gaxl-text-primary);
    --color-text-secondary: var(--gaxl-text-secondary);
    --color-text-tertiary: var(--gaxl-text-tertiary);
    --color-text-disabled: var(--gaxl-text-disabled);
    --color-text-muted: var(--gaxl-text-muted);
    --color-text-inverse: var(--gaxl-text-inverse);
    --color-text-link: var(--gaxl-text-link);
    --color-border-default: var(--gaxl-border-default);
    --color-border-strong: var(--gaxl-border-strong);
    --color-border-focus: var(--gaxl-border-focus);
    --color-success: var(--gaxl-success);
    --color-warning: var(--gaxl-warning);
    --color-error: var(--gaxl-error);
    --color-info: var(--gaxl-info);
    --color-success-soft: var(--gaxl-success-soft);
    --color-success-border: var(--gaxl-success-border);
    --color-success-text: var(--gaxl-success-text);
    --color-warning-soft: var(--gaxl-warning-soft);
    --color-warning-border: var(--gaxl-warning-border);
    --color-warning-text: var(--gaxl-warning-text);
    --color-error-soft: var(--gaxl-error-soft);
    --color-info-soft: var(--gaxl-info-soft);
    --color-info-border: var(--gaxl-info-border);
    --color-info-text: var(--gaxl-info-text);
    --color-visit-supervisory: var(--gaxl-visit-supervisory);
    --color-visit-start-of-care: var(--gaxl-visit-start-of-care);
    --color-visit-routine: var(--gaxl-visit-routine);
    --color-visit-pt-ot: var(--gaxl-visit-pt-ot);
    --color-surface-faint: var(--gaxl-surface-faint);
    --color-violet-pale-bg: var(--gaxl-violet-pale-bg);
    --color-blue-tint: var(--gaxl-blue-tint);
    --color-blue-pale: var(--gaxl-blue-pale);
    --color-indigo-pale: var(--gaxl-indigo-pale);
    --color-indigo-light: var(--gaxl-indigo-light);
    --color-esa-panel: var(--gaxl-esa-panel);
    --color-esa-accent: var(--gaxl-esa-accent);
    --color-esa-accent-muted: var(--gaxl-esa-accent-muted);
    --color-esa-hover: var(--gaxl-esa-hover);
    --color-catalog-channel: var(--gaxl-catalog-channel);
    --color-catalog-channel-dot: var(--gaxl-catalog-channel-dot);
    --color-chip-scope-fg: var(--gaxl-chip-scope-fg);
    --color-chip-scope-bg: var(--gaxl-chip-scope-bg);
    --color-chip-scope-border: var(--gaxl-chip-scope-border);
    --color-chip-objective-fg: var(--gaxl-chip-objective-fg);
    --color-chip-objective-bg: var(--gaxl-chip-objective-bg);
    --color-chip-objective-border: var(--gaxl-chip-objective-border);
    --color-shell-bar: var(--gaxl-shell-bar);
    --color-shell-bar-top: var(--gaxl-shell-bar-top);
    --color-success-strong: var(--gaxl-success-strong);
    --color-success-strong-hover: var(--gaxl-success-strong-hover);
    --color-success-700: var(--gaxl-success-700);
    --color-error-700: var(--gaxl-error-700);
    --color-disabled-surface: var(--gaxl-disabled-surface);
    --color-secondary-soft: var(--gaxl-secondary-soft);
    --color-pg-btn-active-bg: var(--gaxl-pg-btn-active-bg);
    --color-pg-btn-active-fg: var(--gaxl-pg-btn-active-fg);
    --color-pg-btn-default-bg: var(--gaxl-pg-btn-default-bg);
    --color-pg-btn-default-fg: var(--gaxl-pg-btn-default-fg);
    --color-pg-btn-hover-bg: var(--gaxl-pg-btn-hover-bg);
    --color-pg-btn-border: var(--gaxl-pg-btn-border);
    --color-pg-btn-disabled-fg: var(--gaxl-pg-btn-disabled-fg);
    --color-pg-label-fg: var(--gaxl-pg-label-fg);
    --spacing-1: var(--gaxl-space-1);
    --spacing-2: var(--gaxl-space-2);
    --spacing-3: var(--gaxl-space-3);
    --spacing-4: var(--gaxl-space-4);
    --spacing-5: var(--gaxl-space-5);
    --spacing-6: var(--gaxl-space-6);
    --spacing-7: var(--gaxl-space-7);
    --spacing-8: var(--gaxl-space-8);
    --spacing-9: var(--gaxl-space-9);
    --spacing-10: var(--gaxl-space-10);
    --spacing-11: var(--gaxl-space-11);
    --spacing-12: var(--gaxl-space-12);
    --spacing-13: var(--gaxl-space-13);
    --radius-2: var(--gaxl-radius-2);
    --radius-4: var(--gaxl-radius-4);
    --radius-6: var(--gaxl-radius-6);
    --radius-8: var(--gaxl-radius-8);
    --radius-12: var(--gaxl-radius-12);
    --radius-full: var(--gaxl-radius-full);
    --radius-pg-btn: var(--gaxl-pg-btn-radius);
    --border-width-thin: 1px;
    --text-display-xl: var(--gaxl-size-display-xl);
    --text-display-l: var(--gaxl-size-display-l);
    --text-heading-xl: var(--gaxl-size-heading-xl);
    --text-heading-l: var(--gaxl-size-heading-l);
    --text-heading-m: var(--gaxl-size-heading-m);
    --text-heading-s: var(--gaxl-size-heading-s);
    --text-title: var(--gaxl-size-title);
    --text-body-lg: var(--gaxl-size-body-lg);
    --text-body-md: var(--gaxl-size-body-md);
    --text-body-sm: var(--gaxl-size-body-sm);
    --text-caption: var(--gaxl-size-caption);
    --text-overline: var(--gaxl-size-overline);
    --transition-duration-instant: var(--gaxl-duration-instant);
    --transition-duration-fast: var(--gaxl-duration-fast);
    --transition-duration-base: var(--gaxl-duration-base);
    --transition-duration-slow: var(--gaxl-duration-slow);
    --transition-duration-slower: var(--gaxl-duration-slower);
    --font-weight-regular: var(--gaxl-weight-regular);
    --width-icon-md: 16px;
    --height-icon-md: 16px;
    --text-label: var(--gaxl-size-label);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container {
    container-type: inline-size;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip-path: none;
    white-space: normal;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: 0;
  }
  .inset-\\[10px\\] {
    inset: 10px;
  }
  .inset-x-0 {
    inset-inline: 0;
  }
  .inset-y-0 {
    inset-block: 0;
  }
  .-top-1 {
    top: calc(var(--spacing-1) * -1);
  }
  .-top-1\\.5 {
    top: calc(var(--spacing) * -1.5);
  }
  .-top-\\[98px\\] {
    top: calc(98px * -1);
  }
  .-top-\\[102px\\] {
    top: calc(102px * -1);
  }
  .top-0 {
    top: 0;
  }
  .top-0\\.5 {
    top: calc(var(--spacing) * 0.5);
  }
  .top-1 {
    top: var(--spacing-1);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-2 {
    top: var(--spacing-2);
  }
  .top-4 {
    top: var(--spacing-4);
  }
  .top-\\[-5px\\] {
    top: -5px;
  }
  .top-\\[7px\\] {
    top: 7px;
  }
  .top-\\[42px\\] {
    top: 42px;
  }
  .top-\\[calc\\(100\\%\\+4px\\)\\] {
    top: calc(100% + 4px);
  }
  .top-\\[calc\\(100\\%\\+8px\\)\\] {
    top: calc(100% + 8px);
  }
  .top-full {
    top: 100%;
  }
  .-right-1 {
    right: calc(var(--spacing-1) * -1);
  }
  .-right-1\\.5 {
    right: calc(var(--spacing) * -1.5);
  }
  .-right-\\[9px\\] {
    right: calc(9px * -1);
  }
  .right-0 {
    right: 0;
  }
  .right-1 {
    right: var(--spacing-1);
  }
  .right-2 {
    right: var(--spacing-2);
  }
  .right-3 {
    right: var(--spacing-3);
  }
  .right-4 {
    right: var(--spacing-4);
  }
  .right-5 {
    right: var(--spacing-5);
  }
  .right-\\[8px\\] {
    right: 8px;
  }
  .bottom-0 {
    bottom: 0;
  }
  .bottom-4 {
    bottom: var(--spacing-4);
  }
  .bottom-5 {
    bottom: var(--spacing-5);
  }
  .bottom-20 {
    bottom: calc(var(--spacing) * 20);
  }
  .-left-\\[5px\\] {
    left: calc(5px * -1);
  }
  .left-0 {
    left: 0;
  }
  .left-0\\.5 {
    left: calc(var(--spacing) * 0.5);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-3 {
    left: var(--spacing-3);
  }
  .left-4 {
    left: var(--spacing-4);
  }
  .left-5 {
    left: var(--spacing-5);
  }
  .isolate {
    isolation: isolate;
  }
  .isolation-auto {
    isolation: auto;
  }
  .z-1 {
    z-index: 1;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[60\\] {
    z-index: 60;
  }
  .z-\\[100\\] {
    z-index: 100;
  }
  .z-\\[101\\] {
    z-index: 101;
  }
  .z-\\[200\\] {
    z-index: 200;
  }
  .z-\\[201\\] {
    z-index: 201;
  }
  .z-\\[1000\\] {
    z-index: 1000;
  }
  .z-\\[9999\\] {
    z-index: 9999;
  }
  .col-start-1 {
    grid-column-start: 1;
  }
  .row-1 {
    grid-row: 1;
  }
  .row-2 {
    grid-row: 2;
  }
  .row-3 {
    grid-row: 3;
  }
  .row-start-1 {
    grid-row-start: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-0 {
    margin: 0;
  }
  .-mx-\\[13px\\] {
    margin-inline: calc(13px * -1);
  }
  .mx-1 {
    margin-inline: var(--spacing-1);
  }
  .mx-2 {
    margin-inline: var(--spacing-2);
  }
  .mx-3 {
    margin-inline: var(--spacing-3);
  }
  .mx-4 {
    margin-inline: var(--spacing-4);
  }
  .mx-\\[5px\\] {
    margin-inline: 5px;
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: var(--spacing-1);
  }
  .my-2 {
    margin-block: var(--spacing-2);
  }
  .my-3 {
    margin-block: var(--spacing-3);
  }
  .my-4 {
    margin-block: var(--spacing-4);
  }
  .my-auto {
    margin-block: auto;
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: var(--spacing-1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: var(--spacing-2);
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: var(--spacing-3);
  }
  .mt-4 {
    margin-top: var(--spacing-4);
  }
  .mt-5 {
    margin-top: var(--spacing-5);
  }
  .mt-6 {
    margin-top: var(--spacing-6);
  }
  .mt-10 {
    margin-top: var(--spacing-10);
  }
  .mt-11 {
    margin-top: var(--spacing-11);
  }
  .mt-\\[1px\\] {
    margin-top: 1px;
  }
  .mt-\\[2px\\] {
    margin-top: 2px;
  }
  .mt-\\[3px\\] {
    margin-top: 3px;
  }
  .mt-\\[4px\\] {
    margin-top: 4px;
  }
  .mt-\\[6px\\] {
    margin-top: 6px;
  }
  .mt-\\[10px\\] {
    margin-top: 10px;
  }
  .mt-\\[21px\\] {
    margin-top: 21px;
  }
  .mt-auto {
    margin-top: auto;
  }
  .mt-px {
    margin-top: 1px;
  }
  .mr-1 {
    margin-right: var(--spacing-1);
  }
  .mr-2 {
    margin-right: var(--spacing-2);
  }
  .mr-3 {
    margin-right: var(--spacing-3);
  }
  .mr-7 {
    margin-right: var(--spacing-7);
  }
  .mr-10 {
    margin-right: var(--spacing-10);
  }
  .-mb-\\[9px\\] {
    margin-bottom: calc(9px * -1);
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: var(--spacing-1);
  }
  .mb-1\\.5 {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
  .mb-2 {
    margin-bottom: var(--spacing-2);
  }
  .mb-3 {
    margin-bottom: var(--spacing-3);
  }
  .mb-4 {
    margin-bottom: var(--spacing-4);
  }
  .mb-5 {
    margin-bottom: var(--spacing-5);
  }
  .mb-6 {
    margin-bottom: var(--spacing-6);
  }
  .mb-8 {
    margin-bottom: var(--spacing-8);
  }
  .mb-10 {
    margin-bottom: var(--spacing-10);
  }
  .mb-\\[3px\\] {
    margin-bottom: 3px;
  }
  .mb-\\[7px\\] {
    margin-bottom: 7px;
  }
  .mb-\\[10px\\] {
    margin-bottom: 10px;
  }
  .\\!ml-0 {
    margin-left: 0 !important;
  }
  .ml-2 {
    margin-left: var(--spacing-2);
  }
  .ml-3 {
    margin-left: var(--spacing-3);
  }
  .ml-4 {
    margin-left: var(--spacing-4);
  }
  .ml-5 {
    margin-left: var(--spacing-5);
  }
  .ml-7 {
    margin-left: var(--spacing-7);
  }
  .ml-\\[5px\\] {
    margin-left: 5px;
  }
  .ml-auto {
    margin-left: auto;
  }
  .\\!box-border {
    box-sizing: border-box !important;
  }
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .line-clamp-3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .\\!flex {
    display: flex !important;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .flow-root {
    display: flow-root;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-grid {
    display: inline-grid;
  }
  .inline-table {
    display: inline-table;
  }
  .list-item {
    display: list-item;
  }
  .table {
    display: table;
  }
  .table-caption {
    display: table-caption;
  }
  .table-cell {
    display: table-cell;
  }
  .table-column {
    display: table-column;
  }
  .table-column-group {
    display: table-column-group;
  }
  .table-footer-group {
    display: table-footer-group;
  }
  .table-header-group {
    display: table-header-group;
  }
  .table-row {
    display: table-row;
  }
  .table-row-group {
    display: table-row-group;
  }
  .\\!size-2 {
    width: var(--spacing-2) !important;
    height: var(--spacing-2) !important;
  }
  .\\!size-2\\.5 {
    width: calc(var(--spacing) * 2.5) !important;
    height: calc(var(--spacing) * 2.5) !important;
  }
  .\\!size-3 {
    width: var(--spacing-3) !important;
    height: var(--spacing-3) !important;
  }
  .\\!size-3\\.5 {
    width: calc(var(--spacing) * 3.5) !important;
    height: calc(var(--spacing) * 3.5) !important;
  }
  .\\!size-4 {
    width: var(--spacing-4) !important;
    height: var(--spacing-4) !important;
  }
  .\\!size-5 {
    width: var(--spacing-5) !important;
    height: var(--spacing-5) !important;
  }
  .\\!size-6 {
    width: var(--spacing-6) !important;
    height: var(--spacing-6) !important;
  }
  .\\!size-7 {
    width: var(--spacing-7) !important;
    height: var(--spacing-7) !important;
  }
  .\\!size-\\[18px\\] {
    width: 18px !important;
    height: 18px !important;
  }
  .\\!size-full {
    width: 100% !important;
    height: 100% !important;
  }
  .size-1\\.5 {
    width: calc(var(--spacing) * 1.5);
    height: calc(var(--spacing) * 1.5);
  }
  .size-2 {
    width: var(--spacing-2);
    height: var(--spacing-2);
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }
  .size-3\\.5 {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
  .size-5 {
    width: var(--spacing-5);
    height: var(--spacing-5);
  }
  .size-7 {
    width: var(--spacing-7);
    height: var(--spacing-7);
  }
  .size-8 {
    width: var(--spacing-8);
    height: var(--spacing-8);
  }
  .\\!h-4 {
    height: var(--spacing-4) !important;
  }
  .\\!h-6 {
    height: var(--spacing-6) !important;
  }
  .\\!h-7 {
    height: var(--spacing-7) !important;
  }
  .\\!h-8 {
    height: var(--spacing-8) !important;
  }
  .h-0\\.5 {
    height: calc(var(--spacing) * 0.5);
  }
  .h-1 {
    height: var(--spacing-1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: var(--spacing-2);
  }
  .h-3 {
    height: var(--spacing-3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: var(--spacing-4);
  }
  .h-4\\.5 {
    height: calc(var(--spacing) * 4.5);
  }
  .h-5 {
    height: var(--spacing-5);
  }
  .h-5\\.5 {
    height: calc(var(--spacing) * 5.5);
  }
  .h-6 {
    height: var(--spacing-6);
  }
  .h-6\\.5 {
    height: calc(var(--spacing) * 6.5);
  }
  .h-7 {
    height: var(--spacing-7);
  }
  .h-8 {
    height: var(--spacing-8);
  }
  .h-9 {
    height: var(--spacing-9);
  }
  .h-10 {
    height: var(--spacing-10);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-\\[6\\.75px\\] {
    height: 6.75px;
  }
  .h-\\[6px\\] {
    height: 6px;
  }
  .h-\\[7px\\] {
    height: 7px;
  }
  .h-\\[8px\\] {
    height: 8px;
  }
  .h-\\[9px\\] {
    height: 9px;
  }
  .h-\\[12px\\] {
    height: 12px;
  }
  .h-\\[13px\\] {
    height: 13px;
  }
  .h-\\[15px\\] {
    height: 15px;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[20px\\] {
    height: 20px;
  }
  .h-\\[22px\\] {
    height: 22px;
  }
  .h-\\[24px\\] {
    height: 24px;
  }
  .h-\\[25px\\] {
    height: 25px;
  }
  .h-\\[26px\\] {
    height: 26px;
  }
  .h-\\[28px\\] {
    height: 28px;
  }
  .h-\\[30px\\] {
    height: 30px;
  }
  .h-\\[32px\\] {
    height: 32px;
  }
  .h-\\[34px\\] {
    height: 34px;
  }
  .h-\\[35px\\] {
    height: 35px;
  }
  .h-\\[36px\\] {
    height: 36px;
  }
  .h-\\[40px\\] {
    height: 40px;
  }
  .h-\\[42px\\] {
    height: 42px;
  }
  .h-\\[47px\\] {
    height: 47px;
  }
  .h-\\[48px\\] {
    height: 48px;
  }
  .h-\\[58px\\] {
    height: 58px;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[80px\\] {
    height: 80px;
  }
  .h-\\[var\\(--gaxl-pg-btn-size\\)\\] {
    height: var(--gaxl-pg-btn-size);
  }
  .h-\\[var\\(--gaxl-progress-height\\)\\] {
    height: var(--gaxl-progress-height);
  }
  .h-full {
    height: 100%;
  }
  .h-icon-md {
    height: var(--height-icon-md);
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .\\!max-h-8 {
    max-height: var(--spacing-8) !important;
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-80 {
    max-height: calc(var(--spacing) * 80);
  }
  .max-h-\\[85vh\\] {
    max-height: 85vh;
  }
  .max-h-\\[116px\\] {
    max-height: 116px;
  }
  .max-h-\\[180px\\] {
    max-height: 180px;
  }
  .max-h-\\[200px\\] {
    max-height: 200px;
  }
  .max-h-\\[260px\\] {
    max-height: 260px;
  }
  .max-h-\\[300px\\] {
    max-height: 300px;
  }
  .max-h-\\[420px\\] {
    max-height: 420px;
  }
  .max-h-\\[calc\\(\\.\\.\\.\\*N\\)\\] {
    max-height: calc(...*N);
  }
  .\\!min-h-4 {
    min-height: var(--spacing-4) !important;
  }
  .\\!min-h-6 {
    min-height: var(--spacing-6) !important;
  }
  .\\!min-h-8 {
    min-height: var(--spacing-8) !important;
  }
  .\\!min-h-9 {
    min-height: var(--spacing-9) !important;
  }
  .min-h-0 {
    min-height: 0;
  }
  .min-h-5 {
    min-height: var(--spacing-5);
  }
  .min-h-8 {
    min-height: var(--spacing-8);
  }
  .min-h-12 {
    min-height: var(--spacing-12);
  }
  .min-h-\\[21px\\] {
    min-height: 21px;
  }
  .min-h-\\[38px\\] {
    min-height: 38px;
  }
  .min-h-\\[40px\\] {
    min-height: 40px;
  }
  .min-h-\\[48px\\] {
    min-height: 48px;
  }
  .min-h-\\[60vh\\] {
    min-height: 60vh;
  }
  .min-h-\\[120px\\] {
    min-height: 120px;
  }
  .min-h-auto {
    min-height: auto;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .\\!w-full {
    width: 100% !important;
  }
  .w-0\\.5 {
    width: calc(var(--spacing) * 0.5);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-1\\/2 {
    width: calc(1 / 2 * 100%);
  }
  .w-1\\/3 {
    width: calc(1 / 3 * 100%);
  }
  .w-2 {
    width: var(--spacing-2);
  }
  .w-3 {
    width: var(--spacing-3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-4 {
    width: var(--spacing-4);
  }
  .w-4\\.5 {
    width: calc(var(--spacing) * 4.5);
  }
  .w-5 {
    width: var(--spacing-5);
  }
  .w-5\\.5 {
    width: calc(var(--spacing) * 5.5);
  }
  .w-6 {
    width: var(--spacing-6);
  }
  .w-6\\.5 {
    width: calc(var(--spacing) * 6.5);
  }
  .w-7 {
    width: var(--spacing-7);
  }
  .w-8 {
    width: var(--spacing-8);
  }
  .w-9 {
    width: var(--spacing-9);
  }
  .w-10 {
    width: var(--spacing-10);
  }
  .w-11 {
    width: var(--spacing-11);
  }
  .w-14 {
    width: calc(var(--spacing) * 14);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-\\[1px\\] {
    width: 1px;
  }
  .w-\\[3px\\] {
    width: 3px;
  }
  .w-\\[6\\.75px\\] {
    width: 6.75px;
  }
  .w-\\[6px\\] {
    width: 6px;
  }
  .w-\\[7px\\] {
    width: 7px;
  }
  .w-\\[8px\\] {
    width: 8px;
  }
  .w-\\[9px\\] {
    width: 9px;
  }
  .w-\\[12px\\] {
    width: 12px;
  }
  .w-\\[14px\\] {
    width: 14px;
  }
  .w-\\[15px\\] {
    width: 15px;
  }
  .w-\\[15rem\\] {
    width: 15rem;
  }
  .w-\\[18px\\] {
    width: 18px;
  }
  .w-\\[20px\\] {
    width: 20px;
  }
  .w-\\[22px\\] {
    width: 22px;
  }
  .w-\\[24px\\] {
    width: 24px;
  }
  .w-\\[26px\\] {
    width: 26px;
  }
  .w-\\[28px\\] {
    width: 28px;
  }
  .w-\\[30px\\] {
    width: 30px;
  }
  .w-\\[32px\\] {
    width: 32px;
  }
  .w-\\[34px\\] {
    width: 34px;
  }
  .w-\\[40px\\] {
    width: 40px;
  }
  .w-\\[48px\\] {
    width: 48px;
  }
  .w-\\[58px\\] {
    width: 58px;
  }
  .w-\\[60px\\] {
    width: 60px;
  }
  .w-\\[76px\\] {
    width: 76px;
  }
  .w-\\[80px\\] {
    width: 80px;
  }
  .w-\\[108px\\] {
    width: 108px;
  }
  .w-\\[120px\\] {
    width: 120px;
  }
  .w-\\[180px\\] {
    width: 180px;
  }
  .w-\\[230px\\] {
    width: 230px;
  }
  .w-\\[260px\\] {
    width: 260px;
  }
  .w-\\[340px\\] {
    width: 340px;
  }
  .w-\\[380px\\] {
    width: 380px;
  }
  .w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-icon-md {
    width: var(--width-icon-md);
  }
  .w-max {
    width: -moz-max-content;
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .\\!max-w-full {
    max-width: 100% !important;
  }
  .max-w-\\[50\\%\\] {
    max-width: 50%;
  }
  .max-w-\\[78\\%\\] {
    max-width: 78%;
  }
  .max-w-\\[120px\\] {
    max-width: 120px;
  }
  .max-w-\\[150px\\] {
    max-width: 150px;
  }
  .max-w-\\[160px\\] {
    max-width: 160px;
  }
  .max-w-\\[180px\\] {
    max-width: 180px;
  }
  .max-w-\\[200px\\] {
    max-width: 200px;
  }
  .max-w-\\[220px\\] {
    max-width: 220px;
  }
  .max-w-\\[260px\\] {
    max-width: 260px;
  }
  .max-w-\\[300px\\] {
    max-width: 300px;
  }
  .max-w-\\[320px\\] {
    max-width: 320px;
  }
  .max-w-\\[360px\\] {
    max-width: 360px;
  }
  .max-w-\\[374px\\] {
    max-width: 374px;
  }
  .max-w-\\[380px\\] {
    max-width: 380px;
  }
  .max-w-\\[420px\\] {
    max-width: 420px;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .\\!min-w-0 {
    min-width: 0 !important;
  }
  .\\!min-w-full {
    min-width: 100% !important;
  }
  .min-w-0 {
    min-width: 0;
  }
  .min-w-2 {
    min-width: var(--spacing-2);
  }
  .min-w-4 {
    min-width: var(--spacing-4);
  }
  .min-w-5 {
    min-width: var(--spacing-5);
  }
  .min-w-7 {
    min-width: var(--spacing-7);
  }
  .min-w-20 {
    min-width: calc(var(--spacing) * 20);
  }
  .min-w-28 {
    min-width: calc(var(--spacing) * 28);
  }
  .min-w-\\[16px\\] {
    min-width: 16px;
  }
  .min-w-\\[18px\\] {
    min-width: 18px;
  }
  .min-w-\\[58px\\] {
    min-width: 58px;
  }
  .min-w-\\[160px\\] {
    min-width: 160px;
  }
  .min-w-\\[200px\\] {
    min-width: 200px;
  }
  .min-w-\\[220px\\] {
    min-width: 220px;
  }
  .min-w-\\[var\\(--gaxl-pg-btn-size\\)\\] {
    min-width: var(--gaxl-pg-btn-size);
  }
  .min-w-full {
    min-width: 100%;
  }
  .\\!flex-none {
    flex: none !important;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-\\[0_1_180px\\] {
    flex: 0 1 180px;
  }
  .flex-\\[1_1_200px\\] {
    flex: 1 1 200px;
  }
  .flex-none {
    flex: none;
  }
  .\\!shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .origin-bottom {
    transform-origin: bottom;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: 0;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0\\.5 {
    --tw-translate-x: calc(var(--spacing) * 0.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-1 {
    --tw-translate-x: var(--spacing-1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-3 {
    --tw-translate-x: var(--spacing-3);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-5\\.5 {
    --tw-translate-x: calc(var(--spacing) * 5.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0 {
    --tw-translate-y: 0;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-4 {
    --tw-translate-y: var(--spacing-4);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-none {
    translate: none;
  }
  .scale-3d {
    scale: var(--tw-scale-x) var(--tw-scale-y) var(--tw-scale-z);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-0 {
    rotate: 0deg;
  }
  .rotate-45 {
    rotate: 45deg;
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .rotate-\\[-45deg\\] {
    rotate: -45deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-bounce {
    animation: var(--animate-bounce);
  }
  .animate-ping {
    animation: var(--animate-ping);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-col-resize {
    cursor: col-resize;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .touch-pinch-zoom {
    --tw-pinch-zoom: pinch-zoom;
    touch-action: var(--tw-pan-x,) var(--tw-pan-y,) var(--tw-pinch-zoom,);
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .resize-y {
    resize: vertical;
  }
  .list-decimal {
    list-style-type: decimal;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(158px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(158px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fit\\,minmax\\(120px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
  }
  .grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .\\!justify-between {
    justify-content: space-between !important;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .\\!gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5) !important;
  }
  .\\!gap-2 {
    gap: var(--spacing-2) !important;
  }
  .gap-0 {
    gap: 0;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: var(--spacing-1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: var(--spacing-2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: var(--spacing-3);
  }
  .gap-4 {
    gap: var(--spacing-4);
  }
  .gap-5 {
    gap: var(--spacing-5);
  }
  .gap-6 {
    gap: var(--spacing-6);
  }
  .gap-7 {
    gap: var(--spacing-7);
  }
  .gap-10 {
    gap: var(--spacing-10);
  }
  .gap-\\[2px\\] {
    gap: 2px;
  }
  .gap-\\[3px\\] {
    gap: 3px;
  }
  .gap-\\[5px\\] {
    gap: 5px;
  }
  .gap-\\[6px\\] {
    gap: 6px;
  }
  .gap-\\[7px\\] {
    gap: 7px;
  }
  .gap-\\[9px\\] {
    gap: 9px;
  }
  .gap-\\[10px\\] {
    gap: 10px;
  }
  .gap-\\[11px\\] {
    gap: 11px;
  }
  .gap-\\[17px\\] {
    gap: 17px;
  }
  .gap-\\[18px\\] {
    gap: 18px;
  }
  .gap-\\[21px\\] {
    gap: 21px;
  }
  .gap-\\[var\\(--gaxl-space-1\\)\\] {
    gap: var(--gaxl-space-1);
  }
  .gap-\\[var\\(--gaxl-space-4\\)\\] {
    gap: var(--gaxl-space-4);
  }
  .gap-px {
    gap: 1px;
  }
  .-space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * -1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * -1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-0\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-1) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-2) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-3) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(var(--spacing-4) * var(--tw-space-y-reverse));
      margin-block-end: calc(var(--spacing-4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-reverse {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 1;
    }
  }
  .gap-x-3 {
    -moz-column-gap: var(--spacing-3);
         column-gap: var(--spacing-3);
  }
  .gap-x-5 {
    -moz-column-gap: var(--spacing-5);
         column-gap: var(--spacing-5);
  }
  .gap-x-\\[17px\\] {
    -moz-column-gap: 17px;
         column-gap: 17px;
  }
  .space-x-1 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(var(--spacing-1) * var(--tw-space-x-reverse));
      margin-inline-end: calc(var(--spacing-1) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(var(--spacing-2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(var(--spacing-2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-3 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(var(--spacing-3) * var(--tw-space-x-reverse));
      margin-inline-end: calc(var(--spacing-3) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-reverse {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 1;
    }
  }
  .gap-y-2 {
    row-gap: var(--spacing-2);
  }
  .divide-x {
    :where(& > :not(:last-child)) {
      --tw-divide-x-reverse: 0;
      border-inline-style: var(--tw-border-style);
      border-inline-start-width: calc(1px * var(--tw-divide-x-reverse));
      border-inline-end-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
    }
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-y-reverse {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 1;
    }
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .justify-self-end {
    justify-self: flex-end;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .\\!overflow-hidden {
    overflow: hidden !important;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-hidden {
    overflow-y: hidden;
  }
  .\\!rounded-4 {
    border-radius: var(--radius-4) !important;
  }
  .\\!rounded-8 {
    border-radius: var(--radius-8) !important;
  }
  .\\!rounded-12 {
    border-radius: var(--radius-12) !important;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2 {
    border-radius: var(--radius-2);
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-4 {
    border-radius: var(--radius-4);
  }
  .rounded-6 {
    border-radius: var(--radius-6);
  }
  .rounded-8 {
    border-radius: var(--radius-8);
  }
  .rounded-12 {
    border-radius: var(--radius-12);
  }
  .rounded-\\[2px\\] {
    border-radius: 2px;
  }
  .rounded-\\[4px\\] {
    border-radius: 4px;
  }
  .rounded-\\[4px_12px_12px_12px\\] {
    border-radius: 4px 12px 12px 12px;
  }
  .rounded-\\[5px\\] {
    border-radius: 5px;
  }
  .rounded-\\[6px\\] {
    border-radius: 6px;
  }
  .rounded-\\[7px\\] {
    border-radius: 7px;
  }
  .rounded-\\[8px\\] {
    border-radius: 8px;
  }
  .rounded-\\[9px\\] {
    border-radius: 9px;
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-\\[12px_4px_12px_12px\\] {
    border-radius: 12px 4px 12px 12px;
  }
  .rounded-\\[var\\(--gaxl-radius-8\\)\\] {
    border-radius: var(--gaxl-radius-8);
  }
  .rounded-full {
    border-radius: var(--radius-full);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-pg-btn {
    border-radius: var(--radius-pg-btn);
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-s {
    border-start-start-radius: 0.25rem;
    border-end-start-radius: 0.25rem;
  }
  .rounded-ss {
    border-start-start-radius: 0.25rem;
  }
  .rounded-e {
    border-start-end-radius: 0.25rem;
    border-end-end-radius: 0.25rem;
  }
  .rounded-se {
    border-start-end-radius: 0.25rem;
  }
  .rounded-ee {
    border-end-end-radius: 0.25rem;
  }
  .rounded-es {
    border-end-start-radius: 0.25rem;
  }
  .rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rounded-tl {
    border-top-left-radius: 0.25rem;
  }
  .rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .rounded-tr {
    border-top-right-radius: 0.25rem;
  }
  .rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rounded-b-\\[12px\\] {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  .rounded-br {
    border-bottom-right-radius: 0.25rem;
  }
  .rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }
  .\\!border {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .\\!border-0 {
    border-style: var(--tw-border-style) !important;
    border-width: 0px !important;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-\\[1\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.5px;
  }
  .border-\\[1\\.12px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.12px;
  }
  .border-thin {
    border-style: var(--tw-border-style);
    border-width: var(--border-width-thin);
  }
  .border-thin {
    border-width: var(--border-width-thin);
  }
  .border-x {
    border-inline-style: var(--tw-border-style);
    border-inline-width: 1px;
  }
  .border-x-thin {
    border-inline-style: var(--tw-border-style);
    border-inline-width: var(--border-width-thin);
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-s {
    border-inline-start-style: var(--tw-border-style);
    border-inline-start-width: 1px;
  }
  .border-e {
    border-inline-end-style: var(--tw-border-style);
    border-inline-end-width: 1px;
  }
  .border-bs {
    border-block-start-style: var(--tw-border-style);
    border-block-start-width: 1px;
  }
  .border-be {
    border-block-end-style: var(--tw-border-style);
    border-block-end-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-\\[length\\:var\\(--gaxl-space-2\\)\\] {
    border-top-style: var(--tw-border-style);
    border-top-width: var(--gaxl-space-2);
  }
  .border-t-thin {
    border-top-style: var(--tw-border-style);
    border-top-width: var(--border-width-thin);
  }
  .border-t-thin {
    border-top-width: var(--border-width-thin);
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-b-\\[2\\.5px\\] {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2.5px;
  }
  .border-b-thin {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: var(--border-width-thin);
  }
  .border-b-thin {
    border-bottom-width: var(--border-width-thin);
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-l-\\[3px\\] {
    border-left-style: var(--tw-border-style);
    border-left-width: 3px;
  }
  .border-l-thin {
    border-left-style: var(--tw-border-style);
    border-left-width: var(--border-width-thin);
  }
  .\\!border-none {
    --tw-border-style: none !important;
    border-style: none !important;
  }
  .\\!border-solid {
    --tw-border-style: solid !important;
    border-style: solid !important;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .\\!border-border-default {
    border-color: var(--color-border-default) !important;
  }
  .border-\\[\\#d9d9d9\\] {
    border-color: #d9d9d9;
  }
  .border-\\[\\#e2e6ef\\] {
    border-color: #e2e6ef;
  }
  .border-\\[var\\(--gaxl-border-default\\)\\] {
    border-color: var(--gaxl-border-default);
  }
  .border-\\[var\\(--gaxl-brand-primary\\)\\] {
    border-color: var(--gaxl-brand-primary);
  }
  .border-border-default {
    border-color: var(--color-border-default);
  }
  .border-border-default\\/50 {
    border-color: var(--color-border-default);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-border-default) 50%, transparent);
    }
  }
  .border-border-focus {
    border-color: var(--color-border-focus);
  }
  .border-border-strong {
    border-color: var(--color-border-strong);
  }
  .border-brand-primary {
    border-color: var(--color-brand-primary);
  }
  .border-brand-primary-subtle {
    border-color: var(--color-brand-primary-subtle);
  }
  .border-brand-primary\\/30 {
    border-color: var(--color-brand-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-brand-primary) 30%, transparent);
    }
  }
  .border-brand-secondary {
    border-color: var(--color-brand-secondary);
  }
  .border-catalog-channel-dot {
    border-color: var(--color-catalog-channel-dot);
  }
  .border-chip-objective-border {
    border-color: var(--color-chip-objective-border);
  }
  .border-chip-scope-border {
    border-color: var(--color-chip-scope-border);
  }
  .border-error {
    border-color: var(--color-error);
  }
  .border-error\\/40 {
    border-color: var(--color-error);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-error) 40%, transparent);
    }
  }
  .border-esa-accent {
    border-color: var(--color-esa-accent);
  }
  .border-esa-accent\\/40 {
    border-color: var(--color-esa-accent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-esa-accent) 40%, transparent);
    }
  }
  .border-info-border {
    border-color: var(--color-info-border);
  }
  .border-pg-btn-border {
    border-color: var(--color-pg-btn-border);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-red-300 {
    border-color: var(--color-red-300);
  }
  .border-success {
    border-color: var(--color-success);
  }
  .border-success-border {
    border-color: var(--color-success-border);
  }
  .border-success-strong {
    border-color: var(--color-success-strong);
  }
  .border-surface {
    border-color: var(--color-surface);
  }
  .border-text-muted {
    border-color: var(--color-text-muted);
  }
  .border-text-secondary {
    border-color: var(--color-text-secondary);
  }
  .border-text-tertiary {
    border-color: var(--color-text-tertiary);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-violet-200 {
    border-color: var(--color-violet-200);
  }
  .border-warning {
    border-color: var(--color-warning);
  }
  .border-warning-border {
    border-color: var(--color-warning-border);
  }
  .border-white\\/30 {
    border-color: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .border-t-brand-primary {
    border-top-color: var(--color-brand-primary);
  }
  .border-t-brand-secondary {
    border-top-color: var(--color-brand-secondary);
  }
  .border-t-error {
    border-top-color: var(--color-error);
  }
  .border-t-esa-accent {
    border-top-color: var(--color-esa-accent);
  }
  .border-t-info {
    border-top-color: var(--color-info);
  }
  .border-t-success {
    border-top-color: var(--color-success);
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-t-warning {
    border-top-color: var(--color-warning);
  }
  .border-l-error {
    border-left-color: var(--color-error);
  }
  .border-l-info {
    border-left-color: var(--color-info);
  }
  .border-l-success {
    border-left-color: var(--color-success);
  }
  .border-l-warning {
    border-left-color: var(--color-warning);
  }
  .\\!bg-surface {
    background-color: var(--color-surface) !important;
  }
  .\\!bg-surface-secondary {
    background-color: var(--color-surface-secondary) !important;
  }
  .\\!bg-transparent {
    background-color: transparent !important;
  }
  .bg-\\[\\#d9d9d9\\] {
    background-color: #d9d9d9;
  }
  .bg-\\[\\#fafbfd\\] {
    background-color: #fafbfd;
  }
  .bg-\\[rgba\\(124\\,58\\,237\\,0\\.06\\)\\] {
    background-color: rgba(124,58,237,0.06);
  }
  .bg-\\[var\\(--gaxl-brand-primary-soft\\)\\] {
    background-color: var(--gaxl-brand-primary-soft);
  }
  .bg-\\[var\\(--gaxl-edb-accent-muted\\)\\] {
    background-color: var(--gaxl-edb-accent-muted);
  }
  .bg-\\[var\\(--gaxl-surface-card\\)\\] {
    background-color: var(--gaxl-surface-card);
  }
  .bg-black\\/20 {
    background-color: color-mix(in srgb, #000 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 20%, transparent);
    }
  }
  .bg-blue-pale {
    background-color: var(--color-blue-pale);
  }
  .bg-blue-tint {
    background-color: var(--color-blue-tint);
  }
  .bg-border-default {
    background-color: var(--color-border-default);
  }
  .bg-border-strong {
    background-color: var(--color-border-strong);
  }
  .bg-brand-primary {
    background-color: var(--color-brand-primary);
  }
  .bg-brand-primary-soft {
    background-color: var(--color-brand-primary-soft);
  }
  .bg-brand-primary-soft\\/40 {
    background-color: var(--color-brand-primary-soft);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-brand-primary-soft) 40%, transparent);
    }
  }
  .bg-brand-primary\\/10 {
    background-color: var(--color-brand-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-brand-primary) 10%, transparent);
    }
  }
  .bg-brand-primary\\/\\[0\\.03\\] {
    background-color: var(--color-brand-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-brand-primary) 3%, transparent);
    }
  }
  .bg-brand-primary\\/\\[0\\.08\\] {
    background-color: var(--color-brand-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-brand-primary) 8%, transparent);
    }
  }
  .bg-brand-secondary {
    background-color: var(--color-brand-secondary);
  }
  .bg-canvas {
    background-color: var(--color-canvas);
  }
  .bg-chip-objective-bg {
    background-color: var(--color-chip-objective-bg);
  }
  .bg-chip-scope-bg {
    background-color: var(--color-chip-scope-bg);
  }
  .bg-disabled-surface {
    background-color: var(--color-disabled-surface);
  }
  .bg-edb-accent {
    background-color: var(--color-edb-accent);
  }
  .bg-error {
    background-color: var(--color-error);
  }
  .bg-error-soft {
    background-color: var(--color-error-soft);
  }
  .bg-error\\/5 {
    background-color: var(--color-error);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-error) 5%, transparent);
    }
  }
  .bg-esa-accent {
    background-color: var(--color-esa-accent);
  }
  .bg-esa-accent-muted {
    background-color: var(--color-esa-accent-muted);
  }
  .bg-esa-hover {
    background-color: var(--color-esa-hover);
  }
  .bg-esa-panel {
    background-color: var(--color-esa-panel);
  }
  .bg-info {
    background-color: var(--color-info);
  }
  .bg-info-soft {
    background-color: var(--color-info-soft);
  }
  .bg-pg-btn-active-bg {
    background-color: var(--color-pg-btn-active-bg);
  }
  .bg-pg-btn-default-bg {
    background-color: var(--color-pg-btn-default-bg);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-secondary-soft {
    background-color: var(--color-secondary-soft);
  }
  .bg-shell-bar {
    background-color: var(--color-shell-bar);
  }
  .bg-shell-bar-top {
    background-color: var(--color-shell-bar-top);
  }
  .bg-success {
    background-color: var(--color-success);
  }
  .bg-success-soft {
    background-color: var(--color-success-soft);
  }
  .bg-success-strong {
    background-color: var(--color-success-strong);
  }
  .bg-surface {
    background-color: var(--color-surface);
  }
  .bg-surface-card {
    background-color: var(--color-surface-card);
  }
  .bg-surface-elevated {
    background-color: var(--color-surface-elevated);
  }
  .bg-surface-faint {
    background-color: var(--color-surface-faint);
  }
  .bg-surface-hover {
    background-color: var(--color-surface-hover);
  }
  .bg-surface-muted {
    background-color: var(--color-surface-muted);
  }
  .bg-surface-secondary {
    background-color: var(--color-surface-secondary);
  }
  .bg-surface-secondary\\/40 {
    background-color: var(--color-surface-secondary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-surface-secondary) 40%, transparent);
    }
  }
  .bg-surface-selected {
    background-color: var(--color-surface-selected);
  }
  .bg-surface\\/60 {
    background-color: var(--color-surface);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-surface) 60%, transparent);
    }
  }
  .bg-surface\\/70 {
    background-color: var(--color-surface);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-surface) 70%, transparent);
    }
  }
  .bg-text-muted {
    background-color: var(--color-text-muted);
  }
  .bg-text-secondary {
    background-color: var(--color-text-secondary);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-violet-pale-bg {
    background-color: var(--color-violet-pale-bg);
  }
  .bg-warning {
    background-color: var(--color-warning);
  }
  .bg-warning-soft {
    background-color: var(--color-warning-soft);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/10 {
    background-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .bg-gradient-to-b {
    --tw-gradient-position: to bottom in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-br {
    --tw-gradient-position: to bottom right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-r {
    --tw-gradient-position: to right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-t {
    --tw-gradient-position: to top in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[linear-gradient\\(90deg\\,\\#3b82f6_0\\%\\,\\#2563eb_100\\%\\)\\] {
    background-image: linear-gradient(90deg,#3b82f6 0%,#2563eb 100%);
  }
  .bg-\\[linear-gradient\\(160deg\\,\\#eef1f8_0\\%\\,\\#f5f7fc_50\\%\\,\\#e8edf8_100\\%\\)\\] {
    background-image: linear-gradient(160deg,#eef1f8 0%,#f5f7fc 50%,#e8edf8 100%);
  }
  .from-esa-accent {
    --tw-gradient-from: var(--color-esa-accent);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[var\\(--gaxl-indigo-light\\)\\] {
    --tw-gradient-to: var(--gaxl-indigo-light);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-canvas {
    --tw-gradient-to: var(--color-canvas);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-esa-accent {
    --tw-gradient-to: var(--color-esa-accent);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-transparent {
    --tw-gradient-to: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-clip-text {
    -webkit-background-clip: text;
            background-clip: text;
  }
  .bg-repeat {
    background-repeat: repeat;
  }
  .mask-no-clip {
    -webkit-mask-clip: no-clip;
            mask-clip: no-clip;
  }
  .mask-repeat {
    -webkit-mask-repeat: repeat;
            mask-repeat: repeat;
  }
  .fill-text-secondary {
    fill: var(--color-text-secondary);
  }
  .object-cover {
    -o-object-fit: cover;
       object-fit: cover;
  }
  .p-0 {
    padding: 0;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: var(--spacing-1);
  }
  .p-2 {
    padding: var(--spacing-2);
  }
  .p-3 {
    padding: var(--spacing-3);
  }
  .p-4 {
    padding: var(--spacing-4);
  }
  .p-5 {
    padding: var(--spacing-5);
  }
  .p-6 {
    padding: var(--spacing-6);
  }
  .p-8 {
    padding: var(--spacing-8);
  }
  .p-10 {
    padding: var(--spacing-10);
  }
  .p-\\[2px\\] {
    padding: 2px;
  }
  .p-\\[10px_8px_10px_6px\\] {
    padding: 10px 8px 10px 6px;
  }
  .p-\\[10px_12px\\] {
    padding: 10px 12px;
  }
  .p-\\[12px\\] {
    padding: 12px;
  }
  .p-\\[12px_14px\\] {
    padding: 12px 14px;
  }
  .p-\\[20px_24px\\] {
    padding: 20px 24px;
  }
  .p-\\[25px\\] {
    padding: 25px;
  }
  .\\!px-0 {
    padding-inline: 0 !important;
  }
  .\\!px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5) !important;
  }
  .\\!px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5) !important;
  }
  .\\!px-3 {
    padding-inline: var(--spacing-3) !important;
  }
  .px-1 {
    padding-inline: var(--spacing-1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: var(--spacing-2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: var(--spacing-3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: var(--spacing-4);
  }
  .px-5 {
    padding-inline: var(--spacing-5);
  }
  .px-6 {
    padding-inline: var(--spacing-6);
  }
  .px-8 {
    padding-inline: var(--spacing-8);
  }
  .px-10 {
    padding-inline: var(--spacing-10);
  }
  .px-18 {
    padding-inline: calc(var(--spacing) * 18);
  }
  .px-20 {
    padding-inline: calc(var(--spacing) * 20);
  }
  .px-\\[5px\\] {
    padding-inline: 5px;
  }
  .px-\\[6px\\] {
    padding-inline: 6px;
  }
  .px-\\[7px\\] {
    padding-inline: 7px;
  }
  .px-\\[8px\\] {
    padding-inline: 8px;
  }
  .px-\\[9px\\] {
    padding-inline: 9px;
  }
  .px-\\[10px\\] {
    padding-inline: 10px;
  }
  .px-\\[11px\\] {
    padding-inline: 11px;
  }
  .px-\\[12px\\] {
    padding-inline: 12px;
  }
  .px-\\[13px\\] {
    padding-inline: 13px;
  }
  .px-\\[14px\\] {
    padding-inline: 14px;
  }
  .px-\\[17px\\] {
    padding-inline: 17px;
  }
  .px-\\[18px\\] {
    padding-inline: 18px;
  }
  .px-\\[22px\\] {
    padding-inline: 22px;
  }
  .\\!py-0 {
    padding-block: 0 !important;
  }
  .\\!py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5) !important;
  }
  .\\!py-1 {
    padding-block: var(--spacing-1) !important;
  }
  .\\!py-2 {
    padding-block: var(--spacing-2) !important;
  }
  .py-0 {
    padding-block: 0;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: var(--spacing-1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: var(--spacing-2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: var(--spacing-3);
  }
  .py-4 {
    padding-block: var(--spacing-4);
  }
  .py-5 {
    padding-block: var(--spacing-5);
  }
  .py-6 {
    padding-block: var(--spacing-6);
  }
  .py-7 {
    padding-block: var(--spacing-7);
  }
  .py-8 {
    padding-block: var(--spacing-8);
  }
  .py-9 {
    padding-block: var(--spacing-9);
  }
  .py-10 {
    padding-block: var(--spacing-10);
  }
  .py-12 {
    padding-block: var(--spacing-12);
  }
  .py-13 {
    padding-block: var(--spacing-13);
  }
  .py-\\[0\\.5px\\] {
    padding-block: 0.5px;
  }
  .py-\\[1px\\] {
    padding-block: 1px;
  }
  .py-\\[2px\\] {
    padding-block: 2px;
  }
  .py-\\[3px\\] {
    padding-block: 3px;
  }
  .py-\\[4px\\] {
    padding-block: 4px;
  }
  .py-\\[5px\\] {
    padding-block: 5px;
  }
  .py-\\[6px\\] {
    padding-block: 6px;
  }
  .py-\\[8px\\] {
    padding-block: 8px;
  }
  .py-\\[9px\\] {
    padding-block: 9px;
  }
  .py-\\[10px\\] {
    padding-block: 10px;
  }
  .py-\\[11px\\] {
    padding-block: 11px;
  }
  .py-\\[13px\\] {
    padding-block: 13px;
  }
  .py-px {
    padding-block: 1px;
  }
  .pt-0 {
    padding-top: 0;
  }
  .pt-2 {
    padding-top: var(--spacing-2);
  }
  .pt-3 {
    padding-top: var(--spacing-3);
  }
  .pt-4 {
    padding-top: var(--spacing-4);
  }
  .pt-\\[7px\\] {
    padding-top: 7px;
  }
  .pt-\\[8px\\] {
    padding-top: 8px;
  }
  .pt-\\[9px\\] {
    padding-top: 9px;
  }
  .pt-\\[14px\\] {
    padding-top: 14px;
  }
  .pt-\\[var\\(--gaxl-space-4\\)\\] {
    padding-top: var(--gaxl-space-4);
  }
  .pr-1\\.5 {
    padding-right: calc(var(--spacing) * 1.5);
  }
  .pr-2 {
    padding-right: var(--spacing-2);
  }
  .pr-2\\.5 {
    padding-right: calc(var(--spacing) * 2.5);
  }
  .pr-3 {
    padding-right: var(--spacing-3);
  }
  .pr-5 {
    padding-right: var(--spacing-5);
  }
  .pr-10 {
    padding-right: var(--spacing-10);
  }
  .pr-24 {
    padding-right: calc(var(--spacing) * 24);
  }
  .pr-\\[9px\\] {
    padding-right: 9px;
  }
  .pr-\\[var\\(--gaxl-space-4\\)\\] {
    padding-right: var(--gaxl-space-4);
  }
  .pb-1\\.5 {
    padding-bottom: calc(var(--spacing) * 1.5);
  }
  .pb-2 {
    padding-bottom: var(--spacing-2);
  }
  .pb-3 {
    padding-bottom: var(--spacing-3);
  }
  .pb-4 {
    padding-bottom: var(--spacing-4);
  }
  .pb-5 {
    padding-bottom: var(--spacing-5);
  }
  .pb-8 {
    padding-bottom: var(--spacing-8);
  }
  .pb-\\[8px\\] {
    padding-bottom: 8px;
  }
  .pb-\\[12px\\] {
    padding-bottom: 12px;
  }
  .pl-0\\.5 {
    padding-left: calc(var(--spacing) * 0.5);
  }
  .pl-2 {
    padding-left: var(--spacing-2);
  }
  .pl-3 {
    padding-left: var(--spacing-3);
  }
  .pl-3\\.5 {
    padding-left: calc(var(--spacing) * 3.5);
  }
  .pl-4 {
    padding-left: var(--spacing-4);
  }
  .pl-5 {
    padding-left: var(--spacing-5);
  }
  .pl-9 {
    padding-left: var(--spacing-9);
  }
  .pl-10 {
    padding-left: var(--spacing-10);
  }
  .pl-\\[2px\\] {
    padding-left: 2px;
  }
  .pl-\\[13px\\] {
    padding-left: 13px;
  }
  .pl-\\[var\\(--gaxl-space-5\\)\\] {
    padding-left: var(--gaxl-space-5);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .align-top {
    vertical-align: top;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\\!text-\\[0\\.625rem\\] {
    font-size: 0.625rem !important;
  }
  .\\!text-\\[10px\\] {
    font-size: 10px !important;
  }
  .\\!text-\\[20px\\] {
    font-size: 20px !important;
  }
  .\\!text-\\[22px\\] {
    font-size: 22px !important;
  }
  .\\!text-body-md {
    font-size: var(--text-body-md) !important;
  }
  .\\!text-body-sm {
    font-size: var(--text-body-sm) !important;
  }
  .\\!text-caption {
    font-size: var(--text-caption) !important;
  }
  .\\!text-overline {
    font-size: var(--text-overline) !important;
  }
  .text-\\[1\\.35rem\\] {
    font-size: 1.35rem;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10\\.5px\\] {
    font-size: 10.5px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11\\.5px\\] {
    font-size: 11.5px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12\\.5px\\] {
    font-size: 12.5px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13\\.5px\\] {
    font-size: 13.5px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[14px\\] {
    font-size: 14px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[18px\\] {
    font-size: 18px;
  }
  .text-\\[20px\\] {
    font-size: 20px;
  }
  .text-\\[22px\\] {
    font-size: 22px;
  }
  .text-\\[24px\\] {
    font-size: 24px;
  }
  .text-\\[32px\\] {
    font-size: 32px;
  }
  .text-body-lg {
    font-size: var(--text-body-lg);
  }
  .text-body-md {
    font-size: var(--text-body-md);
  }
  .text-body-sm {
    font-size: var(--text-body-sm);
  }
  .text-caption {
    font-size: var(--text-caption);
  }
  .text-display-l {
    font-size: var(--text-display-l);
  }
  .text-display-xl {
    font-size: var(--text-display-xl);
  }
  .text-heading-l {
    font-size: var(--text-heading-l);
  }
  .text-heading-m {
    font-size: var(--text-heading-m);
  }
  .text-heading-s {
    font-size: var(--text-heading-s);
  }
  .text-heading-xl {
    font-size: var(--text-heading-xl);
  }
  .text-label {
    font-size: var(--text-label);
  }
  .text-overline {
    font-size: var(--text-overline);
  }
  .text-title {
    font-size: var(--text-title);
  }
  .\\!leading-none {
    --tw-leading: 1 !important;
    line-height: 1 !important;
  }
  .\\!leading-snug {
    --tw-leading: var(--leading-snug) !important;
    line-height: var(--leading-snug) !important;
  }
  .leading-\\[1\\.4\\] {
    --tw-leading: 1.4;
    line-height: 1.4;
  }
  .leading-\\[1\\.5\\] {
    --tw-leading: 1.5;
    line-height: 1.5;
  }
  .leading-\\[1\\.45\\] {
    --tw-leading: 1.45;
    line-height: 1.45;
  }
  .leading-\\[var\\(--gaxl-leading-snug\\)\\] {
    --tw-leading: var(--gaxl-leading-snug);
    line-height: var(--gaxl-leading-snug);
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .\\!font-bold {
    --tw-font-weight: var(--font-weight-bold) !important;
    font-weight: var(--font-weight-bold) !important;
  }
  .\\!font-medium {
    --tw-font-weight: var(--font-weight-medium) !important;
    font-weight: var(--font-weight-medium) !important;
  }
  .\\!font-normal {
    --tw-font-weight: var(--font-weight-normal) !important;
    font-weight: var(--font-weight-normal) !important;
  }
  .\\!font-semibold {
    --tw-font-weight: var(--font-weight-semibold) !important;
    font-weight: var(--font-weight-semibold) !important;
  }
  .font-\\[650\\] {
    --tw-font-weight: 650;
    font-weight: 650;
  }
  .font-\\[800\\] {
    --tw-font-weight: 800;
    font-weight: 800;
  }
  .font-\\[number\\:var\\(--gaxl-weight-semibold\\)\\] {
    --tw-font-weight: var(--gaxl-weight-semibold);
    font-weight: var(--gaxl-weight-semibold);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-regular {
    --tw-font-weight: var(--font-weight-regular);
    font-weight: var(--font-weight-regular);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[0\\.1px\\] {
    --tw-tracking: 0.1px;
    letter-spacing: 0.1px;
  }
  .tracking-\\[0\\.3px\\] {
    --tw-tracking: 0.3px;
    letter-spacing: 0.3px;
  }
  .tracking-\\[0\\.4px\\] {
    --tw-tracking: 0.4px;
    letter-spacing: 0.4px;
  }
  .tracking-\\[0\\.5px\\] {
    --tw-tracking: 0.5px;
    letter-spacing: 0.5px;
  }
  .tracking-\\[0\\.6px\\] {
    --tw-tracking: 0.6px;
    letter-spacing: 0.6px;
  }
  .tracking-\\[0\\.08em\\] {
    --tw-tracking: 0.08em;
    letter-spacing: 0.08em;
  }
  .tracking-normal {
    --tw-tracking: var(--tracking-normal);
    letter-spacing: var(--tracking-normal);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-tighter {
    --tw-tracking: var(--tracking-tighter);
    letter-spacing: var(--tracking-tighter);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .text-clip {
    text-overflow: clip;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .\\!text-\\[var\\(--gaxl-edb-accent\\)\\] {
    color: var(--gaxl-edb-accent) !important;
  }
  .\\!text-error {
    color: var(--color-error) !important;
  }
  .\\!text-surface {
    color: var(--color-surface) !important;
  }
  .\\!text-text-primary {
    color: var(--color-text-primary) !important;
  }
  .\\!text-text-secondary {
    color: var(--color-text-secondary) !important;
  }
  .text-\\[var\\(--gaxl-brand-on-primary\\)\\] {
    color: var(--gaxl-brand-on-primary);
  }
  .text-\\[var\\(--gaxl-brand-primary\\)\\] {
    color: var(--gaxl-brand-primary);
  }
  .text-\\[var\\(--gaxl-edb-accent\\)\\] {
    color: var(--gaxl-edb-accent);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-border-default {
    color: var(--color-border-default);
  }
  .text-border-strong {
    color: var(--color-border-strong);
  }
  .text-brand-on-primary {
    color: var(--color-brand-on-primary);
  }
  .text-brand-primary {
    color: var(--color-brand-primary);
  }
  .text-brand-primary-hover {
    color: var(--color-brand-primary-hover);
  }
  .text-brand-secondary {
    color: var(--color-brand-secondary);
  }
  .text-canvas {
    color: var(--color-canvas);
  }
  .text-catalog-channel {
    color: var(--color-catalog-channel);
  }
  .text-chip-objective-fg {
    color: var(--color-chip-objective-fg);
  }
  .text-chip-scope-fg {
    color: var(--color-chip-scope-fg);
  }
  .text-current {
    color: currentcolor;
  }
  .text-error {
    color: var(--color-error);
  }
  .text-esa-accent {
    color: var(--color-esa-accent);
  }
  .text-esa-hover {
    color: var(--color-esa-hover);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-info {
    color: var(--color-info);
  }
  .text-info-text {
    color: var(--color-info-text);
  }
  .text-pg-btn-active-fg {
    color: var(--color-pg-btn-active-fg);
  }
  .text-pg-btn-default-fg {
    color: var(--color-pg-btn-default-fg);
  }
  .text-pg-btn-disabled-fg {
    color: var(--color-pg-btn-disabled-fg);
  }
  .text-pg-label-fg {
    color: var(--color-pg-label-fg);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-success {
    color: var(--color-success);
  }
  .text-success-strong {
    color: var(--color-success-strong);
  }
  .text-success-text {
    color: var(--color-success-text);
  }
  .text-surface {
    color: var(--color-surface);
  }
  .text-text-inverse {
    color: var(--color-text-inverse);
  }
  .text-text-link {
    color: var(--color-text-link);
  }
  .text-text-muted {
    color: var(--color-text-muted);
  }
  .text-text-primary {
    color: var(--color-text-primary);
  }
  .text-text-secondary {
    color: var(--color-text-secondary);
  }
  .text-text-tertiary {
    color: var(--color-text-tertiary);
  }
  .text-transparent {
    color: transparent;
  }
  .text-violet-600 {
    color: var(--color-violet-600);
  }
  .text-visit-pt-ot {
    color: var(--color-visit-pt-ot);
  }
  .text-visit-routine {
    color: var(--color-visit-routine);
  }
  .text-visit-start-of-care {
    color: var(--color-visit-start-of-care);
  }
  .text-visit-supervisory {
    color: var(--color-visit-supervisory);
  }
  .text-warning {
    color: var(--color-warning);
  }
  .text-warning-text {
    color: var(--color-warning-text);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/70 {
    color: color-mix(in srgb, #fff 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 70%, transparent);
    }
  }
  .\\!capitalize {
    text-transform: capitalize !important;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .normal-case {
    text-transform: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .not-italic {
    font-style: normal;
  }
  .diagonal-fractions {
    --tw-numeric-fraction: diagonal-fractions;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .lining-nums {
    --tw-numeric-figure: lining-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .oldstyle-nums {
    --tw-numeric-figure: oldstyle-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .ordinal {
    --tw-ordinal: ordinal;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .proportional-nums {
    --tw-numeric-spacing: proportional-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .slashed-zero {
    --tw-slashed-zero: slashed-zero;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .stacked-fractions {
    --tw-numeric-fraction: stacked-fractions;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .normal-nums {
    font-variant-numeric: normal;
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .no-underline {
    text-decoration-line: none;
  }
  .overline {
    text-decoration-line: overline;
  }
  .underline {
    text-decoration-line: underline;
  }
  .decoration-current {
    text-decoration-color: currentcolor;
  }
  .underline-offset-2 {
    text-underline-offset: 2px;
  }
  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  .placeholder-gray-400 {
    &::-moz-placeholder {
      color: var(--color-gray-400);
    }
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .placeholder-text-tertiary {
    &::-moz-placeholder {
      color: var(--color-text-tertiary);
    }
    &::placeholder {
      color: var(--color-text-tertiary);
    }
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-10 {
    opacity: 10%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-30 {
    opacity: 30%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-75 {
    opacity: 75%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .\\!shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_0_1px_var\\(--gaxl-brand-primary\\)\\] {
    --tw-shadow: 0 0 0 1px var(--tw-shadow-color, var(--gaxl-brand-primary));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_0_0_2px_var\\(--gaxl-brand-primary-subtle\\)\\] {
    --tw-shadow: 0 0 0 2px var(--tw-shadow-color, var(--gaxl-brand-primary-subtle));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_4px_32px_0_rgba\\(60\\,80\\,160\\,0\\.10\\)\\,0_1\\.5px_6px_0_rgba\\(60\\,80\\,160\\,0\\.06\\)\\] {
    --tw-shadow: 0 4px 32px 0 var(--tw-shadow-color, rgba(60,80,160,0.10)), 0 1.5px 6px 0 var(--tw-shadow-color, rgba(60,80,160,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[var\\(--gaxl-shadow-lg\\)\\] {
    --tw-shadow: var(--gaxl-shadow-lg);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: var(--gaxl-shadow-lg);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: var(--gaxl-shadow-md);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-overlay {
    --tw-shadow: var(--gaxl-shadow-overlay);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: var(--gaxl-shadow-sm);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: var(--gaxl-shadow-xl);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: var(--gaxl-shadow-xs);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .inset-ring {
    --tw-inset-ring-shadow: inset 0 0 0 1px var(--tw-inset-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-border-default {
    --tw-ring-color: var(--color-border-default);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.1))) drop-shadow(0 1px 1px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.06)));
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow( 0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur {
    --tw-backdrop-blur: blur(8px);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(var(--blur-md));
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-grayscale {
    --tw-backdrop-grayscale: grayscale(100%);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-invert {
    --tw-backdrop-invert: invert(100%);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-sepia {
    --tw-backdrop-sepia: sepia(100%);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-filter {
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[border-color\\,box-shadow\\,transform\\] {
    transition-property: border-color,box-shadow,transform;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[transform\\,color\\] {
    transition-property: transform,color;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-\\[var\\(--gaxl-duration-base\\)\\] {
    --tw-duration: var(--gaxl-duration-base);
    transition-duration: var(--gaxl-duration-base);
  }
  .duration-base {
    --tw-duration: var(--transition-duration-base);
    transition-duration: var(--transition-duration-base);
  }
  .duration-fast {
    --tw-duration: var(--transition-duration-fast);
    transition-duration: var(--transition-duration-fast);
  }
  .duration-instant {
    --tw-duration: var(--transition-duration-instant);
    transition-duration: var(--transition-duration-instant);
  }
  .duration-slow {
    --tw-duration: var(--transition-duration-slow);
    transition-duration: var(--transition-duration-slow);
  }
  .duration-slower {
    --tw-duration: var(--transition-duration-slower);
    transition-duration: var(--transition-duration-slower);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-all {
    -webkit-user-select: all;
    -moz-user-select: all;
         user-select: all;
  }
  .select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
         user-select: none;
  }
  .\\[animation-delay\\:-0\\.3s\\] {
    animation-delay: -0.3s;
  }
  .\\[animation-delay\\:-0\\.15s\\] {
    animation-delay: -0.15s;
  }
  .divide-x-reverse {
    :where(& > :not(:last-child)) {
      --tw-divide-x-reverse: 1;
    }
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  .group-hover\\:block {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        display: block;
      }
    }
  }
  .group-hover\\:border-esa-accent {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        border-color: var(--color-esa-accent);
      }
    }
  }
  .group-hover\\:bg-esa-accent {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-esa-accent);
      }
    }
  }
  .group-hover\\:text-brand-on-primary {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-brand-on-primary);
      }
    }
  }
  .group-hover\\:text-brand-primary\\/60 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-brand-primary);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-brand-primary) 60%, transparent);
        }
      }
    }
  }
  .group-hover\\:text-text-primary {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-text-primary);
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .placeholder\\:text-border-default {
    &::-moz-placeholder {
      color: var(--color-border-default);
    }
    &::placeholder {
      color: var(--color-border-default);
    }
  }
  .placeholder\\:text-text-disabled {
    &::-moz-placeholder {
      color: var(--color-text-disabled);
    }
    &::placeholder {
      color: var(--color-text-disabled);
    }
  }
  .placeholder\\:text-text-muted {
    &::-moz-placeholder {
      color: var(--color-text-muted);
    }
    &::placeholder {
      color: var(--color-text-muted);
    }
  }
  .placeholder\\:text-text-tertiary {
    &::-moz-placeholder {
      color: var(--color-text-tertiary);
    }
    &::placeholder {
      color: var(--color-text-tertiary);
    }
  }
  .first\\:rounded-t-lg {
    &:first-child {
      border-top-left-radius: var(--radius-lg);
      border-top-right-radius: var(--radius-lg);
    }
  }
  .first\\:border-t-0 {
    &:first-child {
      border-top-style: var(--tw-border-style);
      border-top-width: 0px;
    }
  }
  .last\\:mb-0 {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .last\\:rounded-b-lg {
    &:last-child {
      border-bottom-right-radius: var(--radius-lg);
      border-bottom-left-radius: var(--radius-lg);
    }
  }
  .last\\:border-b-0 {
    &:last-child {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
  }
  .focus-within\\:border-border-focus {
    &:focus-within {
      border-color: var(--color-border-focus);
    }
  }
  .focus-within\\:bg-brand-primary-soft {
    &:focus-within {
      background-color: var(--color-brand-primary-soft);
    }
  }
  .hover\\:-translate-y-0\\.5 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:-translate-y-px {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: -1px;
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .hover\\:scale-105 {
    &:hover {
      @media (hover: hover) {
        --tw-scale-x: 105%;
        --tw-scale-y: 105%;
        --tw-scale-z: 105%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .hover\\:border-\\[var\\(--gaxl-border-hover\\)\\] {
    &:hover {
      @media (hover: hover) {
        border-color: var(--gaxl-border-hover);
      }
    }
  }
  .hover\\:border-border-default {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-border-default);
      }
    }
  }
  .hover\\:border-border-strong {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-border-strong);
      }
    }
  }
  .hover\\:border-brand-primary {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-brand-primary);
      }
    }
  }
  .hover\\:border-brand-primary-hover {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-brand-primary-hover);
      }
    }
  }
  .hover\\:border-brand-primary\\/60 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-brand-primary);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-brand-primary) 60%, transparent);
        }
      }
    }
  }
  .hover\\:border-brand-secondary {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-brand-secondary);
      }
    }
  }
  .hover\\:border-error {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-error);
      }
    }
  }
  .hover\\:border-error-700 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-error-700);
      }
    }
  }
  .hover\\:border-esa-accent {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-esa-accent);
      }
    }
  }
  .hover\\:border-esa-hover {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-esa-hover);
      }
    }
  }
  .hover\\:border-info {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-info);
      }
    }
  }
  .hover\\:border-success {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-success);
      }
    }
  }
  .hover\\:border-success-strong-hover {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-success-strong-hover);
      }
    }
  }
  .hover\\:border-text-tertiary {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-text-tertiary);
      }
    }
  }
  .hover\\:border-warning {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-warning);
      }
    }
  }
  .hover\\:\\!bg-surface-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-surface-hover) !important;
      }
    }
  }
  .hover\\:bg-\\[rgba\\(124\\,58\\,237\\,0\\.1\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: rgba(124,58,237,0.1);
      }
    }
  }
  .hover\\:bg-brand-primary-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brand-primary-hover);
      }
    }
  }
  .hover\\:bg-brand-primary-soft {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brand-primary-soft);
      }
    }
  }
  .hover\\:bg-brand-primary\\/15 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brand-primary);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-brand-primary) 15%, transparent);
        }
      }
    }
  }
  .hover\\:bg-brand-primary\\/\\[0\\.06\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-brand-primary);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-brand-primary) 6%, transparent);
        }
      }
    }
  }
  .hover\\:bg-canvas {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-canvas);
      }
    }
  }
  .hover\\:bg-error-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-error-700);
      }
    }
  }
  .hover\\:bg-esa-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-esa-accent);
      }
    }
  }
  .hover\\:bg-esa-accent-muted {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-esa-accent-muted);
      }
    }
  }
  .hover\\:bg-esa-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-esa-hover);
      }
    }
  }
  .hover\\:bg-pg-btn-hover-bg {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-pg-btn-hover-bg);
      }
    }
  }
  .hover\\:bg-success-strong-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-success-strong-hover);
      }
    }
  }
  .hover\\:bg-surface {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-surface);
      }
    }
  }
  .hover\\:bg-surface-hover {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-surface-hover);
      }
    }
  }
  .hover\\:bg-surface-muted {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-surface-muted);
      }
    }
  }
  .hover\\:bg-surface-secondary {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-surface-secondary);
      }
    }
  }
  .hover\\:bg-white\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
        }
      }
    }
  }
  .hover\\:text-brand-on-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-brand-on-primary);
      }
    }
  }
  .hover\\:text-error {
    &:hover {
      @media (hover: hover) {
        color: var(--color-error);
      }
    }
  }
  .hover\\:text-esa-accent {
    &:hover {
      @media (hover: hover) {
        color: var(--color-esa-accent);
      }
    }
  }
  .hover\\:text-gray-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-600);
      }
    }
  }
  .hover\\:text-surface {
    &:hover {
      @media (hover: hover) {
        color: var(--color-surface);
      }
    }
  }
  .hover\\:text-text-inverse {
    &:hover {
      @media (hover: hover) {
        color: var(--color-text-inverse);
      }
    }
  }
  .hover\\:text-text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-text-primary);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-90 {
    &:hover {
      @media (hover: hover) {
        opacity: 90%;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-\\[var\\(--gaxl-shadow-md\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: var(--gaxl-shadow-md);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-sm {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: var(--gaxl-shadow-sm);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:brightness-\\[0\\.97\\] {
    &:hover {
      @media (hover: hover) {
        --tw-brightness: brightness(0.97);
        filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
      }
    }
  }
  .focus\\:border-blue-500 {
    &:focus {
      border-color: var(--color-blue-500);
    }
  }
  .focus\\:border-text-primary {
    &:focus {
      border-color: var(--color-text-primary);
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-info-border {
    &:focus {
      --tw-ring-color: var(--color-info-border);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus-visible\\:bg-surface-hover {
    &:focus-visible {
      background-color: var(--color-surface-hover);
    }
  }
  .focus-visible\\:shadow-\\[var\\(--gaxl-focus-ring\\)\\] {
    &:focus-visible {
      --tw-shadow: var(--gaxl-focus-ring);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-\\[3px\\] {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-\\[var\\(--gaxl-focus-ring\\)\\] {
    &:focus-visible {
      --tw-ring-color: var(--gaxl-focus-ring);
    }
  }
  .focus-visible\\:ring-border-focus {
    &:focus-visible {
      --tw-ring-color: var(--color-border-focus);
    }
  }
  .focus-visible\\:ring-border-strong {
    &:focus-visible {
      --tw-ring-color: var(--color-border-strong);
    }
  }
  .focus-visible\\:ring-brand-primary {
    &:focus-visible {
      --tw-ring-color: var(--color-brand-primary);
    }
  }
  .focus-visible\\:ring-brand-secondary {
    &:focus-visible {
      --tw-ring-color: var(--color-brand-secondary);
    }
  }
  .focus-visible\\:ring-error {
    &:focus-visible {
      --tw-ring-color: var(--color-error);
    }
  }
  .focus-visible\\:ring-esa-accent {
    &:focus-visible {
      --tw-ring-color: var(--color-esa-accent);
    }
  }
  .focus-visible\\:ring-info {
    &:focus-visible {
      --tw-ring-color: var(--color-info);
    }
  }
  .focus-visible\\:ring-success {
    &:focus-visible {
      --tw-ring-color: var(--color-success);
    }
  }
  .focus-visible\\:ring-warning {
    &:focus-visible {
      --tw-ring-color: var(--color-warning);
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .active\\:scale-95 {
    &:active {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .active\\:scale-\\[0\\.99\\] {
    &:active {
      scale: 0.99;
    }
  }
  .active\\:cursor-grabbing {
    &:active {
      cursor: grabbing;
    }
  }
  .active\\:bg-brand-primary-active {
    &:active {
      background-color: var(--color-brand-primary-active);
    }
  }
  .active\\:bg-brand-primary-subtle {
    &:active {
      background-color: var(--color-brand-primary-subtle);
    }
  }
  .active\\:bg-error-700 {
    &:active {
      background-color: var(--color-error-700);
    }
  }
  .active\\:bg-success-700 {
    &:active {
      background-color: var(--color-success-700);
    }
  }
  .active\\:bg-surface-secondary {
    &:active {
      background-color: var(--color-surface-secondary);
    }
  }
  .active\\:text-surface {
    &:active {
      color: var(--color-surface);
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:border-border-default {
    &:disabled {
      border-color: var(--color-border-default);
    }
  }
  .disabled\\:bg-disabled-surface {
    &:disabled {
      background-color: var(--color-disabled-surface);
    }
  }
  .disabled\\:text-text-tertiary {
    &:disabled {
      color: var(--color-text-tertiary);
    }
  }
  .disabled\\:opacity-40 {
    &:disabled {
      opacity: 40%;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60%;
    }
  }
  .disabled\\:opacity-75 {
    &:disabled {
      opacity: 75%;
    }
  }
  .disabled\\:hover\\:border-border-default {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          border-color: var(--color-border-default);
        }
      }
    }
  }
  .disabled\\:hover\\:bg-disabled-surface {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-disabled-surface);
        }
      }
    }
  }
  .disabled\\:hover\\:bg-transparent {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: transparent;
        }
      }
    }
  }
  .motion-safe\\:animate-pulse {
    @media (prefers-reduced-motion: no-preference) {
      animation: var(--animate-pulse);
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:text-2xl {
    @media (width >= 48rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .md\\:text-3xl {
    @media (width >= 48rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .md\\:text-4xl {
    @media (width >= 48rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .md\\:text-base {
    @media (width >= 48rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .md\\:text-lg {
    @media (width >= 48rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .md\\:text-xl {
    @media (width >= 48rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .md\\:text-\\[14px\\] {
    @media (width >= 48rem) {
      font-size: 14px;
    }
  }
  .md\\:text-\\[18px\\] {
    @media (width >= 48rem) {
      font-size: 18px;
    }
  }
  .md\\:text-\\[20px\\] {
    @media (width >= 48rem) {
      font-size: 20px;
    }
  }
  .md\\:text-body-sm {
    @media (width >= 48rem) {
      font-size: var(--text-body-sm);
    }
  }
  .\\[\\&_\\[data-testid\\=numbered-pagination-label\\]\\]\\:hidden {
    & [data-testid=numbered-pagination-label] {
      display: none;
    }
  }
  .\\[\\&_\\[data-testid\\=step-pagination-label\\]\\]\\:hidden {
    & [data-testid=step-pagination-label] {
      display: none;
    }
  }
  .\\[\\&_button\\]\\:\\!gap-2 {
    & button {
      gap: var(--spacing-2) !important;
    }
  }
  .\\[\\&_button\\]\\:\\!px-2\\.5 {
    & button {
      padding-inline: calc(var(--spacing) * 2.5) !important;
    }
  }
  .\\[\\&_button\\]\\:\\!py-1\\.5 {
    & button {
      padding-block: calc(var(--spacing) * 1.5) !important;
    }
  }
  .\\[\\&_button\\]\\:\\!text-overline {
    & button {
      font-size: var(--text-overline) !important;
    }
  }
  .\\[\\&_button\\]\\:\\!leading-snug {
    & button {
      --tw-leading: var(--leading-snug) !important;
      line-height: var(--leading-snug) !important;
    }
  }
  .\\[\\&_button\\]\\:\\!font-medium {
    & button {
      --tw-font-weight: var(--font-weight-medium) !important;
      font-weight: var(--font-weight-medium) !important;
    }
  }
  .\\[\\&_button\\>span\\:last-child\\]\\:\\!min-w-0 {
    & button>span:last-child {
      min-width: 0 !important;
    }
  }
  .\\[\\&_button\\>span\\:last-child\\]\\:\\!truncate {
    & button>span:last-child {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
    }
  }
  .\\[\\&_code\\]\\:rounded {
    & code {
      border-radius: 0.25rem;
    }
  }
  .\\[\\&_code\\]\\:bg-surface-secondary {
    & code {
      background-color: var(--color-surface-secondary);
    }
  }
  .\\[\\&_code\\]\\:px-1 {
    & code {
      padding-inline: var(--spacing-1);
    }
  }
  .\\[\\&_code\\]\\:py-0\\.5 {
    & code {
      padding-block: calc(var(--spacing) * 0.5);
    }
  }
  .\\[\\&_code\\]\\:font-mono {
    & code {
      font-family: var(--font-mono);
    }
  }
  .\\[\\&_code\\]\\:text-xs {
    & code {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
  }
  .\\[\\&_input\\]\\:\\!border-none {
    & input {
      --tw-border-style: none !important;
      border-style: none !important;
    }
  }
  .\\[\\&_input\\]\\:\\!bg-transparent {
    & input {
      background-color: transparent !important;
    }
  }
  .\\[\\&_input\\]\\:\\!shadow-none {
    & input {
      --tw-shadow: 0 0 #0000 !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .\\[\\&_input\\]\\:\\!outline-none {
    & input {
      --tw-outline-style: none !important;
      outline-style: none !important;
    }
  }
  .\\[\\&_strong\\]\\:font-semibold {
    & strong {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
  }
  .\\[\\&_svg\\]\\:fill-\\[var\\(--gaxl-edb-accent\\)\\] {
    & svg {
      fill: var(--gaxl-edb-accent);
    }
  }
  .\\[\\&_svg\\]\\:stroke-\\[var\\(--gaxl-edb-accent\\)\\] {
    & svg {
      stroke: var(--gaxl-edb-accent);
    }
  }
  .\\[\\&\\>span\\:first-child\\]\\:\\!min-w-0 {
    &>span:first-child {
      min-width: 0 !important;
    }
  }
  .\\[\\&\\>span\\:first-child\\]\\:\\!flex-1 {
    &>span:first-child {
      flex: 1 !important;
    }
  }
  .\\[\\&\\>span\\:first-child_span\\]\\:\\!text-overline {
    &>span:first-child span {
      font-size: var(--text-overline) !important;
    }
  }
  .\\[\\&\\>span\\:first-child_span\\]\\:\\!font-medium {
    &>span:first-child span {
      --tw-font-weight: var(--font-weight-medium) !important;
      font-weight: var(--font-weight-medium) !important;
    }
  }
  .\\[\\&\\>span\\:last-child_svg\\]\\:\\!h-3\\.5 {
    &>span:last-child svg {
      height: calc(var(--spacing) * 3.5) !important;
    }
  }
  .\\[\\&\\>span\\:last-child_svg\\]\\:\\!w-3\\.5 {
    &>span:last-child svg {
      width: calc(var(--spacing) * 3.5) !important;
    }
  }
  .\\[\\&\\>span\\:last-child_svg\\]\\:\\!text-text-tertiary {
    &>span:last-child svg {
      color: var(--color-text-tertiary) !important;
    }
  }
}
html,
body,
#root {
  height: 100%;
  margin: 0;
}
html[data-theme='light'] {
  color-scheme: light;
}
html[data-theme='dark'] {
  color-scheme: dark;
}
body {
  font-family: var(--gaxl-font-sans, system-ui, sans-serif);
  background: var(--gaxl-canvas);
  color: var(--gaxl-text-primary);
}
.esa-chip-transition {
  transition: background var(--gaxl-duration-fast) var(--gaxl-ease-standard),
    color var(--gaxl-duration-fast) var(--gaxl-ease-standard),
    border-color var(--gaxl-duration-fast) var(--gaxl-ease-standard);
}
.esa-chip-idle:not(:disabled):hover {
  background: var(--gaxl-esa-suggestion-gradient);
  color: var(--gaxl-brand-on-primary);
  border-color: transparent;
}
.esa-chip-filled:not(:disabled):hover {
  background-color: var(--color-esa-hover);
}
[role='tablist'] button:not(:disabled) {
  cursor: pointer !important;
}
button[aria-haspopup='listbox']:not(:disabled),
button[aria-haspopup='menu']:not(:disabled),
button[aria-haspopup='dialog']:not(:disabled),
[role='listbox'] button,
[role='menu'] [role='menuitem'],
[data-testid^='waffle-card-'] {
  cursor: pointer !important;
}
.esa-suggestion-strip::before,
.esa-suggestion-strip::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 28px;
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  transition: opacity var(--gaxl-duration-fast) var(--gaxl-ease-standard);
}
.esa-suggestion-strip::before {
  left: 0;
  background: linear-gradient(to right, var(--gaxl-esa-panel), transparent);
}
.esa-suggestion-strip::after {
  right: 0;
  background: linear-gradient(to left, var(--gaxl-esa-panel), transparent);
}
.esa-suggestion-strip--fade-left::before,
.esa-suggestion-strip--fade-right::after {
  opacity: 1;
}
[data-testid='global-header'] {
  box-sizing: border-box;
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  flex-shrink: 0;
  overflow: visible;
  background-color: var(--gaxl-shell-bar-top);
}
html[data-theme='dark'] [data-testid='global-header'] {
  background-color: var(--gaxl-surface-header);
}
.esa-panel-shell {
  flex-shrink: 0;
}
.esa-canvas-divider-handle {
  padding: 0 !important;
  margin: 0 !important;
}
.esa-canvas-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6px;
  height: 100%;
  min-height: 100%;
  flex-shrink: 0;
  background: var(--gaxl-splitter-idle);
  border-right: 1px solid var(--gaxl-border-default);
  box-sizing: border-box;
}
.esa-canvas-divider__grip {
  display: block;
  width: 2px;
  height: var(--gaxl-space-6);
  border-radius: var(--gaxl-radius-full);
  background-color: var(--gaxl-splitter-grip);
}
[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar) {
  scrollbar-width: thin;
  scrollbar-color: var(--gaxl-zinc-300) transparent;
}
[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar-thumb {
  background-color: var(--gaxl-zinc-300);
  border-radius: var(--gaxl-radius-full);
}
[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar-track {
  background: transparent;
}
.Toastify__toast.gaxl-success-action-toast {
  background: transparent;
  box-shadow: none;
  padding: 0;
  min-height: 0;
  width: min(360px, calc(100vw - 24px));
  margin-bottom: 12px;
}
.Toastify__toast.gaxl-success-action-toast .Toastify__toast-body,
.gaxl-success-action-toast__body {
  margin: 0;
  padding: 0;
  width: 100%;
}
.Toastify__toast.gaxl-success-action-toast .Toastify__toast-icon {
  display: none;
}
.Toastify__toast.gaxl-success-action-toast [data-testid='success-action-toast-link'],
.Toastify__toast.gaxl-success-action-toast [data-testid='success-action-toast-link'] * {
  cursor: pointer;
}
.Toastify__toast.gaxl-success-action-toast .Toastify__progress-bar--wrp {
  opacity: 0;
  pointer-events: none;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-x {
  syntax: "*";
  inherits: false;
}
@property --tw-pan-y {
  syntax: "*";
  inherits: false;
}
@property --tw-pinch-zoom {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-pan-x: initial;
      --tw-pan-y: initial;
      --tw-pinch-zoom: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-x-reverse: 0;
      --tw-border-style: solid;
      --tw-divide-y-reverse: 0;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./node_modules/@growthaxl/web-foundation/dist/styles/llc.css","webpack://./node_modules/@growthaxl/web-foundation/dist/styles/tailwind-theme.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;ACv6BrB;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EAExB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAE1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAE3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAE3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAE3B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EAEzB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EAGxB,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAG3B,0CAA0C;EAC1C,gDAAgD;EAChD,iDAAiD;EACjD,8CAA8C;EAC9C,iDAAiD;EACjD,8CAA8C;EAC9C,8CAA8C;EAC9C,2CAA2C;EAE3C,qCAAqC;EACrC,qCAAqC;EACrC,iDAAiD;EACjD,0CAA0C;EAC1C,8CAA8C;EAC9C,4CAA4C;EAC5C,2CAA2C;EAC3C,+CAA+C;EAC/C,6CAA6C;EAC7C,4CAA4C;EAC5C,oCAAoC;EAEpC,4CAA4C;EAC5C,8CAA8C;EAC9C,6CAA6C;EAC7C,6CAA6C;EAC7C,0BAA0B;EAC1B,0CAA0C;EAC1C,sCAAsC;EAEtC,8CAA8C;EAC9C,6CAA6C;EAC7C,yCAAyC;EACzC,4CAA4C;EAC5C,oDAAoD;EAEpD,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,iCAAiC;EAEjC,+CAA+C;EAC/C,8CAA8C;EAC9C,4CAA4C;EAE5C,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EAGrC,2CAA2C;EAC3C,8CAA8C;EAC9C,4CAA4C;EAC5C,2CAA2C;EAC3C,8CAA8C;EAC9C,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;EAC1C,wCAAwC;EACxC,qCAAqC;EACrC,wCAAwC;EACxC,sCAAsC;EAGtC,gDAAgD;EAChD,mDAAmD;EACnD,0CAA0C;EAC1C,2CAA2C;EAE3C,uCAAuC;EACvC,yCAAyC;EACzC,+CAA+C;EAC/C,wCAAwC;EACxC,8CAA8C;EAC9C,8CAA8C;EAC9C;;;;GAIC;EAED,6CAA6C;EAC7C,4CAA4C;EAC5C,gDAAgD;EAChD,gDAAgD;EAChD,kDAAkD;EAElD,yCAAyC;EACzC,wCAAwC;EACxC,6CAA6C;EAC7C,gDAAgD;EAChD,+CAA+C;EAC/C,oDAAoD;EAEpD,qCAAqC;EACrC,sCAAsC;EACtC,kCAAkC;EAElC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EAExC,uCAAuC;EACvC,2CAA2C;EAC3C,6CAA6C;EAC7C,kDAAkD;EAElD,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,6CAA6C;EAE7C,kDAAkD;EAClD,8CAA8C;EAC9C,8CAA8C;EAC9C,oDAAoD;EACpD,0CAA0C;EAG1C,uGACuF;EACvF,qGACqF;EAErF,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EAEvB,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAE3B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAE3B,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAEhC,6DAA6D;EAC7D,6DAA6D;EAC7D,0DAA0D;EAC1D,6DAA6D;EAC7D,6DAA6D;EAC7D,6DAA6D;EAC7D,qDAAqD;EACrD,yDAAyD;EACzD,0DAA0D;EAC1D,0DAA0D;EAG1D,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EAGrB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAG1B,kDAAkD;EAClD,oFAAoF;EACpF,6FAA6F;EAC7F,gGAAgG;EAChG,iGAAiG;EACjG,+DAA+D;EAE/D,wBAAwB;EACxB,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EAGzC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAE7B,gDAAgD;EAChD,qDAAqD;EACrD,kDAAkD;EAClD,gDAAgD;EAEhD;;oEAGkE;EAClE,0FAA0F;EAG1F,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAG5B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAG7B,uCAAuC;EACvC,mDAAmD;EACnD,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;EAC3B,0CAA0C;EAC1C,2BAA2B;EAC3B,2BAA2B;EAC3B,iDAAiD;EACjD,iDAAiD;EACjD,iDAAiD;EACjD,gDAAgD;EAChD,4DAA4D;EAC5D,8DAA8D;EAC9D,mDAAmD;EACnD,4CAA4C;EAC5C,wDAAwD;EACxD,6DAA6D;EAC7D,iDAAiD;EACjD,sDAAsD;EACtD,+CAA+C;EAC/C,oDAAoD;EACpD,uCAAuC;EACvC,iDAAiD;EACjD,6CAA6C;EAE7C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4CAA4C;EAE5C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2CAA2C;EAC3C,yCAAyC;EACzC,oCAAoC;EACpC,+CAA+C;EAC/C,mDAAmD;EACnD,mDAAmD;EACnD,yCAAyC;EACzC,mDAAmD;EACnD,uDAAuD;EACvD,4CAA4C;EAC5C,gDAAgD;EAChD,kDAAkD;EAClD,kDAAkD;EAClD,+CAA+C;EAE/C,yBAAyB;EACzB,2CAA2C;EAC3C,gDAAgD;EAChD,oDAAoD;EACpD,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,gDAAgD;EAChD,iDAAiD;EAEjD,wCAAwC;EACxC,8CAA8C;EAC9C,wCAAwC;EACxC,yBAAyB;EACzB,gDAAgD;EAChD,+BAA+B;EAC/B,yCAAyC;EACzC,+CAA+C;EAC/C,oDAAoD;EAEpD,uCAAuC;EACvC,uCAAuC;EACvC,6BAA6B;EAC7B,kDAAkD;EAElD,4CAA4C;EAC5C,gDAAgD;EAChD,mDAAmD;EACnD,2BAA2B;EAC3B,2CAA2C;EAC3C,gDAAgD;EAChD,0BAA0B;EAE1B,iDAAiD;EAEjD,+CAA+C;EAC/C,6CAA6C;EAE7C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,oDAAoD;EACpD,mDAAmD;EAEnD,2DAA2D;EAC3D,wDAAwD;EACxD,uDAAuD;EACvD,4DAA4D;EAC5D,uDAAuD;EACvD,0DAA0D;EAC1D,0DAA0D;EAC1D,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,kDAAkD;EAClD,kDAAkD;EAClD,gDAAgD;EAChD,gDAAgD;EAEhD,4CAA4C;EAC5C,6CAA6C;EAC7C,yCAAyC;EACzC,uCAAuC;EAEvC,yCAAyC;EACzC,+CAA+C;EAC/C,qDAAqD;EACrD,kDAAkD;EAClD,+DAA+D;EAC/D,6DAA6D;EAC7D,2DAA2D;EAC3D,gDAAgD;EAChD,iDAAiD;EACjD,uDAAuD;EAEvD,yCAAyC;EACzC,+CAA+C;EAC/C,+CAA+C;EAC/C,mDAAmD;EAEnD,0CAA0C;EAC1C,wCAAwC;EACxC,2CAA2C;EAC3C,kDAAkD;EAElD,yCAAyC;EACzC,8CAA8C;EAE9C,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,gDAAgD;EAChD,2CAA2C;EAC3C,iDAAiD;EAEjD,oDAAoD;EACpD,8CAA8C;EAC9C,2BAA2B;EAE3B,sDAAsD;EACtD,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EAErD,wBAAwB;EACxB,sCAAsC;EACtC,0CAA0C;EAC1C,kDAAkD;EAClD,qDAAqD;EACrD,6CAA6C;EAC7C,kDAAkD;EAClD,iDAAiD;EACjD,gDAAgD;EAChD,oDAAoD;EACpD,8CAA8C;AAvjB3B;AA8jBrB;EACE,0CAA0C;EAC1C,gDAAgD;EAChD,iDAAiD;EACjD,mDAAmD;EACnD,qDAAqD;EACrD,gDAAgD;EAChD,2CAA2C;EAE3C,sCAAsC;EACtC,uCAAuC;EACvC,iDAAiD;EACjD,4CAA4C;EAC5C,gDAAgD;EAChD,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;EAC/C,iDAAiD;EAEjD,2CAA2C;EAC3C,8CAA8C;EAC9C,6CAA6C;EAC7C,sCAAsC;EAEtC,+CAA+C;EAC/C,+CAA+C;EAC/C,oDAAoD;EAEpD,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,iCAAiC;EAEjC,6CAA6C;EAC7C,+CAA+C;EAC/C,4CAA4C;EAC5C,6CAA6C;EAC7C,+CAA+C;EAC/C,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,wCAAwC;EACxC,0CAA0C;EAC1C,4CAA4C;EAC5C,sCAAsC;EAEtC,+CAA+C;EAC/C,6CAA6C;EAC7C,uDAAuD;EAEvD,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EAGrC,0CAA0C;EAC1C,yCAAyC;EACzC,iDAAiD;EACjD,wCAAwC;EACxC,8CAA8C;EAC9C,8CAA8C;EAC9C;;;;GAIC;EACD,uCAAuC;EACvC,iDAAiD;EAGjD,gDAAgD;EAEhD,6CAA6C;EAC7C,kDAAkD;EAClD,iDAAiD;EACjD,gDAAgD;EAChD,oDAAoD;EACpD,8CAA8C;AA7E5B;AAoFpB;EACE;IACE,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;EALvB;AADgC;AAiBxC;EAGE,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,kDAAkD;EAClD,qDAAqD;EACrD,yBAAyB;EAEzB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,gDAAgD;EAEhD,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAE5B,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAE5B,uBAAuB;EACvB,4CAA4C;EAC5C,4BAA4B;EAC5B,8CAA8C;EAE9C,qBAAqB;EACrB,yCAAyC;EACzC,0BAA0B;EAC1B,2CAA2C;EAE3C,uBAAuB;EACvB,4CAA4C;EAC5C,4BAA4B;EAC5B,8CAA8C;EAG9C,oFACoE;EACpE,yFACyE;EAEzE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAE/B,iGAAiG;EACjG,8FAA8F;EAC9F,kGAAkG;EAClG,8FAA8F;EAC9F,sGAAsG;EACtG,sGAAsG;EACtG,sGAAsG;EACtG,wGAAwG;EACxG,uGAAuG;EACvG,yGAAyG;EAGzG,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EAGrB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAE1B,oFAAoF;EACpF,uFAAuF;EACvF,yFAAyF;EACzF,qDAAqD;EAGrD,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;EACd,eAAe;AA5GI;AA+GrB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,iDAAiD;EAEjD,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAE5B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EAEzB,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,mDAAmD;EACnD,qDAAqD;EAErD,uBAAuB;EACvB,6CAA6C;EAC7C,4BAA4B;EAC5B,+CAA+C;EAE/C,qBAAqB;EACrB,0CAA0C;EAC1C,0BAA0B;EAC1B,4CAA4C;EAE5C,uBAAuB;EACvB,6CAA6C;EAC7C,4BAA4B;EAC5B,+CAA+C;EAE/C,6BAA6B;EAC7B,wBAAwB;AAzCN;AD3xBpB,yCAAyC;AAEzC;EACE;IE2KA,kCAAkC;IAClC,kCAAkC;IFnKhC,wCAAwC;IAExC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAsH1C,4CAA4C;IE1E9C,0CAA0C;IAC1C,0CAA0C;IFwKxC,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAuF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IAYrB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IAezC,yBAAyB;IExM3B,+CAA+C;IAC/C,mDAAmD;IACnD,2CAA2C;IF0MzC,4BAA4B;IAG5B,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IAIxB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAuClB,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IACvC,2DAA2D;IAC3D,+DAA+D;IAC/D,oCAAoC;IAqCpC,eAAe;IAcf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IErf3D,gDAAgD;IAChD,4DAA4D;IAC5D,8DAA8D;IAC9D,0DAA0D;IAC1D,8DAA8D;IAC9D,sDAAsD;IACtD,oDAAoD;IAEpD,0CAA0C;IAE1C,kCAAkC;IAClC,oCAAoC;IACpC,wDAAwD;IACxD,8CAA8C;IAC9C,sDAAsD;IAItD,gDAAgD;IAChD,sDAAsD;IACtD,gDAAgD;IAChD,8CAA8C;IAC9C,kDAAkD;IAClD,gDAAgD;IAChD,gDAAgD;IAChD,0CAA0C;IAC1C,8CAA8C;IAC9C,wCAAwC;IACxC,kDAAkD;IAClD,gDAAgD;IAChD,8CAA8C;IAC9C,oCAAoC;IACpC,oCAAoC;IACpC,gCAAgC;IAChC,8BAA8B;IAC9B,8CAA8C;IAC9C,kDAAkD;IAClD,8CAA8C;IAC9C,8CAA8C;IAC9C,kDAAkD;IAClD,8CAA8C;IAC9C,0CAA0C;IAG1C,wCAAwC;IACxC,4CAA4C;IAC5C,wCAAwC;IACxC,wDAAwD;IACxD,4DAA4D;IAC5D,gDAAgD;IAChD,4CAA4C;IAC5C,gDAAgD;IAChD,kDAAkD;IAGlD,wCAAwC;IACxC,wCAAwC;IACxC,4CAA4C;IAC5C,8CAA8C;IAC9C,wCAAwC;IACxC,0CAA0C;IAC1C,sDAAsD;IACtD,wCAAwC;IAIxC,oDAAoD;IACpD,4DAA4D;IAG5D,gDAAgD;IAChD,gDAAgD;IAChD,wDAAwD;IACxD,wDAAwD;IACxD,wDAAwD;IACxD,gEAAgE;IAOhE,wCAAwC;IACxC,gDAAgD;IAGhD,kDAAkD;IAClD,8DAA8D;IAC9D,4CAA4C;IAC5C,wCAAwC;IACxC,sDAAsD;IACtD,kDAAkD;IAIlD,sDAAsD;IACtD,sDAAsD;IACtD,wDAAwD;IACxD,wDAAwD;IACxD,oDAAoD;IACpD,gDAAgD;IAChD,0DAA0D;IAC1D,4CAA4C;IAG5C,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAGlC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,kCAAkC;IAGlC,sCAAsC;IACtC,0CAA0C;IAG1C,wBAAwB;IAWxB,8CAA8C;IAC9C,4CAA4C;IAC5C,8CAA8C;IAC9C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,oCAAoC;IACpC,wCAAwC;IACxC,wCAAwC;IACxC,wCAAwC;IACxC,wCAAwC;IAExC,0CAA0C;IAG1C,2DAA2D;IAC3D,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,yDAAyD;IAOzD,iDAAiD;IAMjD,qBAAqB;IACrB,sBAAsB;IChLtB,oCAAqC;EHNtB;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAW;MAAX,cAAW;SAAX,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EAAd;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;IAAd;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,0BAAkB;OAAlB,uBAAkB;YAAlB,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,2BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,WAAmB;IAAnB,YAAmB;IAAnB,UAAmB;IAAnB,SAAmB;IAAnB,iBAAmB;IAAnB,eAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,MAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IEpuBA,wBAAwB;IACxB,qBAAqB;IAErB;MACE,aAAa;IADM;EFiuBF;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,mBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,mBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,MAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,iFAAmB;MAAnB,yFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,sEAAmB;MAAnB,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;SAAnB,4BAAmB;EAAA;EAAnB;IAAA,iCAAmB;SAAnB,4BAAmB;EAAA;EAAnB;IAAA,qBAAmB;SAAnB,gBAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,uEAAmB;MAAnB,+EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,uEAAmB;MAAnB,+EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,uEAAmB;MAAnB,+EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,iEAAmB;MAAnB,yEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IEhvBA,sCAAsC;EFgvBnB;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,2BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IExuBA,0CAA0C;EFwuBvB;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IE5uBA,6CAA6C;EF4uB1B;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB;MAAA,2EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB;MAAA,uFAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;IAAnB;MAAA,kFAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,4CAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,sFAAmB;IAAA;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,gEAAmB;EAAA;EAAnB;IAAA,6EAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;YAAnB,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;YAAnB,kBAAmB;EAAA;EAAnB;IAAA,2BAAmB;YAAnB,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oBAAmB;OAAnB,iBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,mDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,iKAAmB;IAAnB,mGAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,gRAAmB;EAAA;EAAnB;IAAA,gTAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,uDAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,oDAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qBAAmB;SAAnB,gBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,sBAAmB;SAAnB,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,cAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB;UAAA,uEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;MAAnB,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;MAAnB,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sBAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;QAAnB;UAAA,8EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;QAAnB;UAAA,kFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;QAAnB;UAAA,iFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB,sIAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB,0LAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;MAAnB,iBAAmB;MAAnB,iBAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,yCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,+CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,kCAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;AADJ;AGl5BjB;;;EAGE,YAAa;EACb,SAAU;AACX;AAED;EACE,mBAAoB;AACrB;AAED;EACE,kBAAmB;AACpB;AAED;EACE,yDAA0D;EAC1D,8BAA+B;EAC/B,+BAAgC;AACjC;AAYD;EACE;;oEAGmE;AACpE;AAED;EACE,+CAAgD;EAChD,mCAAoC;EACpC,yBAA0B;AAC3B;AAED;EACE,wCAAyC;AAC1C;AAKD;EACE,0BAA2B;AAC5B;AAED;;;;;;EAME,0BAA2B;AAC5B;AAED;;EAEE,WAAY;EACZ,kBAAmB;EACnB,MAAO;EACP,SAAU;EACV,WAAY;EACZ,oBAAqB;EACrB,UAAW;EACX,UAAW;EACX,uEAAwE;AACzE;AAED;EACE,OAAQ;EACR,yEAA0E;AAC3E;AAED;EACE,QAAS;EACT,wEAAyE;AAC1E;AAED;;EAEE,UAAW;AACZ;AAGD;EACE,sBAAuB;EACvB,uBAAwB;EACxB,2BAA4B;EAC5B,2BAA4B;EAC5B,cAAe;EACf,iBAAkB;EAClB,2CAA4C;AAC7C;AAED;EACE,4CAA6C;AAC9C;AAGD;EACE,cAAe;AAChB;AAED;EACE,qBAAsB;EACtB,oBAAqB;AACtB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,UAAW;EACX,YAAa;EACb,gBAAiB;EACjB,cAAe;EACf,qCAAsC;EACtC,kDAAmD;EACnD,sBAAuB;AACxB;AAED;EACE,cAAe;EACf,UAAW;EACX,2BAA4B;EAC5B,sCAAuC;EACvC,2CAA4C;AAC7C;AAGD;EACE,qBAAsB;EACtB,iDAAkD;AACnD;AAED;EACE,UAAW;EACX,WAAY;AACb;AAED;EACE,sCAAuC;EACvC,sCAAuC;AACxC;AAED;EACE,uBAAwB;AACzB;AAMD;EACE,uBAAwB;EACxB,gBAAiB;EACjB,UAAW;EACX,aAAc;EACd,qCAAsC;EACtC,mBAAoB;AACrB;AAED;;EAEE,SAAU;EACV,UAAW;EACX,WAAY;AACb;AAED;EACE,aAAc;AACf;AAED;;EAEE,eAAgB;AACjB;AAGD;EACE,UAAW;EACX,oBAAqB;AACtB;AHotBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AAMhB;EACE;IAEE,mBAAmB;IACnB,UAAU;EAFP;AAFS;AAQhB;EACE;IACE,YAAY;EADV;AADW;AAMjB;EACE;IAEE,2BAA2B;IAC3B,qDAAqD;EAFlD;EAKL;IACE,eAAe;IACf,qDAAqD;EAFnD;AAPY;AAudpB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","/* Flattened LLC entry: EDB index.css + llc-overrides.css (no nested @import) */\n/* ==========================================================================\n   EDB Design Tokens — foundation.css\n   Single source of truth for all CSS custom properties.\n   Theme switching via [data-theme] attribute (DR-9).\n   ========================================================================== */\n\n:root,\n[data-theme='light'] {\n  /* ── Palette Primitives ────────────────────────────────────────────────── */\n  --gaxl-blue-50: #eef4ff;\n  --gaxl-blue-100: #d9e5ff;\n  --gaxl-blue-200: #bcd1ff;\n  --gaxl-blue-300: #8eb3fd;\n  --gaxl-blue-400: #5c8cf9;\n  --gaxl-blue-450: #3b82f6;\n  --gaxl-blue-500: #3b6bf0;\n  --gaxl-blue-600: #2563eb;\n  --gaxl-blue-700: #1d4fcb;\n  --gaxl-blue-800: #1e42a3;\n  --gaxl-blue-900: #1c3a80;\n  --gaxl-blue-950: #132652;\n\n  --gaxl-violet-25: #fafaff;\n  --gaxl-violet-50: #f5f3ff;\n  --gaxl-violet-100: #ebe6fe;\n  --gaxl-violet-150: #e0dcea;\n  --gaxl-violet-200: #dacffe;\n  --gaxl-violet-300: #c0abfc;\n  --gaxl-violet-400: #a37cf8;\n  --gaxl-violet-500: #8b54f2;\n  --gaxl-violet-550: #6d4ad9;\n  --gaxl-violet-600: #7c3aed;\n  --gaxl-violet-700: #6a28d4;\n  --gaxl-violet-800: #5821ac;\n  --gaxl-violet-900: #491d8a;\n\n  --gaxl-neutral-0: #ffffff;\n  --gaxl-neutral-50: #f8fafc;\n  --gaxl-neutral-100: #f1f5f9;\n  --gaxl-neutral-200: #e5eaf1;\n  --gaxl-neutral-300: #cfd8e3;\n  --gaxl-neutral-400: #98a4b6;\n  --gaxl-neutral-500: #6a7689;\n  --gaxl-neutral-600: #4b576b;\n  --gaxl-neutral-700: #354056;\n  --gaxl-neutral-800: #1f2940;\n  --gaxl-neutral-900: #131a2b;\n  --gaxl-neutral-925: #0e1626;\n  --gaxl-neutral-950: #0a0f1c;\n\n  --gaxl-success-50: #ecfdf3;\n  --gaxl-success-100: #d1fadf;\n  --gaxl-success-200: #a7f3cb;\n  --gaxl-success-500: #16b364;\n  --gaxl-success-600: #099250;\n  --gaxl-success-700: #087443;\n\n  --gaxl-warning-50: #fffaeb;\n  --gaxl-warning-100: #fef0c7;\n  --gaxl-warning-200: #fedf89;\n  --gaxl-warning-500: #f59e0b;\n  --gaxl-warning-600: #dc8211;\n  --gaxl-warning-700: #b45309;\n\n  --gaxl-error-50: #fef3f2;\n  --gaxl-error-100: #fee4e2;\n  --gaxl-error-200: #fecdca;\n  --gaxl-error-500: #f04438;\n  --gaxl-error-600: #d92d20;\n  --gaxl-error-700: #b42318;\n\n  --gaxl-info-50: #eff8ff;\n  --gaxl-info-100: #d7edff;\n  --gaxl-info-200: #b2ddff;\n  --gaxl-info-500: #2e90fa;\n  --gaxl-info-600: #1570ef;\n  --gaxl-info-700: #175cd3;\n\n  /* Domain palette stops */\n  --gaxl-indigo-500: #6366f1;\n  --gaxl-indigo-600: #4f46e5;\n  --gaxl-sky-50: #f0f9ff;\n  --gaxl-sky-200: #bae6fd;\n  --gaxl-sky-600: #0284c7;\n  --gaxl-sky-700: #0369a1;\n  --gaxl-teal-500: #0e9bbb;\n  --gaxl-teal-700: #0e7490;\n  --gaxl-zinc-300: #d4d4d8;\n  --gaxl-zinc-600: #52525b;\n  --gaxl-slate-150: #e6e6ee;\n  --gaxl-slate-400: #94a3b8;\n  --gaxl-slate-925: #1e1e2e;\n  --gaxl-amber-600: #d97706;\n  --gaxl-green-100: #dcfce7;\n  --gaxl-green-650: #1f8a5b;\n  --gaxl-red-650: #c0392b;\n  --gaxl-gray-150: #eeeeee;\n  --gaxl-cyan-600: #0891b2;\n  --gaxl-teal-mid: #0e9488;\n  --gaxl-slate-ink: #0f172a;\n  --gaxl-gray-near-black: #111111;\n  --gaxl-blue-alt: #2a6fdb;\n  --gaxl-apple-green: #34c759;\n  --gaxl-sky-bright: #38bdf8;\n  --gaxl-slate-deep: #475569;\n  --gaxl-slate-mid: #64748b;\n  --gaxl-gray-mid: #666666;\n  --gaxl-violet-mid: #7a5ae0;\n  --gaxl-indigo-light: #818cf8;\n  --gaxl-purple-deep: #9333ea;\n  --gaxl-gray-hex-muted: #999999;\n  --gaxl-violet-light: #a78bfa;\n  --gaxl-mint-light: #a7f3d0;\n  --gaxl-chrome-muted: #b8b8c8;\n  --gaxl-red-deep: #b91c1c;\n  --gaxl-violet-pale: #c4b5fd;\n  --gaxl-border-muted: #c4c4cc;\n  --gaxl-indigo-pale: #c7d2fe;\n  --gaxl-amber-dark: #ca8a04;\n  --gaxl-coral: #d97757;\n  --gaxl-pink-deep: #db2777;\n  --gaxl-sky-pale: #e0f2fe;\n  --gaxl-orange-deep: #ea580c;\n  --gaxl-orange-accent: #ea7317;\n  --gaxl-surface-subtle: #ececf2;\n  --gaxl-green-pale: #ecfdf5;\n  --gaxl-blue-pale: #eef4ff;\n  --gaxl-slate-pale: #f1f5f9;\n  --gaxl-violet-pale-bg: #f3f0ff;\n  --gaxl-surface-alt: #f4f4f8;\n  --gaxl-warm-surface: #f6f4ef;\n  --gaxl-surface-neutral: #f6f6f7;\n  --gaxl-blue-tint: #f6f9ff;\n  --gaxl-edb-accent: #497bf7;\n  --gaxl-edb-accent-muted: #edf2ff;\n  --gaxl-surface-lifted: #f8f8fa;\n  --gaxl-violet-tint: #faf7ff;\n  --gaxl-blue-tint-light: #faf9ff;\n  --gaxl-surface-faint: #fafafb;\n  --gaxl-surface-muted: #fafafa;\n  --gaxl-surface-cool: #fbfbfe;\n  --gaxl-surface-cooler: #fcfcfe;\n  --gaxl-amber-pale: #fef3c7;\n  --gaxl-splitter-idle: #f0f0f0;\n  --gaxl-splitter-grip: #cccccc;\n  --gaxl-disabled-surface: #f4f4f5;\n  --gaxl-danger-border-hover: #fca5a5;\n  --gaxl-placeholder-stripe-a: #f7f7f8;\n  --gaxl-placeholder-stripe-b: #f0f0f2;\n  --gaxl-result-teal: #0d9488;\n  --gaxl-result-teal-light: #0e9bbb;\n  --gaxl-tweaks-text: #29261b;\n\n  /* ── Semantic Colors (Light) ───────────────────────────────────────────── */\n  --gaxl-brand-primary: var(--gaxl-blue-600);\n  --gaxl-brand-primary-hover: var(--gaxl-blue-700);\n  --gaxl-brand-primary-active: var(--gaxl-blue-800);\n  --gaxl-brand-primary-soft: var(--gaxl-blue-50);\n  --gaxl-brand-primary-subtle: var(--gaxl-blue-100);\n  --gaxl-brand-on-primary: var(--gaxl-neutral-0);\n  --gaxl-brand-secondary: var(--gaxl-violet-600);\n  --gaxl-brand-accent: var(--gaxl-violet-600);\n\n  --gaxl-canvas: var(--gaxl-neutral-50);\n  --gaxl-surface: var(--gaxl-neutral-0);\n  --gaxl-surface-secondary: var(--gaxl-neutral-100);\n  --gaxl-surface-card: var(--gaxl-neutral-0);\n  --gaxl-surface-elevated: var(--gaxl-neutral-0);\n  --gaxl-surface-header: var(--gaxl-neutral-0);\n  --gaxl-surface-modal: var(--gaxl-neutral-0);\n  --gaxl-surface-sidebar: var(--gaxl-neutral-900);\n  --gaxl-surface-hover: var(--gaxl-neutral-100);\n  --gaxl-surface-selected: var(--gaxl-blue-50);\n  --gaxl-scrim: rgba(10, 15, 28, 0.48);\n\n  --gaxl-text-primary: var(--gaxl-neutral-900);\n  --gaxl-text-secondary: var(--gaxl-neutral-600);\n  --gaxl-text-tertiary: var(--gaxl-neutral-500);\n  --gaxl-text-disabled: var(--gaxl-neutral-400);\n  --gaxl-text-muted: #a1a1aa;\n  --gaxl-text-inverse: var(--gaxl-neutral-0);\n  --gaxl-text-link: var(--gaxl-blue-600);\n\n  --gaxl-border-default: var(--gaxl-neutral-200);\n  --gaxl-border-strong: var(--gaxl-neutral-300);\n  --gaxl-border-focus: var(--gaxl-blue-600);\n  --gaxl-border-hover: var(--gaxl-neutral-300);\n  --gaxl-focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.32);\n\n  --gaxl-success: var(--gaxl-success-600);\n  --gaxl-warning: var(--gaxl-warning-600);\n  --gaxl-error: var(--gaxl-error-600);\n  --gaxl-info: var(--gaxl-info-600);\n\n  --gaxl-confidence-high: var(--gaxl-success-600);\n  --gaxl-confidence-med: var(--gaxl-warning-600);\n  --gaxl-confidence-low: var(--gaxl-error-600);\n\n  --gaxl-viz-1: var(--gaxl-blue-600);\n  --gaxl-viz-2: var(--gaxl-violet-600);\n  --gaxl-viz-3: var(--gaxl-info-500);\n  --gaxl-viz-4: var(--gaxl-warning-500);\n  --gaxl-viz-5: var(--gaxl-success-500);\n  --gaxl-viz-6: var(--gaxl-neutral-500);\n\n  /* ── Status Extended ───────────────────────────────────────────────────── */\n  --gaxl-success-soft: var(--gaxl-success-50);\n  --gaxl-success-border: var(--gaxl-success-200);\n  --gaxl-success-text: var(--gaxl-success-700);\n  --gaxl-warning-soft: var(--gaxl-warning-50);\n  --gaxl-warning-border: var(--gaxl-warning-200);\n  --gaxl-warning-text: var(--gaxl-warning-700);\n  --gaxl-error-soft: var(--gaxl-error-50);\n  --gaxl-error-border: var(--gaxl-error-200);\n  --gaxl-error-text: var(--gaxl-error-700);\n  --gaxl-info-soft: var(--gaxl-info-50);\n  --gaxl-info-border: var(--gaxl-info-200);\n  --gaxl-info-text: var(--gaxl-info-700);\n\n  /* ── Domain Tokens ─────────────────────────────────────────────────────── */\n  --gaxl-visit-supervisory: var(--gaxl-indigo-500);\n  --gaxl-visit-start-of-care: var(--gaxl-success-500);\n  --gaxl-visit-routine: var(--gaxl-blue-450);\n  --gaxl-visit-pt-ot: var(--gaxl-warning-500);\n\n  --gaxl-esa-panel: var(--gaxl-violet-25);\n  --gaxl-esa-accent: var(--gaxl-indigo-500);\n  --gaxl-esa-accent-muted: var(--gaxl-violet-100);\n  --gaxl-esa-hover: var(--gaxl-indigo-600);\n  --gaxl-esa-gradient-from: var(--gaxl-blue-600);\n  --gaxl-esa-gradient-to: var(--gaxl-violet-600);\n  --gaxl-esa-suggestion-gradient: linear-gradient(\n    to right,\n    var(--gaxl-esa-gradient-from),\n    var(--gaxl-esa-gradient-to)\n  );\n\n  --gaxl-catalog-master: var(--gaxl-violet-550);\n  --gaxl-catalog-channel: var(--gaxl-teal-700);\n  --gaxl-catalog-channel-dot: var(--gaxl-teal-500);\n  --gaxl-catalog-supplier: var(--gaxl-warning-700);\n  --gaxl-catalog-supplier-dot: var(--gaxl-amber-600);\n\n  --gaxl-chip-scope-fg: var(--gaxl-sky-700);\n  --gaxl-chip-scope-bg: var(--gaxl-sky-50);\n  --gaxl-chip-scope-border: var(--gaxl-sky-200);\n  --gaxl-chip-objective-fg: var(--gaxl-violet-600);\n  --gaxl-chip-objective-bg: var(--gaxl-violet-50);\n  --gaxl-chip-objective-border: var(--gaxl-violet-200);\n\n  --gaxl-dq-high: var(--gaxl-green-650);\n  --gaxl-dq-mid: var(--gaxl-warning-700);\n  --gaxl-dq-low: var(--gaxl-red-650);\n\n  --gaxl-run-running: var(--gaxl-blue-600);\n  --gaxl-run-queued: var(--gaxl-slate-400);\n  --gaxl-explorer-new: var(--gaxl-sky-600);\n\n  --gaxl-shell-bar: var(--gaxl-slate-925);\n  --gaxl-shell-bar-top: var(--gaxl-slate-150);\n  --gaxl-shell-bar-avatar: var(--gaxl-zinc-600);\n  --gaxl-shell-bar-avatar-text: var(--gaxl-zinc-300);\n\n  --gaxl-overlay: rgba(0, 0, 0, 0.4);\n  --gaxl-overlay-strong: rgba(0, 0, 0, 0.18);\n  --gaxl-glass-background: rgba(250, 249, 247, 0.82);\n  --gaxl-glass-border: rgba(255, 255, 255, 0.6);\n\n  --gaxl-progress-track-legacy: var(--gaxl-gray-150);\n  --gaxl-progress-before: var(--gaxl-violet-150);\n  --gaxl-success-strong: var(--gaxl-success-500);\n  --gaxl-success-strong-hover: var(--gaxl-success-700);\n  --gaxl-success-tint: var(--gaxl-green-100);\n\n  /* ── Typography ────────────────────────────────────────────────────────── */\n  --gaxl-font-sans:\n    'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, system-ui, sans-serif;\n  --gaxl-font-mono:\n    'JetBrains Mono', 'SFMono-Regular', ui-monospace, 'Cascadia Code', Menlo, monospace;\n\n  --gaxl-weight-regular: 400;\n  --gaxl-weight-medium: 500;\n  --gaxl-weight-semibold: 600;\n  --gaxl-weight-bold: 700;\n\n  --gaxl-size-display-xl: 3.5rem;\n  --gaxl-size-display-l: 2.75rem;\n  --gaxl-size-heading-xl: 2rem;\n  --gaxl-size-heading-l: 1.625rem;\n  --gaxl-size-heading-m: 1.375rem;\n  --gaxl-size-heading-s: 1.125rem;\n  --gaxl-size-title: 1rem;\n  --gaxl-size-subtitle: 0.9375rem;\n  --gaxl-size-body-lg: 1rem;\n  --gaxl-size-body-md: 0.875rem;\n  --gaxl-size-body-sm: 0.8125rem;\n  --gaxl-size-label: 0.8125rem;\n  --gaxl-size-caption: 0.75rem;\n  --gaxl-size-compact: 0.71875rem;\n  --gaxl-size-overline: 0.6875rem;\n  --gaxl-size-code: 0.8125rem;\n\n  --gaxl-leading-tight: 1.15;\n  --gaxl-leading-snug: 1.3;\n  --gaxl-leading-normal: 1.45;\n  --gaxl-leading-relaxed: 1.6;\n\n  --gaxl-tracking-tighter: -0.02em;\n  --gaxl-tracking-tight: -0.011em;\n  --gaxl-tracking-normal: 0;\n  --gaxl-tracking-wide: 0.04em;\n  --gaxl-tracking-overline: 0.08em;\n\n  --gaxl-text-display-xl: 700 3.5rem/1.15 var(--gaxl-font-sans);\n  --gaxl-text-display-l: 700 2.75rem/1.15 var(--gaxl-font-sans);\n  --gaxl-text-heading-xl: 600 2rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-heading-l: 600 1.625rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-heading-m: 600 1.375rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-heading-s: 600 1.125rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-title: 600 1rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-body: 400 0.875rem/1.45 var(--gaxl-font-sans);\n  --gaxl-text-label: 500 0.8125rem/1.3 var(--gaxl-font-sans);\n  --gaxl-text-caption: 400 0.75rem/1.3 var(--gaxl-font-sans);\n\n  /* ── Spacing ───────────────────────────────────────────────────────────── */\n  --gaxl-space-1: 2px;\n  --gaxl-space-2: 4px;\n  --gaxl-space-3: 8px;\n  --gaxl-space-4: 12px;\n  --gaxl-space-5: 16px;\n  --gaxl-space-6: 20px;\n  --gaxl-space-7: 24px;\n  --gaxl-space-8: 32px;\n  --gaxl-space-9: 40px;\n  --gaxl-space-10: 48px;\n  --gaxl-space-11: 64px;\n  --gaxl-space-12: 80px;\n  --gaxl-space-13: 96px;\n\n  /* ── Border Radius ─────────────────────────────────────────────────────── */\n  --gaxl-radius-2: 2px;\n  --gaxl-radius-4: 4px;\n  --gaxl-radius-6: 6px;\n  --gaxl-radius-8: 8px;\n  --gaxl-radius-12: 12px;\n  --gaxl-radius-16: 16px;\n  --gaxl-radius-20: 20px;\n  --gaxl-radius-full: 9999px;\n\n  /* ── Shadows & Elevation ───────────────────────────────────────────────── */\n  --gaxl-shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.05);\n  --gaxl-shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);\n  --gaxl-shadow-md: 0 4px 8px -2px rgba(15, 23, 42, 0.1), 0 2px 4px -2px rgba(15, 23, 42, 0.06);\n  --gaxl-shadow-lg: 0 12px 20px -4px rgba(15, 23, 42, 0.12), 0 4px 8px -4px rgba(15, 23, 42, 0.06);\n  --gaxl-shadow-xl: 0 24px 40px -8px rgba(15, 23, 42, 0.18), 0 8px 16px -8px rgba(15, 23, 42, 0.08);\n  --gaxl-shadow-overlay: 0 32px 64px -12px rgba(10, 15, 28, 0.28);\n\n  --gaxl-elevation-0: none;\n  --gaxl-elevation-1: var(--gaxl-shadow-xs);\n  --gaxl-elevation-2: var(--gaxl-shadow-sm);\n  --gaxl-elevation-3: var(--gaxl-shadow-md);\n  --gaxl-elevation-4: var(--gaxl-shadow-lg);\n\n  /* ── Motion ────────────────────────────────────────────────────────────── */\n  --gaxl-duration-instant: 80ms;\n  --gaxl-duration-fast: 120ms;\n  --gaxl-duration-base: 180ms;\n  --gaxl-duration-slow: 240ms;\n  --gaxl-duration-slower: 360ms;\n\n  --gaxl-ease-standard: cubic-bezier(0.2, 0, 0, 1);\n  --gaxl-ease-emphasized: cubic-bezier(0.2, 0, 0, 1.05);\n  --gaxl-ease-accelerate: cubic-bezier(0.3, 0, 1, 1);\n  --gaxl-ease-decelerate: cubic-bezier(0, 0, 0, 1);\n\n  --gaxl-transition-colors:\n    color var(--gaxl-duration-fast) var(--gaxl-ease-standard),\n    background-color var(--gaxl-duration-fast) var(--gaxl-ease-standard),\n    border-color var(--gaxl-duration-fast) var(--gaxl-ease-standard);\n  --gaxl-transition-transform: transform var(--gaxl-duration-fast) var(--gaxl-ease-standard);\n\n  /* ── Opacity ───────────────────────────────────────────────────────────── */\n  --gaxl-opacity-0: 0;\n  --gaxl-opacity-10: 0.1;\n  --gaxl-opacity-20: 0.2;\n  --gaxl-opacity-40: 0.4;\n  --gaxl-opacity-60: 0.6;\n  --gaxl-opacity-80: 0.8;\n  --gaxl-opacity-100: 1;\n  --gaxl-opacity-disabled: 0.4;\n\n  /* ── Layout ────────────────────────────────────────────────────────────── */\n  --gaxl-container-max: 1440px;\n  --gaxl-sidebar-width: 248px;\n  --gaxl-sidebar-collapsed: 64px;\n  --gaxl-header-height: 56px;\n  --gaxl-page-margin: 1.5rem;\n  --gaxl-gutter: 1rem;\n  --gaxl-row-height-compact: 36px;\n  --gaxl-row-height-medium: 44px;\n  --gaxl-row-height-large: 56px;\n\n  /* ── Component Tokens ──────────────────────────────────────────────────── */\n  --gaxl-btn-radius: var(--gaxl-radius-6);\n  --gaxl-btn-font-weight: var(--gaxl-weight-semibold);\n  --gaxl-btn-gap: var(--gaxl-space-3);\n  --gaxl-btn-height-xs: 26px;\n  --gaxl-btn-height-sm: 30px;\n  --gaxl-btn-height-md: 36px;\n  --gaxl-btn-height-lg: 42px;\n  --gaxl-btn-height-xl: 48px;\n  --gaxl-btn-padding-xs: var(--gaxl-space-3);\n  --gaxl-btn-padding-sm: 11px;\n  --gaxl-btn-padding-md: var(--gaxl-space-4);\n  --gaxl-btn-padding-lg: 18px;\n  --gaxl-btn-padding-xl: 22px;\n  --gaxl-btn-font-size-sm: var(--gaxl-size-body-sm);\n  --gaxl-btn-font-size-md: var(--gaxl-size-body-md);\n  --gaxl-btn-font-size-lg: var(--gaxl-size-body-lg);\n  --gaxl-btn-primary-bg: var(--gaxl-brand-primary);\n  --gaxl-btn-primary-bg-hover: var(--gaxl-brand-primary-hover);\n  --gaxl-btn-primary-bg-active: var(--gaxl-brand-primary-active);\n  --gaxl-btn-primary-fg: var(--gaxl-brand-on-primary);\n  --gaxl-btn-secondary-bg: var(--gaxl-surface);\n  --gaxl-btn-secondary-bg-hover: var(--gaxl-surface-hover);\n  --gaxl-btn-secondary-bg-active: var(--gaxl-surface-secondary);\n  --gaxl-btn-secondary-fg: var(--gaxl-text-primary);\n  --gaxl-btn-secondary-border: var(--gaxl-border-strong);\n  --gaxl-btn-ghost-fg: var(--gaxl-text-secondary);\n  --gaxl-btn-ghost-bg-hover: var(--gaxl-surface-hover);\n  --gaxl-btn-danger-bg: var(--gaxl-error);\n  --gaxl-btn-danger-bg-hover: var(--gaxl-error-700);\n  --gaxl-btn-focus-ring: var(--gaxl-focus-ring);\n\n  --gaxl-icon-btn-size-sm: 30px;\n  --gaxl-icon-btn-size-md: 36px;\n  --gaxl-icon-btn-size-lg: 42px;\n  --gaxl-icon-btn-radius: var(--gaxl-radius-6);\n\n  --gaxl-field-height-sm: 30px;\n  --gaxl-field-height-md: 36px;\n  --gaxl-field-height-lg: 42px;\n  --gaxl-field-padding-x: var(--gaxl-space-4);\n  --gaxl-field-radius: var(--gaxl-radius-6);\n  --gaxl-field-bg: var(--gaxl-surface);\n  --gaxl-field-border: var(--gaxl-border-default);\n  --gaxl-field-border-hover: var(--gaxl-border-hover);\n  --gaxl-field-border-focus: var(--gaxl-border-focus);\n  --gaxl-field-fg: var(--gaxl-text-primary);\n  --gaxl-field-placeholder: var(--gaxl-text-tertiary);\n  --gaxl-field-disabled-bg: var(--gaxl-surface-secondary);\n  --gaxl-field-error-border: var(--gaxl-error);\n  --gaxl-field-success-border: var(--gaxl-success);\n  --gaxl-field-label-color: var(--gaxl-text-primary);\n  --gaxl-field-hint-color: var(--gaxl-text-tertiary);\n  --gaxl-field-focus-ring: var(--gaxl-focus-ring);\n\n  --gaxl-control-size: 18px;\n  --gaxl-control-radius: var(--gaxl-radius-4);\n  --gaxl-control-border: var(--gaxl-border-strong);\n  --gaxl-control-checked-bg: var(--gaxl-brand-primary);\n  --gaxl-control-checked-fg: var(--gaxl-neutral-0);\n  --gaxl-switch-width: 36px;\n  --gaxl-switch-height: 20px;\n  --gaxl-switch-track-off: var(--gaxl-neutral-300);\n  --gaxl-switch-track-on: var(--gaxl-brand-primary);\n\n  --gaxl-card-bg: var(--gaxl-surface-card);\n  --gaxl-card-border: var(--gaxl-border-default);\n  --gaxl-card-radius: var(--gaxl-radius-8);\n  --gaxl-card-padding: 18px;\n  --gaxl-card-padding-compact: var(--gaxl-space-4);\n  --gaxl-card-padding-dense: 10px;\n  --gaxl-card-shadow: var(--gaxl-shadow-xs);\n  --gaxl-card-shadow-hover: var(--gaxl-shadow-md);\n  --gaxl-card-selected-ring: var(--gaxl-brand-primary);\n\n  --gaxl-kpi-bg: var(--gaxl-surface-card);\n  --gaxl-kpi-radius: var(--gaxl-radius-8);\n  --gaxl-kpi-padding: 16px 18px;\n  --gaxl-kpi-value-size: var(--gaxl-size-heading-xl);\n\n  --gaxl-badge-radius: var(--gaxl-radius-full);\n  --gaxl-badge-radius-square: var(--gaxl-radius-4);\n  --gaxl-badge-font-weight: var(--gaxl-weight-medium);\n  --gaxl-badge-padding-y: 3px;\n  --gaxl-badge-padding-x: var(--gaxl-space-3);\n  --gaxl-badge-font-size: var(--gaxl-size-caption);\n  --gaxl-badge-dot-size: 6px;\n\n  --gaxl-btn-font-size-xs: var(--gaxl-size-caption);\n\n  --gaxl-secondary-soft: rgba(124, 58, 237, 0.08);\n  --gaxl-secondary-text: var(--gaxl-violet-700);\n\n  --gaxl-badge-height-sm: 20px;\n  --gaxl-badge-height-md: 24px;\n  --gaxl-badge-height-lg: 28px;\n  --gaxl-badge-font-size-sm: var(--gaxl-size-overline);\n  --gaxl-badge-font-size-lg: var(--gaxl-size-body-sm);\n\n  --gaxl-badge-neutral-soft-bg: var(--gaxl-surface-secondary);\n  --gaxl-badge-neutral-soft-fg: var(--gaxl-text-secondary);\n  --gaxl-badge-neutral-filled-bg: var(--gaxl-neutral-600);\n  --gaxl-badge-primary-soft-bg: var(--gaxl-brand-primary-soft);\n  --gaxl-badge-primary-soft-fg: var(--gaxl-brand-primary);\n  --gaxl-badge-secondary-soft-bg: var(--gaxl-secondary-soft);\n  --gaxl-badge-secondary-soft-fg: var(--gaxl-secondary-text);\n  --gaxl-badge-success-soft-bg: var(--gaxl-success-soft);\n  --gaxl-badge-success-soft-fg: var(--gaxl-success-text);\n  --gaxl-badge-warning-soft-bg: var(--gaxl-warning-soft);\n  --gaxl-badge-warning-soft-fg: var(--gaxl-warning-text);\n  --gaxl-badge-error-soft-bg: var(--gaxl-error-soft);\n  --gaxl-badge-error-soft-fg: var(--gaxl-error-text);\n  --gaxl-badge-info-soft-bg: var(--gaxl-info-soft);\n  --gaxl-badge-info-soft-fg: var(--gaxl-info-text);\n\n  --gaxl-tag-bg: var(--gaxl-surface-secondary);\n  --gaxl-tag-border: var(--gaxl-border-default);\n  --gaxl-tag-fg: var(--gaxl-text-secondary);\n  --gaxl-tag-radius: var(--gaxl-radius-4);\n\n  --gaxl-table-radius: var(--gaxl-radius-8);\n  --gaxl-table-border: var(--gaxl-border-default);\n  --gaxl-table-header-bg: var(--gaxl-surface-secondary);\n  --gaxl-table-header-fg: var(--gaxl-text-secondary);\n  --gaxl-table-row-height-compact: var(--gaxl-row-height-compact);\n  --gaxl-table-row-height-medium: var(--gaxl-row-height-medium);\n  --gaxl-table-row-height-large: var(--gaxl-row-height-large);\n  --gaxl-table-cell-padding-x: var(--gaxl-space-5);\n  --gaxl-table-row-hover: var(--gaxl-surface-hover);\n  --gaxl-table-row-selected: var(--gaxl-surface-selected);\n\n  --gaxl-tab-fg: var(--gaxl-text-secondary);\n  --gaxl-tab-fg-active: var(--gaxl-brand-primary);\n  --gaxl-tab-indicator: var(--gaxl-brand-primary);\n  --gaxl-tab-font-weight: var(--gaxl-weight-semibold);\n\n  --gaxl-tooltip-bg: var(--gaxl-neutral-900);\n  --gaxl-tooltip-fg: var(--gaxl-neutral-0);\n  --gaxl-tooltip-radius: var(--gaxl-radius-6);\n  --gaxl-tooltip-font-size: var(--gaxl-size-caption);\n\n  --gaxl-alert-radius: var(--gaxl-radius-8);\n  --gaxl-alert-padding: var(--gaxl-space-4) 14px;\n\n  --gaxl-avatar-size-xs: 22px;\n  --gaxl-avatar-size-sm: 28px;\n  --gaxl-avatar-size-md: 36px;\n  --gaxl-avatar-size-lg: 44px;\n  --gaxl-avatar-size-xl: 56px;\n  --gaxl-avatar-bg: var(--gaxl-brand-primary-soft);\n  --gaxl-avatar-fg: var(--gaxl-brand-primary);\n  --gaxl-avatar-radius-square: var(--gaxl-radius-8);\n\n  --gaxl-progress-track: var(--gaxl-surface-secondary);\n  --gaxl-progress-bar: var(--gaxl-brand-primary);\n  --gaxl-progress-height: 8px;\n\n  --gaxl-confidence-track: var(--gaxl-surface-secondary);\n  --gaxl-confidence-seg-high: var(--gaxl-confidence-high);\n  --gaxl-confidence-seg-med: var(--gaxl-confidence-med);\n  --gaxl-confidence-seg-low: var(--gaxl-confidence-low);\n\n  --gaxl-pg-btn-size: 32px;\n  --gaxl-pg-btn-gap: var(--gaxl-space-2);\n  --gaxl-pg-btn-radius: var(--gaxl-radius-6);\n  --gaxl-pg-btn-active-bg: var(--gaxl-brand-primary);\n  --gaxl-pg-btn-active-fg: var(--gaxl-brand-on-primary);\n  --gaxl-pg-btn-default-bg: var(--gaxl-surface);\n  --gaxl-pg-btn-default-fg: var(--gaxl-text-primary);\n  --gaxl-pg-btn-hover-bg: var(--gaxl-surface-hover);\n  --gaxl-pg-btn-border: var(--gaxl-border-default);\n  --gaxl-pg-btn-disabled-fg: var(--gaxl-text-disabled);\n  --gaxl-pg-label-fg: var(--gaxl-text-secondary);\n}\n\n/* ==========================================================================\n   Dark Theme Overrides\n   ========================================================================== */\n\n[data-theme='dark'] {\n  --gaxl-brand-primary: var(--gaxl-blue-500);\n  --gaxl-brand-primary-hover: var(--gaxl-blue-400);\n  --gaxl-brand-primary-active: var(--gaxl-blue-300);\n  --gaxl-brand-primary-soft: rgba(59, 107, 240, 0.14);\n  --gaxl-brand-primary-subtle: rgba(59, 107, 240, 0.22);\n  --gaxl-brand-on-primary: var(--gaxl-neutral-950);\n  --gaxl-brand-accent: var(--gaxl-violet-400);\n\n  --gaxl-canvas: var(--gaxl-neutral-950);\n  --gaxl-surface: var(--gaxl-neutral-900);\n  --gaxl-surface-secondary: var(--gaxl-neutral-925);\n  --gaxl-surface-card: var(--gaxl-neutral-900);\n  --gaxl-surface-elevated: var(--gaxl-neutral-800);\n  --gaxl-surface-header: var(--gaxl-neutral-900);\n  --gaxl-surface-modal: var(--gaxl-neutral-800);\n  --gaxl-surface-hover: rgba(255, 255, 255, 0.04);\n  --gaxl-surface-selected: rgba(59, 107, 240, 0.16);\n\n  --gaxl-text-primary: var(--gaxl-neutral-50);\n  --gaxl-text-secondary: var(--gaxl-neutral-300);\n  --gaxl-text-tertiary: var(--gaxl-neutral-400);\n  --gaxl-text-link: var(--gaxl-blue-300);\n\n  --gaxl-border-default: rgba(255, 255, 255, 0.1);\n  --gaxl-border-strong: rgba(255, 255, 255, 0.18);\n  --gaxl-focus-ring: 0 0 0 3px rgba(92, 140, 249, 0.4);\n\n  --gaxl-success: var(--gaxl-success-500);\n  --gaxl-warning: var(--gaxl-warning-500);\n  --gaxl-error: var(--gaxl-error-500);\n  --gaxl-info: var(--gaxl-info-500);\n\n  --gaxl-success-soft: rgba(22, 179, 100, 0.14);\n  --gaxl-success-border: rgba(22, 179, 100, 0.32);\n  --gaxl-success-text: var(--gaxl-success-200);\n  --gaxl-warning-soft: rgba(245, 158, 11, 0.14);\n  --gaxl-warning-border: rgba(245, 158, 11, 0.32);\n  --gaxl-warning-text: var(--gaxl-warning-200);\n  --gaxl-error-soft: rgba(240, 68, 56, 0.14);\n  --gaxl-error-border: rgba(240, 68, 56, 0.32);\n  --gaxl-error-text: var(--gaxl-error-200);\n  --gaxl-info-soft: rgba(46, 144, 250, 0.14);\n  --gaxl-info-border: rgba(46, 144, 250, 0.32);\n  --gaxl-info-text: var(--gaxl-info-200);\n\n  --gaxl-secondary-soft: rgba(124, 58, 237, 0.14);\n  --gaxl-secondary-text: var(--gaxl-violet-200);\n  --gaxl-badge-neutral-filled-bg: var(--gaxl-neutral-500);\n\n  --gaxl-viz-1: var(--gaxl-blue-400);\n  --gaxl-viz-2: var(--gaxl-violet-400);\n  --gaxl-viz-6: var(--gaxl-neutral-400);\n\n  /* Domain: ESA & EDB */\n  --gaxl-esa-panel: rgba(99, 102, 241, 0.08);\n  --gaxl-esa-accent: var(--gaxl-violet-400);\n  --gaxl-esa-accent-muted: rgba(99, 102, 241, 0.14);\n  --gaxl-esa-hover: var(--gaxl-indigo-500);\n  --gaxl-esa-gradient-from: var(--gaxl-blue-600);\n  --gaxl-esa-gradient-to: var(--gaxl-violet-600);\n  --gaxl-esa-suggestion-gradient: linear-gradient(\n    to right,\n    var(--gaxl-esa-gradient-from),\n    var(--gaxl-esa-gradient-to)\n  );\n  --gaxl-edb-accent: var(--gaxl-blue-400);\n  --gaxl-edb-accent-muted: rgba(73, 123, 247, 0.14);\n\n  /* Shell chrome */\n  --gaxl-shell-bar-top: var(--gaxl-surface-header);\n\n  --gaxl-pg-btn-default-bg: var(--gaxl-surface);\n  --gaxl-pg-btn-default-fg: var(--gaxl-text-primary);\n  --gaxl-pg-btn-hover-bg: var(--gaxl-surface-hover);\n  --gaxl-pg-btn-border: var(--gaxl-border-default);\n  --gaxl-pg-btn-disabled-fg: var(--gaxl-text-disabled);\n  --gaxl-pg-label-fg: var(--gaxl-text-secondary);\n}\n\n/* ==========================================================================\n   Reduced Motion (UC-4)\n   ========================================================================== */\n\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --gaxl-duration-instant: 0ms;\n    --gaxl-duration-fast: 0ms;\n    --gaxl-duration-base: 0ms;\n    --gaxl-duration-slow: 0ms;\n    --gaxl-duration-slower: 0ms;\n  }\n}\n\n\n/* ==========================================================================\n   LLC Design System — bridge overrides onto --gaxl-* contract\n   Published via flatten: dist/styles/llc.css = index.css + this file.\n   Do NOT nest-import the foundation stylesheet here (publish must stay flattened).\n   ========================================================================== */\n\n:root,\n[data-theme='light'] {\n  /* ── Color bridges (LLC light) ─────────────────────────────────────────── */\n  --gaxl-brand-primary: #196EE0;\n  --gaxl-brand-primary-hover: #1558B0;\n  --gaxl-brand-primary-active: #1044A0;\n  --gaxl-brand-primary-soft: rgba(25, 110, 224, 0.1);\n  --gaxl-brand-primary-subtle: rgba(25, 110, 224, 0.18);\n  --gaxl-text-link: #1558B0;\n\n  --gaxl-canvas: #ffffff;\n  --gaxl-surface: #ffffff;\n  --gaxl-surface-card: #F8FAFC;\n  --gaxl-surface-muted: #F1F5F9;\n  --gaxl-surface-hover: #F1F5F9;\n  --gaxl-surface-selected: rgba(25, 110, 224, 0.1);\n\n  --gaxl-text-primary: #0F172A;\n  --gaxl-text-secondary: #334155;\n  --gaxl-text-muted: #64748B;\n  --gaxl-text-disabled: #94A3B8;\n  --gaxl-text-inverse: #ffffff;\n\n  --gaxl-border-default: #E2E8F0;\n  --gaxl-border-strong: #CBD5E1;\n  --gaxl-border-focus: #196EE0;\n\n  --gaxl-success: #16B364;\n  --gaxl-success-soft: rgba(22, 179, 100, 0.1);\n  --gaxl-success-text: #15803D;\n  --gaxl-success-border: rgba(22, 179, 100, 0.3);\n\n  --gaxl-error: #F04438;\n  --gaxl-error-soft: rgba(240, 68, 56, 0.1);\n  --gaxl-error-text: #B91C1C;\n  --gaxl-error-border: rgba(240, 68, 56, 0.3);\n\n  --gaxl-warning: #F59E0B;\n  --gaxl-warning-soft: rgba(245, 158, 11, 0.1);\n  --gaxl-warning-text: #B45309;\n  --gaxl-warning-border: rgba(245, 158, 11, 0.3);\n\n  /* ── Typography ────────────────────────────────────────────────────────── */\n  --gaxl-font-sans:\n    'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --gaxl-font-mono:\n    'JetBrains Mono', 'Fira Code', 'Cascadia Code', ui-monospace, monospace;\n\n  --gaxl-size-overline: 0.6875rem;\n  --gaxl-size-compact: 0.6875rem;\n  --gaxl-size-caption: 0.75rem;\n  --gaxl-size-body-sm: 0.75rem;\n  --gaxl-size-label: 0.75rem;\n  --gaxl-size-code: 0.75rem;\n  --gaxl-size-body-md: 0.875rem;\n  --gaxl-size-subtitle: 0.9375rem;\n  --gaxl-size-body-lg: 1rem;\n  --gaxl-size-title: 1rem;\n  --gaxl-size-heading-s: 1.125rem;\n  --gaxl-size-heading-m: 1.25rem;\n  --gaxl-size-heading-l: 1.5rem;\n  --gaxl-size-heading-xl: 1.875rem;\n  --gaxl-size-display-l: 2.25rem;\n  --gaxl-size-display-xl: 2.25rem;\n\n  --gaxl-text-body: 400 var(--gaxl-size-body-md) / var(--gaxl-leading-normal) var(--gaxl-font-sans);\n  --gaxl-text-label: 500 var(--gaxl-size-label) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-caption: 400 var(--gaxl-size-caption) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-title: 600 var(--gaxl-size-title) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-heading-s: 600 var(--gaxl-size-heading-s) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-heading-m: 600 var(--gaxl-size-heading-m) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-heading-l: 600 var(--gaxl-size-heading-l) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-heading-xl: 600 var(--gaxl-size-heading-xl) / var(--gaxl-leading-snug) var(--gaxl-font-sans);\n  --gaxl-text-display-l: 700 var(--gaxl-size-display-l) / var(--gaxl-leading-tight) var(--gaxl-font-sans);\n  --gaxl-text-display-xl: 700 var(--gaxl-size-display-xl) / var(--gaxl-leading-tight) var(--gaxl-font-sans);\n\n  /* ── Spacing contract (by value ↔ LLC) ─────────────────────────────────── */\n  --gaxl-space-1: 2px;\n  --gaxl-space-2: 4px;\n  --gaxl-space-3: 8px;\n  --gaxl-space-4: 12px;\n  --gaxl-space-5: 16px;\n  --gaxl-space-6: 20px;\n  --gaxl-space-7: 24px;\n  --gaxl-space-8: 32px;\n  --gaxl-space-9: 40px;\n  --gaxl-space-10: 48px;\n  --gaxl-space-11: 64px;\n  --gaxl-space-12: 80px;\n  --gaxl-space-13: 96px;\n\n  /* ── Radius / shadow ───────────────────────────────────────────────────── */\n  --gaxl-radius-2: 2px;\n  --gaxl-radius-4: 4px;\n  --gaxl-radius-6: 6px;\n  --gaxl-radius-8: 8px;\n  --gaxl-radius-12: 12px;\n  --gaxl-radius-16: 16px;\n  --gaxl-radius-full: 9999px;\n\n  --gaxl-shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06);\n  --gaxl-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06);\n  --gaxl-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.06);\n  --gaxl-focus-ring: 0 0 0 3px rgba(25, 110, 224, 0.35);\n\n  /* Optional LLC-native aliases (debug / LLC-specific CSS) */\n  --color-blue-primary: #196EE0;\n  --color-bg-page: #ffffff;\n  --space-4: 8px;\n  --space-8: 16px;\n}\n\n[data-theme='dark'] {\n  --gaxl-canvas: #09090B;\n  --gaxl-surface: #09090B;\n  --gaxl-surface-card: #18181B;\n  --gaxl-surface-muted: #1F2937;\n  --gaxl-surface-hover: #27272A;\n  --gaxl-surface-selected: rgba(59, 107, 240, 0.16);\n\n  --gaxl-border-default: #3F3F46;\n  --gaxl-border-strong: #3F3F46;\n  --gaxl-border-focus: #2563EB;\n\n  --gaxl-text-primary: #F8FAFC;\n  --gaxl-text-secondary: #CFD8E3;\n  --gaxl-text-muted: #98A4B6;\n  --gaxl-text-disabled: #6B7280;\n  --gaxl-text-inverse: #09090B;\n  --gaxl-text-link: #8EB3FD;\n\n  --gaxl-brand-primary: #2563EB;\n  --gaxl-brand-primary-hover: #3B76F5;\n  --gaxl-brand-primary-active: #4F88FF;\n  --gaxl-brand-primary-soft: rgba(59, 107, 240, 0.16);\n  --gaxl-brand-primary-subtle: rgba(59, 107, 240, 0.28);\n\n  --gaxl-success: #16B364;\n  --gaxl-success-soft: rgba(22, 179, 100, 0.12);\n  --gaxl-success-text: #4ADE80;\n  --gaxl-success-border: rgba(22, 179, 100, 0.25);\n\n  --gaxl-error: #F04438;\n  --gaxl-error-soft: rgba(240, 68, 56, 0.12);\n  --gaxl-error-text: #FCA5A5;\n  --gaxl-error-border: rgba(240, 68, 56, 0.25);\n\n  --gaxl-warning: #F59E0B;\n  --gaxl-warning-soft: rgba(245, 158, 11, 0.12);\n  --gaxl-warning-text: #FCD34D;\n  --gaxl-warning-border: rgba(245, 158, 11, 0.25);\n\n  --color-blue-primary: #2563EB;\n  --color-bg-page: #09090B;\n}\n\n","/**\n * Tailwind v4 @theme bridge for @growthaxl/web-foundation consumers.\n * Import after foundation.css (or @growthaxl/web-foundation/styles).\n *\n *   @import 'tailwindcss';\n *   @import '@growthaxl/web-foundation/styles';\n *   @import '@growthaxl/web-foundation/tailwind-theme';\n */\n@theme {\n  /* Colors — bare-name utilities referencing foundation.css custom properties */\n  --color-brand-primary: var(--gaxl-brand-primary);\n  --color-brand-primary-hover: var(--gaxl-brand-primary-hover);\n  --color-brand-primary-active: var(--gaxl-brand-primary-active);\n  --color-brand-primary-soft: var(--gaxl-brand-primary-soft);\n  --color-brand-primary-subtle: var(--gaxl-brand-primary-subtle);\n  --color-brand-on-primary: var(--gaxl-brand-on-primary);\n  --color-brand-secondary: var(--gaxl-brand-secondary);\n  --color-brand-accent: var(--gaxl-brand-accent);\n  --color-edb-accent: var(--gaxl-edb-accent);\n  --color-edb-accent-muted: var(--gaxl-edb-accent-muted);\n  --color-canvas: var(--gaxl-canvas);\n  --color-surface: var(--gaxl-surface);\n  --color-surface-secondary: var(--gaxl-surface-secondary);\n  --color-surface-card: var(--gaxl-surface-card);\n  --color-surface-elevated: var(--gaxl-surface-elevated);\n  --color-surface-header: var(--gaxl-surface-header);\n  --color-surface-modal: var(--gaxl-surface-modal);\n  --color-surface-sidebar: var(--gaxl-surface-sidebar);\n  --color-surface-hover: var(--gaxl-surface-hover);\n  --color-surface-selected: var(--gaxl-surface-selected);\n  --color-surface-muted: var(--gaxl-surface-muted);\n  --color-text-primary: var(--gaxl-text-primary);\n  --color-text-secondary: var(--gaxl-text-secondary);\n  --color-text-tertiary: var(--gaxl-text-tertiary);\n  --color-text-disabled: var(--gaxl-text-disabled);\n  --color-text-muted: var(--gaxl-text-muted);\n  --color-text-inverse: var(--gaxl-text-inverse);\n  --color-text-link: var(--gaxl-text-link);\n  --color-border-default: var(--gaxl-border-default);\n  --color-border-strong: var(--gaxl-border-strong);\n  --color-border-focus: var(--gaxl-border-focus);\n  --color-success: var(--gaxl-success);\n  --color-warning: var(--gaxl-warning);\n  --color-error: var(--gaxl-error);\n  --color-info: var(--gaxl-info);\n  --color-success-soft: var(--gaxl-success-soft);\n  --color-success-border: var(--gaxl-success-border);\n  --color-success-text: var(--gaxl-success-text);\n  --color-warning-soft: var(--gaxl-warning-soft);\n  --color-warning-border: var(--gaxl-warning-border);\n  --color-warning-text: var(--gaxl-warning-text);\n  --color-error-soft: var(--gaxl-error-soft);\n  --color-error-border: var(--gaxl-error-border);\n  --color-error-text: var(--gaxl-error-text);\n  --color-info-soft: var(--gaxl-info-soft);\n  --color-info-border: var(--gaxl-info-border);\n  --color-info-text: var(--gaxl-info-text);\n  --color-visit-supervisory: var(--gaxl-visit-supervisory);\n  --color-visit-start-of-care: var(--gaxl-visit-start-of-care);\n  --color-visit-routine: var(--gaxl-visit-routine);\n  --color-visit-pt-ot: var(--gaxl-visit-pt-ot);\n  --color-surface-faint: var(--gaxl-surface-faint);\n  --color-violet-pale-bg: var(--gaxl-violet-pale-bg);\n  --color-violet-200: var(--gaxl-violet-200);\n  --color-violet-600: var(--gaxl-violet-600);\n  --color-blue-tint: var(--gaxl-blue-tint);\n  --color-blue-pale: var(--gaxl-blue-pale);\n  --color-indigo-pale: var(--gaxl-indigo-pale);\n  --color-indigo-light: var(--gaxl-indigo-light);\n  --color-esa-panel: var(--gaxl-esa-panel);\n  --color-esa-accent: var(--gaxl-esa-accent);\n  --color-esa-accent-muted: var(--gaxl-esa-accent-muted);\n  --color-esa-hover: var(--gaxl-esa-hover);\n  --color-esa-gradient-from: var(--gaxl-esa-gradient-from);\n  --color-esa-gradient-to: var(--gaxl-esa-gradient-to);\n  --color-catalog-master: var(--gaxl-catalog-master);\n  --color-catalog-channel: var(--gaxl-catalog-channel);\n  --color-catalog-channel-dot: var(--gaxl-catalog-channel-dot);\n  --color-catalog-supplier: var(--gaxl-catalog-supplier);\n  --color-catalog-supplier-dot: var(--gaxl-catalog-supplier-dot);\n  --color-chip-scope-fg: var(--gaxl-chip-scope-fg);\n  --color-chip-scope-bg: var(--gaxl-chip-scope-bg);\n  --color-chip-scope-border: var(--gaxl-chip-scope-border);\n  --color-chip-objective-fg: var(--gaxl-chip-objective-fg);\n  --color-chip-objective-bg: var(--gaxl-chip-objective-bg);\n  --color-chip-objective-border: var(--gaxl-chip-objective-border);\n  --color-dq-high: var(--gaxl-dq-high);\n  --color-dq-mid: var(--gaxl-dq-mid);\n  --color-dq-low: var(--gaxl-dq-low);\n  --color-run-running: var(--gaxl-run-running);\n  --color-run-queued: var(--gaxl-run-queued);\n  --color-explorer-new: var(--gaxl-explorer-new);\n  --color-shell-bar: var(--gaxl-shell-bar);\n  --color-shell-bar-top: var(--gaxl-shell-bar-top);\n\n  /* Button/Badge consumer tokens */\n  --color-success-strong: var(--gaxl-success-strong);\n  --color-success-strong-hover: var(--gaxl-success-strong-hover);\n  --color-success-700: var(--gaxl-success-700);\n  --color-error-700: var(--gaxl-error-700);\n  --color-disabled-surface: var(--gaxl-disabled-surface);\n  --color-secondary-soft: var(--gaxl-secondary-soft);\n  --color-secondary-text: var(--gaxl-secondary-text);\n\n  /* Pagination component tokens */\n  --color-pg-btn-active-bg: var(--gaxl-pg-btn-active-bg);\n  --color-pg-btn-active-fg: var(--gaxl-pg-btn-active-fg);\n  --color-pg-btn-default-bg: var(--gaxl-pg-btn-default-bg);\n  --color-pg-btn-default-fg: var(--gaxl-pg-btn-default-fg);\n  --color-pg-btn-hover-bg: var(--gaxl-pg-btn-hover-bg);\n  --color-pg-btn-border: var(--gaxl-pg-btn-border);\n  --color-pg-btn-disabled-fg: var(--gaxl-pg-btn-disabled-fg);\n  --color-pg-label-fg: var(--gaxl-pg-label-fg);\n\n  /* Spacing — numeric scale */\n  --spacing-1: var(--gaxl-space-1);\n  --spacing-2: var(--gaxl-space-2);\n  --spacing-3: var(--gaxl-space-3);\n  --spacing-4: var(--gaxl-space-4);\n  --spacing-5: var(--gaxl-space-5);\n  --spacing-6: var(--gaxl-space-6);\n  --spacing-7: var(--gaxl-space-7);\n  --spacing-8: var(--gaxl-space-8);\n  --spacing-9: var(--gaxl-space-9);\n  --spacing-10: var(--gaxl-space-10);\n  --spacing-11: var(--gaxl-space-11);\n  --spacing-12: var(--gaxl-space-12);\n  --spacing-13: var(--gaxl-space-13);\n\n  /* Radius */\n  --radius-2: var(--gaxl-radius-2);\n  --radius-4: var(--gaxl-radius-4);\n  --radius-6: var(--gaxl-radius-6);\n  --radius-8: var(--gaxl-radius-8);\n  --radius-12: var(--gaxl-radius-12);\n  --radius-16: var(--gaxl-radius-16);\n  --radius-20: var(--gaxl-radius-20);\n  --radius-full: var(--gaxl-radius-full);\n  --radius-pg-btn: var(--gaxl-pg-btn-radius);\n\n  /* Border width */\n  --border-width-thin: 1px;\n\n  /* Shadows */\n  --shadow-xs: var(--gaxl-shadow-xs);\n  --shadow-sm: var(--gaxl-shadow-sm);\n  --shadow-md: var(--gaxl-shadow-md);\n  --shadow-lg: var(--gaxl-shadow-lg);\n  --shadow-xl: var(--gaxl-shadow-xl);\n  --shadow-overlay: var(--gaxl-shadow-overlay);\n\n  /* Font sizes */\n  --text-display-xl: var(--gaxl-size-display-xl);\n  --text-display-l: var(--gaxl-size-display-l);\n  --text-heading-xl: var(--gaxl-size-heading-xl);\n  --text-heading-l: var(--gaxl-size-heading-l);\n  --text-heading-m: var(--gaxl-size-heading-m);\n  --text-heading-s: var(--gaxl-size-heading-s);\n  --text-title: var(--gaxl-size-title);\n  --text-body-lg: var(--gaxl-size-body-lg);\n  --text-body-md: var(--gaxl-size-body-md);\n  --text-body-sm: var(--gaxl-size-body-sm);\n  --text-caption: var(--gaxl-size-caption);\n  --text-compact: var(--gaxl-size-compact);\n  --text-overline: var(--gaxl-size-overline);\n\n  /* Duration */\n  --transition-duration-instant: var(--gaxl-duration-instant);\n  --transition-duration-fast: var(--gaxl-duration-fast);\n  --transition-duration-base: var(--gaxl-duration-base);\n  --transition-duration-slow: var(--gaxl-duration-slow);\n  --transition-duration-slower: var(--gaxl-duration-slower);\n\n  /* Font family */\n  --font-sans: var(--gaxl-font-sans);\n  --font-mono: var(--gaxl-font-mono);\n\n  /* Font weight */\n  --font-weight-regular: var(--gaxl-weight-regular);\n  --font-weight-medium: var(--gaxl-weight-medium);\n  --font-weight-semibold: var(--gaxl-weight-semibold);\n  --font-weight-bold: var(--gaxl-weight-bold);\n\n  /* Icon / component dimensions */\n  --width-icon-md: 16px;\n  --height-icon-md: 16px;\n}\n\n/* Tailwind v4 workarounds for component utilities (ADR-0004) */\n@utility border-thin {\n  border-width: var(--border-width-thin);\n}\n\n@utility border-b-thin {\n  border-bottom-width: var(--border-width-thin);\n}\n\n@utility border-t-thin {\n  border-top-width: var(--border-width-thin);\n}\n\n@utility hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n","/* Import foundation tokens (CSS variables) */\n@import '@growthaxl/web-foundation/styles/llc';\n\n/* Import Tailwind with foundation theme extensions */\n@import 'tailwindcss';\n@import '@growthaxl/web-foundation/tailwind-theme';\n\n/* Host-specific theme extensions not yet in foundation bridge */\n@theme {\n  --text-label: var(--gaxl-size-label);\n  --font-size-label: var(--gaxl-size-label);\n  --font-size-subtitle: var(--gaxl-size-subtitle);\n  --color-scrim: var(--gaxl-scrim);\n  --color-border-hover: var(--gaxl-border-hover);\n}\n\n\n@source \"../node_modules/@growthaxl/web-foundation/dist\";\n\n/*\n * Safelist — classes used inside gaxl-web-foundation components that do not\n * appear in the host's own .tsx files. Tailwind v4 + webpack/postcss-loader\n * won't auto-watch foundation source files during hot-reload, so we force-\n * generate these utilities here via @source inline().\n */\n@source inline(\"bg-esa-hover bg-error-soft py-[11px] px-[7px] py-[2px] py-[1px] px-[5px] min-w-[18px] tracking-[0.5px] font-[800] text-text-muted bg-esa-panel bg-brand-secondary h-[6px] w-[6px] max-h-[260px] shadow-md z-50 hover:bg-esa-accent hover:text-brand-on-primary hover:border-esa-accent hover:bg-esa-hover hide-scrollbar bg-surface-muted text-body-md text-label text-caption text-overline tracking-overline min-w-28 size-8 grid grid-cols-3 gap-4 rounded-8 border-2 bg-surface-secondary bg-surface-card focus-within:border-border-focus focus-within:bg-brand-primary-soft min-h-[60vh] max-h-[85vh] py-13 hover:-translate-y-0.5 hover:shadow-[var(--gaxl-shadow-md)]\");\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n}\n\nhtml[data-theme='light'] {\n  color-scheme: light;\n}\n\nhtml[data-theme='dark'] {\n  color-scheme: dark;\n}\n\nbody {\n  font-family: var(--gaxl-font-sans, system-ui, sans-serif);\n  background: var(--gaxl-canvas);\n  color: var(--gaxl-text-primary);\n}\n\n/*\n * ESA chip hover overrides — intentionally kept OUTSIDE any @layer.\n *\n * Tailwind v4 places all utility rules in @layer utilities. When a canvas\n * remote is loaded (via Module Federation + style-loader), its stylesheet is\n * appended to <head> AFTER the host CSS. Within the same layer, later document\n * order wins, so canvas-generated utilities can shadow host hover classes.\n * Un-layered rules always beat @layer utilities rules in the CSS cascade, so\n * placing these critical hover styles here makes them immune to that ordering.\n */\n.esa-chip-transition {\n  transition:\n    background var(--gaxl-duration-fast) var(--gaxl-ease-standard),\n    color var(--gaxl-duration-fast) var(--gaxl-ease-standard),\n    border-color var(--gaxl-duration-fast) var(--gaxl-ease-standard);\n}\n\n.esa-chip-idle:not(:disabled):hover {\n  background: var(--gaxl-esa-suggestion-gradient);\n  color: var(--gaxl-brand-on-primary);\n  border-color: transparent;\n}\n\n.esa-chip-filled:not(:disabled):hover {\n  background-color: var(--color-esa-hover);\n}\n\n/*\n * Capability tabs & dropdown pointer cursor — un-layered so canvas MF CSS cannot shadow.\n */\n[role='tablist'] button:not(:disabled) {\n  cursor: pointer !important;\n}\n\nbutton[aria-haspopup='listbox']:not(:disabled),\nbutton[aria-haspopup='menu']:not(:disabled),\nbutton[aria-haspopup='dialog']:not(:disabled),\n[role='listbox'] button,\n[role='menu'] [role='menuitem'],\n[data-testid^='waffle-card-'] {\n  cursor: pointer !important;\n}\n\n.esa-suggestion-strip::before,\n.esa-suggestion-strip::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 28px;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity var(--gaxl-duration-fast) var(--gaxl-ease-standard);\n}\n\n.esa-suggestion-strip::before {\n  left: 0;\n  background: linear-gradient(to right, var(--gaxl-esa-panel), transparent);\n}\n\n.esa-suggestion-strip::after {\n  right: 0;\n  background: linear-gradient(to left, var(--gaxl-esa-panel), transparent);\n}\n\n.esa-suggestion-strip--fade-left::before,\n.esa-suggestion-strip--fade-right::after {\n  opacity: 1;\n}\n\n/* Shell chrome — fixed height; composed canvas bundles must not resize the host header */\n[data-testid='global-header'] {\n  box-sizing: border-box;\n  height: 48px !important;\n  min-height: 48px !important;\n  max-height: 48px !important;\n  flex-shrink: 0;\n  overflow: visible;\n  background-color: var(--gaxl-shell-bar-top);\n}\n\nhtml[data-theme='dark'] [data-testid='global-header'] {\n  background-color: var(--gaxl-surface-header);\n}\n\n/* ESA ↔ canvas separator — un-layered so canvas MF CSS cannot strip it on reload */\n.esa-panel-shell {\n  flex-shrink: 0;\n}\n\n.esa-canvas-divider-handle {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.esa-canvas-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 6px;\n  height: 100%;\n  min-height: 100%;\n  flex-shrink: 0;\n  background: var(--gaxl-splitter-idle);\n  border-right: 1px solid var(--gaxl-border-default);\n  box-sizing: border-box;\n}\n\n.esa-canvas-divider__grip {\n  display: block;\n  width: 2px;\n  height: var(--gaxl-space-6);\n  border-radius: var(--gaxl-radius-full);\n  background-color: var(--gaxl-splitter-grip);\n}\n\n/* ESA panel scrollbars — thinner than OS default; skip hide-scrollbar strips */\n[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar) {\n  scrollbar-width: thin;\n  scrollbar-color: var(--gaxl-zinc-300) transparent;\n}\n\n[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar-thumb {\n  background-color: var(--gaxl-zinc-300);\n  border-radius: var(--gaxl-radius-full);\n}\n\n[data-testid='esa-panel'] :is(.overflow-y-auto, .overflow-auto):not(.hide-scrollbar)::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/*\n * Custom success-action toast — strip react-toastify chrome so the card\n * (icon, title, action link, green accent) is the only visible surface.\n */\n.Toastify__toast.gaxl-success-action-toast {\n  background: transparent;\n  box-shadow: none;\n  padding: 0;\n  min-height: 0;\n  width: min(360px, calc(100vw - 24px));\n  margin-bottom: 12px;\n}\n\n.Toastify__toast.gaxl-success-action-toast .Toastify__toast-body,\n.gaxl-success-action-toast__body {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.Toastify__toast.gaxl-success-action-toast .Toastify__toast-icon {\n  display: none;\n}\n\n.Toastify__toast.gaxl-success-action-toast [data-testid='success-action-toast-link'],\n.Toastify__toast.gaxl-success-action-toast [data-testid='success-action-toast-link'] * {\n  cursor: pointer;\n}\n\n/* Keep react-toastify auto-close timer alive; hide the default progress chrome. */\n.Toastify__toast.gaxl-success-action-toast .Toastify__progress-bar--wrp {\n  opacity: 0;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
